export default {
"路由/首页":   `Pagina Principale`,
"路由/数据可视化":   `Visualizzazione dei Dati`,
"路由/电站监控":   `Monitoraggio della Stazione`,
"路由/运维分析":   `Operazioni e Manutenzione`,
"路由/生产管理":   `Produzione`,
"路由/数据分析":   `Analisi dei Dati`,
"路由/虚拟电厂":   `Centrale Virtuale`,
"路由/设备管理":   `Attrezzatura`,
"路由/配置管理":   `Configurazione`,
"路由/系统监控":   `Monitoraggio del Sistema`,
"路由/站级监控":   `Monitoraggio a Livello di Stazione`,
"路由/电站地图":   `Mappa della Stazione`,
"路由/生产概览":   `Panoramica della Produzione`,
"路由/告警管理":   `Gestione degli Allarmi`,
"路由/告警信息":   `Informazioni sugli Allarmi`,
"路由/抄表结算":   `Regolamento delle Letture`,
"路由/运行策略":   `Strategia Operativa`,
"路由/策略操作历史":   `Cronologia delle Operazioni Strategiche`,
"路由/每日电表同步":   `Sincronismo Giornaliero delle Letture`,
"路由/数据补录":   `Completamento dei Dati`,
"路由/参数设置":   `Impostazione dei Parametri`,
"路由/空调运行参数设定":   `Impostazioni dei Parametri del Condizionatore`,
"路由/故障录波":   `Registratore di Guasti`,
"路由/功率跟踪":   `Monitoraggio della Potenza`,
"路由/负荷跟踪":   `Monitoraggio del Carico`,
"路由/满充容量统计":   `Statistiche della Capacità`,
"路由/充电电量汇总":   `Riepilogo dell'Energia di Carica`,
"路由/充放电记录":   `Registratore di Carica e Scarica`,
"路由/需量分析":   `Analisi della Domanda`,
"路由/电压数据分析":   `Analisi dei Dati di Tensione`,
"路由/电压一致性":   `Coerenza della Tensione`,
"路由/温度热管理":   `Gestione Termica della Temperatura`,
"路由/储能分析":   `Analisi dell'Accumulo di Energia`,
"路由/电能质量治理":   `Controllo della Qualità dell'Energia`,
"路由/电价趋势":   `Tendenza delle Tariffe Energetiche`,
"路由/电表数据分析":   `Analisi dei Dati del Contatore`,
"路由/运营监控":   `Monitoraggio delle Operazioni`,
"路由/收益管理":   `Gestione dei Guadagni`,
"路由/企业信息":   `Informazioni Aziendali`,
"路由/接入管理":   `Gestione degli Accessi`,
"路由/数据日志":   `Registro Dati`,
"路由/委托管理":   `Gestione Delegati`,
"路由/基线管理":   `Gestione Baseline`,
"路由/申报管理":   `Gestione Rappresentanti`,
"路由/结算管理":   `Gestione Liquidazioni`,
"路由/电站单元":   `Unità Stazione`,
"路由/电表":   `Contatore`,
"路由/能量链":   `eLink`,
"路由/能量块":   `eBlock`,
"路由/设备型号":   `Modello Attrezzatura`,
"路由/电站管理":   `Stazione`,
"路由/设备升级":   `Aggiornamento`,
"路由/eLink查询":   `Ricerca eLink`,
"路由/API白名单设置":   `Impostazioni Lista Bianca API`,
"路由/在线用户":   `Utente Online`,
"路由/定时任务":   `Attività Programmata`,
"路由/标签管理":   `Etichetta`,
"路由/固件管理":   `Firmware`,
"路由/版本信息":   `Versione`,
"路由/时段电价":   `Prezzo Periodico`,
"路由/每日收益修改":   `Modifica Guadagno Giornaliero`,
"路由/系统复位":   `Ripristino Sistema`,
"路由/协控设置":   `Controllo Coordinamento`,
"路由/遥控设置":   `Telecomando`,
"路由/遥控设置历史":   `Registro Impostazioni Telecomando`,
"路由/实时数据":   `Dati in Tempo Reale`,
"路由/采集点表设置":   `Tabella Punti di Acquisizione`,
"路由/采集通道设置":   `Canale di Acquisizione`,
"路由/系统管理":   `Sistema`,
"路由/用户管理":   `Utente`,
"路由/角色管理":   `Ruolo`,
"路由/菜单管理":   `Menu`,
"路由/部门管理":   `Dipartimento`,
"路由/岗位管理":   `Posizione`,
"路由/字典管理":   `Dizionario`,
"路由/通知公告":   `Notifica`,
"路由/操作日志":   `Registro Operazioni`,
"路由/系统日志":   `Registro Sistema`,
"路由/个人中心":   `Centro Personale`,
"路由/告警管理（运维专用）":   `Gestione Allarmi (Operazione e Manutenzione)`,
'路由/经评分析': 'Analisi Performance',
'路由/电站评分总览': 'Panoramica Valutazione Stazione',
'路由/电站评价详情': 'Dettagli Valutazione Stazione',
'路由/电站实际运行数据': 'Dati Operativi Stazione',
'路由/运维日报': 'Report Giornaliero Operazioni',
'路由/空调详情': 'Dettagli Condizionatore',
'路由/光伏': 'Fotovoltaico',
'路由/设备模型': 'Modello Attrezzatura',
'路由/设备点表': 'Tabella Punti Attrezzatura',

"全局/奇点能源":   `JD Energy`,
"全局/重新登录提示":   `Lo stato di accesso è scaduto. Puoi rimanere su questa pagina o accedere di nuovo`,
"全局/会话过期提示":   `Sessione non valida o scaduta, accedi di nuovo`,
"全局/系统接口异常":  (s) => `Eccezione interfaccia di sistema ${s}`,
"全局/系统提示":   `Avviso di sistema`,
"全局/重新登录":   `Accedi di nuovo`,
"全局/选择电站":   `Seleziona stazione`,
"全局/400客服电话":   `Numero verde assistenza clienti 400`,
"全局/登录状态已过期，您可以继续留在该页面，或者重新登录":   `Lo stato di accesso è scaduto. Puoi continuare a rimanere su questa pagina o accedere di nuovo`,
"全局/无效的会话，或者会话已过期，请重新登录":   `Sessione non valida o scaduta, accedi di nuovo`,
"全局/数据正在处理，请勿重复提交":   `I dati sono in elaborazione, non inviare nuovamente`,
"全局/取消":   `Annulla`,
"全局/确定":   `Conferma`,
"全局/编辑":   `Modifica`,
"全局/删除":   `Elimina`,
"全局/保存":   `Salva`,
"全局/查询":   `Cerca`,
"全局/搜索":   `Ricerca`,
"全局/重置":   `Reimposta`,
"全局/选择":   `Seleziona`,
"全局/提交":   `Invia`,
"全局/修改":   `Modifica`,
"全局/设置":   `Impostazioni`,
"全局/设置成功":   `Impostazione riuscita`,
"全局/设置失败":   `Impostazione fallita`,
"全局/全选":   `Seleziona tutto`,
"全局/成功":   `Riuscito`,
"全局/失败":   `Fallito`,
"全局/日期":   `Data`,
"全局/新增":   `Nuovo`,
"全局/返回":   `Indietro`,
"全局/操作":   `Operazione`,
"全局/后端接口连接异常":   `Eccezione di connessione all'interfaccia backend`,
"全局/系统接口请求超时":   `Timeout richiesta interfaccia sistema`,
"全局/正在下载数据，请稍候":   `Download dati in corso, attendere`,
"全局/下载文件出现错误，请联系管理员！":   `Errore nel download del file, contatta l'amministratore!`,
"全局/账号":   `Account`,
"全局/密码":   `Password`,
"全局/验证码":   `Codice di verifica`,
"全局/记住密码":   `Ricorda password`,
"全局/登录":   `Accedi`,
"全局/登录中":   `Accesso`,
"全局/立即注册":   `Registrati Ora`,
"全局/请输入您的账号":   `Inserisci il Tuo Account`,
"全局/请输入您的密码":   `Inserisci la Tua Password`,
"全局/请输入验证码":   `Inserisci il Codice di Verifica`,
"全局/是否切换版本":   `Cambiare versione?`,
"全局/切换新版":   `Passa alla Nuova Versione`,
"全局/留在旧版":   `Rimani sulla Vecchia Versione`,
"全局/实体表":   `Contatore Fisico`,
"全局/虚拟表":   `Contatore Virtuale`,
"全局/能量链":   `eLink`,
"全局/能量块":   `eBlock`,
"首页/分布地图":   `Mappa`,
"首页/布局大小":   `Dimensione Layout`,
"首页/全屏":   `Schermo Intero`,
"首页/切换新版":   `Nuova Versione`,
"首页/个人中心":   `Centro Personale`,
"首页/布局设置":   `Impostazioni Layout`,
"首页/退出登录":   `Disconnetti`,
"首页/个人信息":   `Informazioni Personali`,
"首页/用户名称":   `Nome`,
"首页/手机号码":   `Numero di Telefono`,
"首页/用户邮箱":   `Email`,
"首页/所属部门":   `Dipartimento`,
"首页/所属角色":   `Ruolo`,
"首页/创建日期":   `Data di Creazione`,
"首页/基本资料":   `Informazioni Generali`,
"首页/用户昵称":   `Alias`,
"首页/性别":   `Genere`,
"首页/男":   `Maschio`,
"首页/女":   `Femmina`,
"首页/保存":   `Salva`,
"首页/关闭":   `Chiudi`,
"首页/LOGO设置":   `Impostazioni LOGO`,
"首页/主页LOGO":   `LOGO Home Page`,
"首页/数据可视化LOGO":   `LOGO Visualizzazione Dati`,
"首页/旧密码":   `Vecchia Password`,
"首页/新密码":   `Nuova Password`,
"首页/确认密码":   `Conferma Password`,
"首页/主题风格设置":   `Impostazioni Stile Tema`,
"首页/主题颜色":   `Colore Tema`,
"首页/系统布局配置":   `Configurazione Layout Sistema`,
"首页/开启":   `Apri`,
"首页/固定":   `Blocca`,
"首页/显示LOGO":   `Mostra LOGO`,
"首页/动态标题":   `Titolo Dinamico`,
"首页/保存配置":   `Salva`,
"首页/重置配置":   `Ripristina`,
"首页/清空":   `Sgombero`,
"首页/确定":   `Conferma`,
"首页/电站列表":   `Lista Stazioni`,
"首页/电站名称":   `Nome Stazione`,
"首页/装机容量":   `Capacità Installata`,
"首页/地址":   `Indirizzo`,
"首页/操作":   `Operazione`,
"首页/客服电话":   `Numero Verde Assistenza Clienti`,
"首页/加载更多":   `Carica Altro`,
"首页/查看":   `Visualizza`,
"首页/电站规模":   `Scala Stazione`,
"首页/安全运行天数":   `Giorni di Funzionamento Sicuro`,
"首页/累计装机容量":   `Capacità Installata Cumulativa`,
"首页/累计装机功率":   `Potenza Installata Cumulativa`,
"首页/电站个数":   `Numero di Stazioni`,
"首页/能量链数量":   `Numero di eLink`,
"首页/能量块数量":   `Numero di eBlock`,
"首页/收益分析":   `Analisi Guadagni`,
"首页/累计收益":   `Guadagni Cumulativi`,
"首页/万元":   `Mila Euro`,
"首页/月":   `Mese`,
"首页/所辖电站累计收益":   `Guadagni Cumulativi di Tutte le Stazioni`,
"首页/储能分析":   `Analisi Accumulo`,
"首页/充放电量":   `Energia di Carica e Scarica`,
"首页/累计总充电量":   `Carica Cumulativa`,
"首页/累计总放电量":   `Scarica Cumulativa`,
"首页/充电":   `Carica`,
"首页/放电":   `Scarica`,
"首页/个":   `Unità`,
"首页/修改密码":   `Modifica Password`,
"首页/请输入旧密码":   `Inserisci Vecchia Password`,
"首页/请输入新密码":   `Inserisci Nuova Password`,
"首页/请确认新密码":   `Conferma Nuova Password`,
"首页/两次输入的密码不一致":   `Le due password non coincidono`,
"首页/旧密码不能为空":   `La vecchia password non può essere vuota`,
"首页/新密码不能为空":   `La nuova password non può essere vuota`,
"首页/确认密码不能为空":   `Conferma password non può essere vuota`,
"首页/修改成功":   `Modifica riuscita`,
"首页/邮箱":   `Email`,
"首页/用户昵称不能为空":   `Il soprannome utente non può essere vuoto`,
"首页/邮箱地址不能为空":   `L'indirizzo email non può essere vuoto`,
"首页/请输入正确的邮箱地址":   `Inserisci un indirizzo email corretto`,
"首页/手机号码不能为空":   `Il numero di telefono non può essere vuoto`,
"首页/请输入正确的手机号码":   `Inserisci un numero di telefono corretto`,
"首页/修改头像":   `Modifica avatar`,
"首页/点击上传头像":   `Clicca per caricare l'avatar`,
"首页/选择":   `Seleziona`,
"首页/提交":   `Invia`,
"首页/修改主页LOGO":   `Modifica LOGO homepage`,
"首页/修改数据可视化LOGO":   `Modifica LOGO visualizzazione dati`,
"首页/文件格式错误，请上传图片类型,如：JPG，PNG后缀的文件。":   `Formato file errato, carica un'immagine con estensione come: JPG, PNG.`,
"站级监控/主监控":   `Monitoraggio principale`,
"站级监控/能量链":   `eLink`,
"站级监控/能量块":   `eBlock`,
"站级监控/电表":   `Contatore`,
"站级监控/光伏表":   `Contatore fotovoltaico`,
"站级监控/负荷跟踪":   `Monitoraggio carico`,
"站级监控/消防":   `Antincendio`,
"站级监控/空调":   `Condizionatore`,
"站级监控/统计信息":   `Informazioni statistiche`,
"站级监控/昨日收益":   `Guadagno di ieri`,
"站级监控/累计收益":   `Guadagno accumulato`,
"站级监控/今日充电":   `Energia di ricarica oggi`,
"站级监控/累计充电":   `Ricarica accumulata`,
"站级监控/今日放电":   `Energia di scarica oggi`,
"站级监控/累计放电":   `Scarica accumulata`,
"站级监控/实时功率":   `Potenza in tempo reale`,
"站级监控/电网电压":   `Tensione di rete`,
"站级监控/剩余电量":   `Energia residua della batteria`,
"站级监控/今日电站SOC-功率跟踪分析曲线":   `Curva di analisi SOC-Potenza giornaliera della stazione`,
"站级监控/功率":   `Potenza`,
"站级监控/电网功率":   `Potenza di rete`,
"站级监控/运行信息":   `Informazioni operative`,
"站级监控/装机容量":   `Capacità installata`,
"站级监控/投运时间":   `Tempo di messa in servizio`,
"站级监控/在线能量链":   `Collegamenti eOnline`,
"站级监控/在线能量块":   `Blocchi eOnline`,
"站级监控/采样时间":   `Tempo di Campionamento`,
"站级监控/总有功功率":   `Potenza Attiva Totale`,
"站级监控/总无功功率":   `Potenza Reattiva Totale`,
"站级监控/电池组最大可充电功率":   `Potenza Massima Ricaricabile del Pacco Batteria`,
"站级监控/电池组最大可放电功率":   `Potenza Massima Scaricabile del Pacco Batteria`,
"站级监控/电网A相总电流":   `Tensione Linea-Neutro Rete A`,
"站级监控/电网B相总电流":   `Tensione Linea-Neutro Rete B`,
"站级监控/电网C相总电流":   `Tensione Linea-Neutro Rete C`,
"站级监控/系统剩余可放电量":   `Energia Residua Scaricabile del Sistema`,
"站级监控/日总充电量":   `Energia Totale di Ricarica Giornaliera`,
"站级监控/日总放电量":   `Energia Totale di Scarica Giornaliera`,
"站级监控/总SOC":   `SOC Totale`,
"站级监控/系统CPU占用率":   `Utilizzo CPU del Sistema`,
"站级监控/系统内存占用率":   `Utilizzo Memoria del Sistema`,
"站级监控/文件系统占用率":   `Utilizzo File System`,
"站级监控/虚拟电厂控制参数":   `Parametri di Controllo della Centrale Virtuale`,
"站级监控/最大可充功率":   `Potenza Massima Ricaricabile`,
"站级监控/最大可放功率":   `Potenza Massima Scaricabile`,
"站级监控/第三方控制使能":   `Abilitazione Controllo Terze Parti`,
"站级监控/第三方控制功率值":   `Potenza di Controllo Terze Parti`,
"站级监控/状态":   `Stato`,
"站级监控/系统运行状态":   `Stato Operativo del Sistema`,
"站级监控/断路器状态":   `Stato dell'Interruttore`,
"站级监控/断开":   `Aperto`,
"站级监控/闭合":   `Chiuso`,
"站级监控/开关状态":   `Stato dell'Interruttore`,
"站级监控/开机":   `Acceso`,
"站级监控/设备型号":   `Modello dell'Apparecchiatura`,
"站级监控/工作状态":   `Stato di Lavoro`,
"站级监控/电池簇":   `Gruppo di Batterie`,
"站级监控/运行参数":   `Parametro Operativo`,
"站级监控/PCS运行状态":   `Stato Operativo del PCS`,
"站级监控/并网":   `Allacciamento alla Rete`,
"站级监控/PCS运行模式":   `Modalità Operativa del PCS`,
"站级监控/交流恒功率":   `Potenza AC Costante`,
"站级监控/变流器效率":   `Efficienza del Convertitore`,
"站级监控/对地绝缘阻抗":   `Impedenza di Isolamento a Terra`,
"站级监控/直流接触器状态":   `Stato del Contattore in Corrente Continua`,
"站级监控/交流接触器状态":   `Stato del Contattore in Corrente Alternata`,
"站级监控/有功功率":   `Potenza Attiva`,
"站级监控/无功功率":   `Potenza Reattiva`,
"站级监控/视在功率":   `Potenza Apparente`,
"站级监控/功率因素":   `Fattore di Potenza`,
"站级监控/环境温度":   `Temperatura Ambiente`,
"站级监控/机箱内温度":   `Temperatura Interna del Telaio`,
"站级监控/AB线电压":   `Tensione di Linea AB`,
"站级监控/BC线电压":   `Tensione di Linea BC`,
"站级监控/CA线电压":   `Tensione di Linea CA`,
"站级监控/A相电流":   `Tensione di Fase A`,
"站级监控/B相电流":   `Tensione di Fase B`,
"站级监控/C相电流":   `Tensione di Fase C`,
"站级监控/电网频率":   `Frequenza di Rete`,
"站级监控/直流信息":   `Informazioni sulla Corrente Continua`,
"站级监控/查看 eBlock 详情":   `Visualizza Dettagli eBlock`,
"站级监控/已停用":   `Disabilitato`,
"站级监控/默认标题":   `Titolo Predefinito`,
"站级监控/UUID复制成功":   `UUID Copiato con Successo`,
"站级监控/查看 PCS 运行参数":   `Visualizza Parametri Operativi del PCS`,
"站级监控/查看电池簇详情":   `Visualizza Dettagli del Cluster di Batterie`,
"站级监控/eLink有功功率":   `Potenza Attiva eLink`,
"站级监控/PCS直流侧功率":   `Potenza in Corrente Continua del PCS`,
"站级监控/PCS直流侧电压":   `Tensione lato CC del PCS`,
"站级监控/PCS直流侧电流":   `Corrente lato CC del PCS`,
"站级监控/电池荷电量百分比":   `Percentuale dello Stato di Carica`,
"站级监控/PCS功率因数":   `Fattore di Potenza del PCS`,
"站级监控/极佳":   `Eccellente`,
"站级监控/佳":   `Buono`,
"站级监控/优秀":   `Eccellente`,
"站级监控/良好":   `Buono`,
"站级监控/合格":   `Qualificato`,
"站级监控/建议更换":   `Si Consiglia la Sostituzione`,
"站级监控/停止运行":   `Arrestare il Funzionamento`,
"站级监控/考虑需量与箱变保护后的最大可充功率":   `Considerare la domanda e la massima potenza ricaricabile dopo la protezione del trasformatore a cassetta`,
"站级监控/考虑需量与箱变保护后的最大可放功率":   `Considerare la domanda e la massima potenza di scarica dopo la protezione del trasformatore a cassetta`,
"站级监控/电池总压":   `Tensione Totale della Batteria`,
"站级监控/电池电流":   `Corrente Totale della Batteria`,
"站级监控/直流功率":   `Potenza in Corrente Continua`,
"站级监控/时间":   `Durata`,
"站级监控/启动时间":   `Durata Iniziale`,
"站级监控/停机时间":   `Durata Finale`,
"站级监控/电压统计":   `Statistiche Tensione`,
"站级监控/最高单体电压":   `Tensione Cellula Massima`,
"站级监控/最高电压位置":   `Indice Tensione Cellula Massima`,
"站级监控/最低单体电压":   `Tensione Cellula Minima`,
"站级监控/最低电压位置":   `Indice Tensione Cellula Minima`,
"站级监控/最大压差":   `Differenza Tensione Massima`,
"站级监控/温度统计":   `Statistiche Temperatura`,
"站级监控/最高单体温度":   `Temperatura Cellula Massima`,
"站级监控/最高温度位置":   `Indice Temperatura Cellula Massima`,
"站级监控/最低单体温度":   `Temperatura Cellula Minima`,
"站级监控/最低温度位置":   `Indice Temperatura Cellula Minima`,
"站级监控/最大温差":   `Differenza Temperatura Massima`,
"站级监控/SOC统计":   `Statistiche SOC`,
"站级监控/最高单体SOC":   `SOC Cellula Massimo`,
"站级监控/最高SOC位置":   `Indice SOC Cellula Massimo`,
"站级监控/最低单体SOC":   `SOC Cellula Minimo`,
"站级监控/最低SOC位置":   `Indice SOC Cellula Minimo`,
"站级监控/最大SOC差":   `Differenza SOC Massima`,
"站级监控/序号":   `Indice`,
"站级监控/均衡":   `Bilanciamento`,
"站级监控/未均衡":   `Sbilanciamento`,
"站级监控/内阻统计":   `Statistiche Resistenza`,
"站级监控/最高单体内阻":   `Resistenza Cellula Massima`,
"站级监控/最高内阻位置":   `Indice Resistenza Cellula Massima`,
"站级监控/最低单体内阻":   `Resistenza Cellula Minima`,
"站级监控/最低内阻位置":   `Indice Resistenza Cellula Minima`,
"站级监控/最大内阻差":   `Differenza Resistenza Massima`,
"站级监控/单体电池电压实时曲线":   `Curva Tensione Cellula in Tempo Reale`,
"站级监控/单体电池温度实时曲线":   `Curva Temperatura Cellula in Tempo Reale`,
"站级监控/单体电池SOC实时曲线":   `Curva SOC Cellula in Tempo Reale`,
"站级监控/单体电池内阻实时曲线":   `Curva Resistenza Cellula in Tempo Reale`,
"站级监控/详情":   `Dettagli`,
"站级监控/遥测量":   `Telemetria`,
"站级监控/电池剩余电量":   `Energia Residua Batteria`,
"站级监控/最高电芯电压":   `Tensione Cellula Massima`,
"站级监控/最高电芯温度":   `Temperatura Cellula Massima`,
"站级监控/PCS交流侧有功功率":   `Potenza Attiva Alternata PCS`,
"站级监控/PCS功率因素":   `Fattore di Potenza PCS`,
"站级监控/直流电压":   `Tensione CC`,
"站级监控/空调状态":   `Stato del Condizionatore`,
"站级监控/允许最大充电功率":   `Potenza Massima di Ricarica Consentita`,
"站级监控/最低电芯电压":   `Tensione Minima della Cella`,
"站级监控/最低电芯温度":   `Temperatura Minima della Cella`,
"站级监控/PCS交流侧无功功率":   `Potenza Reattiva CA del PCS`,
"站级监控/直流电流":   `Corrente Continua`,
"站级监控/空调蒸发器温度":   `Temperatura dell'Evaporatore del Condizionatore`,
"站级监控/允许最大放电功率":   `Potenza Massima di Scarica Consentita`,
"站级监控/电芯最高压差":   `Differenza di Tensione Massima`,
"站级监控/电芯最高温差":   `Differenza di Temperatura Massima`,
"站级监控/PCS交流侧视在功率":   `Potenza Apparente CA del PCS`,
"站级监控/空调冷凝器温度":   `Temperatura del Condensatore del Condizionatore`,
"站级监控/并网点电表参数":   `Parametri del Contatore Allacciato alla Rete`,
"站级监控/A相无功功率":   `Potenza Reattiva Fase A`,
"站级监控/B相无功功率":   `Potenza Reattiva Fase B`,
"站级监控/C相无功功率":   `Potenza Reattiva Fase C`,
"站级监控/A相有功功率":   `Potenza Attiva Fase A`,
"站级监控/B相有功功率":   `Potenza Attiva Fase B`,
"站级监控/C相有功功率":   `Potenza Attiva Fase C`,
"站级监控/A相功率因数":   `Fattore di Potenza Fase A`,
"站级监控/B相功率因数":   `Fattore di Potenza Fase B`,
"站级监控/C相功率因数":   `Fattore di Potenza Fase C`,
"站级监控/总功率因数":   `Fattore di Potenza Totale`,
"站级监控/频率":   `Frequenza`,
"站级监控/正向有功电能":   `Energia Attiva Positiva`,
"站级监控/反向有功电能":   `Energia Attiva Negativa`,
"站级监控/暂无数据":   `Nessun Dato`,
"站级监控/并网点功率":   `Potenza del Contatore Allacciato alla Rete`,
"站级监控/关口表功率":   `Potenza del Contatore PCC`,
"站级监控/负载功率":   `Potenza del Carico`,
"站级监控/方阵消防预警级别":   `Livello di Allarme Antincendio Matrix`,
"站级监控/消防主机CO浓度":   `Concentrazione di CO del Computer Antincendio`,
"站级监控/消防主机在线状态":   `Stato Online del Computer Antincendio`,
"站级监控/消防主机H2浓度":   `Concentrazione di H2 del Computer Antincendio`,
"站级监控/主机喷洒状态":   `Stato dell'Irrigatore Principale`,
"站级监控/消防主机风机状态":   `Stato della Turbina Eolica del Computer Antincendio`,
"站级监控/消防主机通信协议版本号":   `Versione del Protocollo di Comunicazione del Computer Antincendio`,
"站级监控/消防主机手动报警":   `Allarme Manuale del Computer Antincendio`,
"站级监控/消防主机程序版本号":   `Versione del Computer Antincendio`,
"站级监控/消防主机手动急停":   `Manuale Antincendio Computer Arresto di Emergenza`,
"站级监控/消防主机温感状态":   `Stato Sensore Temperatura Computer Antincendio`,
"站级监控/柜体消防预警级别":   `Livello Allarme Antincendio Armadio`,
"站级监控/柜体温度":   `temperatura_armadio`,
"站级监控/柜体湿度":   `Umidità Armadio`,
"站级监控/CO浓度":   `Concentrazione CO`,
"站级监控/烟雾浓度":   `Concentrazione Fumo`,
"站级监控/CO状态":   `Stato CO`,
"站级监控/VOC状态":   `Stato VOC`,
"站级监控/柜内主机喷洒状态":   `Stato Principale Spruzzo Interno Telaio`,
"站级监控/消防中继手动报警":   `Allarme Manuale Relè Antincendio`,
"站级监控/消防中继手动急停":   `Arresto Emergenza Manuale Relè Antincendio`,
"站级监控/消防中继程序版本号":   `Versione Relè Antincendio`,
"站级监控/消防中继H2浓度":   `Concentrazione H2 Relè Antincendio`,
"站级监控/冷却方式":   `Tipo Raffreddamento`,
"站级监控/风冷":   `Raffreddamento ad Aria`,
"站级监控/eLink型号":   `Modello eLink`,
"站级监控/eLink控制柜":   `Armadio di Controllo eLink`,
"站级监控/返回":   `Ritorno`,
"站级监控/告警历史":   `Cronologia Allarmi`,
"站级监控/告警时间":   `Ora Allarme`,
"站级监控/故障名称":   `Nome Guasto`,
"站级监控/查询":   `Cerca`,
"站级监控/空调编号":   `Indice Condizionatore`,
"站级监控/告警开始时间":   `Ora Inizio Allarme`,
"站级监控/告警结束时间":   `Ora Fine Allarme`,
"站级监控/故障key":   `Chiave Guasto`,
"站级监控/故障名称模糊搜索":   `Ricerca Approfondita Nome Guasto`,
"站级监控/年":   `Anno`,
"站级监控/月":   `Gennaio, Febbraio, Marzo, Aprile, Maggio, Giugno, Luglio, Agosto, Settembre, Ottobre, Novembre, Dicembre`,
"站级监控/PCS运行参数":   `Parametri Operativi PCS`,
"站级监控/遥测":   `Telemetria`,
"站级监控/遥信":   `Telecomando`,
"站级监控/电网A相电压":   `Tensione Fase A Rete`,
"站级监控/电网B相电压":   `Tensione Fase B Rete`,
"站级监控/电网C相电压":   `Tensione Fase C Rete`,
"站级监控/逆变A相电流":   `Corrente Fase A Inverter`,
"站级监控/逆变B相电流":   `Corrente Fase B Inverter`,
"站级监控/逆变C相电流":   `Corrente Fase C Inverter`,
"站级监控/逆变有功功率":   `Potenza Attiva Inverter`,
"站级监控/逆变无功功率":   `Potenza reattiva dell'inverter`,
"站级监控/逆变视在功率":   `Potenza apparente dell'inverter`,
"站级监控/功率因数":   `Fattore di potenza`,
"站级监控/总母线电压":   `Tensione del bus principale`,
"站级监控/正半母线电压":   `Tensione del semi-bus positivo`,
"站级监控/负半母线电压":   `Tensione del semi-bus negativo`,
"站级监控/总电网有功功率":   `Potenza attiva della rete principale`,
"站级监控/总电网无功功率":   `Potenza reattiva della rete principale`,
"站级监控/重要负载有功功率":   `Potenza attiva del carico primario`,
"站级监控/重要负载无功功率":   `Potenza reattiva del carico primario`,
"站级监控/电池电压":   `Tensione della batteria`,
"站级监控/DCDC低压侧电压":   `Tensione lato bassa tensione DCDC`,
"站级监控/DCDC总电流":   `Corrente totale DCDC`,
"站级监控/DCDC总功率":   `Potenza totale DCDC`,
"站级监控/DCDC功率给定值":   `Potenza impostata DCDC`,
"站级监控/PV1电压":   `Tensione fotovoltaico 1`,
"站级监控/PV2电压":   `Tensione fotovoltaico 2`,
"站级监控/PV3电压":   `Tensione fotovoltaico 3`,
"站级监控/PV4电压":   `Tensione fotovoltaico 4`,
"站级监控/PV1功率":   `Potenza fotovoltaico 1`,
"站级监控/PV2功率":   `Potenza fotovoltaico 2`,
"站级监控/PV3功率":   `Potenza fotovoltaico 3`,
"站级监控/PV4功率":   `Potenza fotovoltaico 4`,
"站级监控/PV总功率":   `Potenza totale fotovoltaico`,
"站级监控/PV功率给定值":   `Potenza impostata fotovoltaico`,
"站级监控/逆变A相电压":   `Tensione fase A dell'inverter`,
"站级监控/逆变B相电压":   `Tensione fase B dell'inverter`,
"站级监控/逆变C相电压":   `Tensione fase C dell'inverter`,
"站级监控/A相电流直流分量":   `Componente continua corrente fase A`,
"站级监控/B相电流直流分量":   `Componente continua corrente fase B`,
"站级监控/C相电流直流分量":   `Componente continua corrente fase C`,
"站级监控/A相电压直流分量":   `Componente continua tensione fase A`,
"站级监控/B相电压直流分量":   `Componente continua tensione fase B`,
"站级监控/C相电压直流分量":   `Componente continua tensione fase C`,
"站级监控/负载A相电压":   `Tensione fase A del carico`,
"站级监控/负载B相电压":   `Tensione fase B del carico`,
"站级监控/负载C相电压":   `Tensione fase C del carico`,
"站级监控/负载A相电流":   `Corrente fase A del carico`,
"站级监控/负载B相电流":   `Corrente fase B del carico`,
"站级监控/负载C相电流":   `Corrente fase C del carico`,
"站级监控/DCDC电感1电流":   `Corrente Induttanza DCDC 1`,
"站级监控/DCDC电感2电流":   `Corrente Induttanza DCDC 2`,
"站级监控/DCDC电感3电流":   `Corrente Induttanza DCDC 3`,
"站级监控/DCDC电感4电流":   `Corrente Induttanza DCDC 4`,
"站级监控/PV1电流":   `Corrente Fotovoltaico 1`,
"站级监控/PV2电流":   `Corrente Fotovoltaico 2`,
"站级监控/PV3电流":   `Corrente Fotovoltaico 3`,
"站级监控/PV4电流":   `Corrente Fotovoltaico 4`,
"站级监控/DSP温度":   `Temperatura DSP`,
"站级监控/DCDCISO电阻1":   `Resistenza ISO DCDC 1`,
"站级监控/DCDCISO电阻2":   `Resistenza ISO DCDC 2`,
"站级监控/母线ISO电阻1":   `Resistenza ISO Bus 1`,
"站级监控/母线ISO电阻2":   `Resistenza ISO Bus 2`,
"站级监控/漏电流":   `Corrente di Fuga`,
"站级监控/DCDC充电功率限值":   `Soglia Potenza Carica DCDC`,
"站级监控/DCDC放电功率限值":   `Soglia Potenza Scarica DCDC`,
"站级监控/电池ISO电压":   `Tensione ISO Batteria`,
"站级监控/CPU1中断执行时间":   `Durata Interrupt CPU1`,
"站级监控/CPU2中断执行时间":   `Durata Interrupt CPU2`,
"站级监控/放电功率累加值":   `Potenza Scarica Accumulata`,
"站级监控/充电功率累加值":   `Potenza Carica Accumulata`,
"站级监控/通讯协议版本":   `Versione Protocollo Comunicazione`,
"站级监控/FPGA软件版本":   `Versione Software FPGA`,
"站级监控/CPU1软件版本":   `Versione Software CPU1`,
"站级监控/CPU2软件版本":   `Versione Software CPU2`,
"站级监控/Boot1软件版本":   `Versione Software Boot1`,
"站级监控/Boot2软件版本":   `Versione Software Boot2`,
"站级监控/软件ID号-APP":   `ID Software-APP`,
"站级监控/软件ID号-FPGA":   `ID Software-FPGA`,
"站级监控/主机状态":   `Stato PCS`,
"站级监控/运行模式":   `Modalità Operativa`,
"站级监控/并网自检":   `Autocontrollo Connesso alla Rete`,
"站级监控/离网自检":   `Autocontrollo Isolato dalla Rete`,
"站级监控/并网运行":   `Funzionamento Connesso alla Rete`,
"站级监控/离网运行":   `Funzionamento Isolato dalla Rete`,
"站级监控/并离网一体运行":   `Funzionamento On/Off Grid`,
"站级监控/主-AC指令标志":   `Marca Comando Master-AC`,
"站级监控/主-PV指令标志":   `Marca Comando Master-PV`,
"站级监控/主-DCDC指令标志":   `Marca Comando Master-DCDC`,
"站级监控/AC状态机":   `Macchina a Stati AC`,
"站级监控/AC-2-Main状态反馈":   `Risposta dello Stato Principale AC-2`,
"站级监控/网侧继电器自检":   `Autocontrollo del Relè di Rete`,
"站级监控/不控整流自检":   `Autocontrollo della Rettifica Non Controllata`,
"站级监控/母线绝缘阻抗检测":   `Controllo dell'Impedenza di Isolamento del Bus`,
"站级监控/漏电流自检":   `Autocontrollo della Perdita di Corrente`,
"站级监控/平衡桥自检":   `Autocontrollo del Ponte di Bilanciamento`,
"站级监控/逆变电压振幅相位检测":   `Controllo di Ampiezza e Fase della Tensione dell'Inverter`,
"站级监控/电感电流采样检测":   `Controllo del Campionamento della Corrente di Induttanza`,
"站级监控/逆变继电器检测":   `Controllo del Relè dell'Inverter`,
"站级监控/状态机工作状态":   `Stato Operativo della Macchina a Stati`,
"站级监控/状态返回值":   `Ritorno di Stato`,
"站级监控/环路状态":   `Stato del Circuito`,
"站级监控/ISO自检完成标志":   `Marcatura di Fine Autocontrollo ISO`,
"站级监控/直流接触器件反馈状态":   `Stato di Risposta del Contattore in Corrente Continua`,
"站级监控/温度降额状态":   `Stato di Derating per Temperatura`,
"站级监控/DC/DC状态（PV1）":   `Stato DCDC (PV1)`,
"站级监控/DC/DC模式（PV1）":   `Modalità DCDC (PV1)`,
"站级监控/MPPT模式（PV1）":   `Modalità MPPT (PV1)`,
"站级监控/MPPT状态（PV1）":   `Stato MPPT (PV1)`,
"站级监控/电压范围（PV1）":   `Intervallo di Tensione (PV1)`,
"站级监控/DC/DC状态（PV2）":   `Stato DCDC (PV2)`,
"站级监控/DC/DC模式（PV2）":   `Modalità DCDC (PV2)`,
"站级监控/MPPT模式（PV2）":   `Modalità MPPT (PV2)`,
"站级监控/MPPT状态（PV2）":   `Stato MPPT (PV2)`,
"站级监控/电压范围（PV2）":   `Intervallo di Tensione (PV2)`,
"站级监控/DC/DC状态（PV3）":   `Stato DCDC (PV3)`,
"站级监控/DC/DC模式（PV3）":   `Modalità DCDC (PV3)`,
"站级监控/MPPT模式（PV3）":   `Modalità MPPT (PV3)`,
"站级监控/MPPT状态（PV3）":   `Stato MPPT (PV3)`,
"站级监控/电压范围（PV3）":   `Intervallo di Tensione (PV3)`,
"站级监控/DC/DC状态（PV4）":   `Stato DCDC (PV4)`,
"站级监控/DC/DC模式（PV4）":   `Modalità DCDC (PV4)`,
"站级监控/MPPT模式（PV4）":   `Modalità MPPT (PV4)`,
"站级监控/MPPT状态（PV4）":   `Stato MPPT (PV4)`,
"站级监控/电压范围（PV4）":   `Intervallo di Tensione (PV4)`,
"站级监控/PV状态机":   `Macchina a Stati Fotovoltaici`,
"站级监控/PV状态反馈":   `Risposta dello Stato Fotovoltaico`,
"站级监控/PV并联模式":   `Modalità Parallela Fotovoltaica`,
"站级监控/恒流模式标志":   `Marcatura della Modalità a Corrente Costante`,
"站级监控/PCS运行LED":   `LED di Funzionamento PCS`,
"站级监控/电池侧接触器控制":   `Controllo Contattore Batteria`,
"站级监控/扰流风扇控制":   `Controllo Ventilatore Flusso Turbolento`,
"站级监控/电池侧绝缘阻抗继电器控制1":   `Controllo Relè Impedenza Isolamento Batteria 1`,
"站级监控/电池侧绝缘阻抗继电器控制2":   `Controllo Relè Impedenza Isolamento Batteria 2`,
"站级监控/PV侧绝缘阻抗继电器控制1":   `Controllo Relè Impedenza Isolamento Fotovoltaico 1`,
"站级监控/PV侧绝缘阻抗继电器控制2":   `Controllo Relè Impedenza Isolamento Fotovoltaico 2`,
"站级监控/继电器驱动芯片使能信号":   `Segnale Abilitazione Chip Driver Relè`,
"站级监控/接地继电器控制":   `Controllo Relè di Terra`,
"站级监控/离网继电器控制":   `Controllo Relè Off-Grid`,
"站级监控/N线继电器控制1":   `Controllo Relè Linea N 1`,
"站级监控/N线继电器控制2":   `Controllo Relè Linea N 2`,
"站级监控/电网侧软启继电器控制":   `Controllo Relè Soft Start Rete`,
"站级监控/电网侧继电器控制信号1":   `Segnale Controllo Relè Rete 1`,
"站级监控/电网侧继电器控制信号2":   `Segnale Controllo Relè Rete 2`,
"站级监控/漏电流自检控制":   `Controllo Autoverifica Perdite Corrente`,
"站级监控/继电器控制切换信号":   `Segnale Commutazione Controllo Relè`,
"站级监控/逆变继电器控制信号":   `Segnale Controllo Relè Inverter`,
"站级监控/系统运行总故障":   `Guasto Totale Funzionamento Sistema`,
"站级监控/电网总故障":   `Guasto Totale Rete`,
"站级监控/逆变器总故障":   `Guasto Totale Inverter`,
"站级监控/PV运行总故障":   `Guasto Totale Funzionamento Fotovoltaico`,
"站级监控/DCDC运行总故障":   `Guasto Totale Funzionamento DCDC`,
"站级监控/电网开机故障":   `Guasto Accensione Rete`,
"站级监控/PV开机故障":   `Guasto Accensione Fotovoltaico`,
"站级监控/远程关机故障":   `Guasto Spegnimento Remoto`,
"站级监控/母线硬件过压故障":   `Guasto Hardware Sovratensione Bus`,
"站级监控/母线过压":   `Sovratensione Bus`,
"站级监控/母线欠压":   `Sottotensione Bus`,
"站级监控/母线二级过压":   `Sovratensione Bus Livello 2`,
"站级监控/母线二级欠压":   `Sottotensione Bus Livello 2`,
"站级监控/正母线硬件过压故障":   `Guasto Hardware Sovratensione Bus Positivo`,
"站级监控/负母线硬件过压故障":   `Guasto Hardware Sovratensione Bus Negativo`,
"站级监控/上位机通信故障":   `Guasto Comunicazione Software Monitoraggio`,
"站级监控/系统锁定故障":   `Guasto Blocco Sistema`,
"站级监控/母线软起失败故障":   `Guasto Fallimento Soft Start Bus`,
"站级监控/电池相关故障":   `Guasto Correlato Batteria`,
"站级监控/E2ROM故障":   `Guasto E2ROM`,
"站级监控/FRAM故障":   `Guasto FRAM`,
"站级监控/逆变电流零漂故障":   `Guasto Deriva Zero Corrente Inverter`,
"站级监控/DCDC电流零漂故障":   `Guasto Deriva Zero Corrente DCDC`,
"站级监控/PV电流零漂故障":   `Guasto deriva zero corrente PV`,
"站级监控/CPU3心跳故障":   `Guasto battimento CPU3`,
"站级监控/母线不平衡故障":   `Guasto sbilanciamento bus`,
"站级监控/风机1故障":   `Guasto turbina eolica 1`,
"站级监控/风机2故障":   `Guasto turbina eolica 2`,
"站级监控/风机3故障":   `Guasto turbina eolica 3`,
"站级监控/半母线短路故障":   `Guasto cortocircuito semi-bus`,
"站级监控/母线短路故障":   `Guasto cortocircuito bus`,
"站级监控/FPGA与CPU1通信故障":   `Guasto comunicazione FPGA e CPU1`,
"站级监控/FPGA与CPU2通信故障":   `Guasto comunicazione FPGA e CPU2`,
"站级监控/AFCI模块自检故障":   `Guasto autotest modulo AFCI`,
"站级监控/AFCI模块通信故障":   `Guasto comunicazione AFCI`,
"站级监控/通道1直流拉弧故障":   `Guasto arco continuo canale 1`,
"站级监控/通道2直流拉弧故障":   `Guasto arco continuo canale 2`,
"站级监控/通道3直流拉弧故障":   `Guasto arco continuo canale 3`,
"站级监控/通道4直流拉弧故障":   `Guasto arco continuo canale 4`,
"站级监控/漏电流故障":   `Guasto dispersione corrente`,
"站级监控/电网过压":   `Sovratensione rete`,
"站级监控/电网欠压":   `Sottotensione rete`,
"站级监控/电网过频":   `Sovrafrequenza rete`,
"站级监控/电网欠频":   `Sottofrequenza rete`,
"站级监控/电网二级过压":   `Sovratensione rete livello 2`,
"站级监控/电网二级欠压":   `Sottotensione rete livello 2`,
"站级监控/电网二级过频":   `Sovrafrequenza rete livello 2`,
"站级监控/电网二级欠频":   `Sottofrequenza rete livello 2`,
"站级监控/电网谐振故障":   `Guasto risonanza rete`,
"站级监控/电网电压穿越故障":   `Guasto attraversamento tensione rete`,
"站级监控/电网相序故障":   `Guasto sequenza fasi rete`,
"站级监控/电网电压开机故障":   `Guasto accensione tensione rete`,
"站级监控/电网对地短路故障":   `Guasto cortocircuito a terra rete`,
"站级监控/电网锁定故障":   `Guasto blocco rete`,
"站级监控/A相电感电流逐波限流":   `Limite corrente induttanza fase A per onde`,
"站级监控/B相电感电流逐波限流":   `Limite corrente induttanza fase B per onde`,
"站级监控/C相电感电流逐波限流":   `Limite corrente induttanza fase C per onde`,
"站级监控/A相电感电流过流":   `Sovracorrente induttanza fase A`,
"站级监控/B相电感电流过流":   `Sovracorrente induttanza fase B`,
"站级监控/C相电感电流过流":   `Sovracorrente induttanza fase C`,
"站级监控/并网110%过载":   `Sovraccarico 110% connesso alla rete`,
"站级监控/并网120%过载":   `Sovraccarico 120% connesso alla rete`,
"站级监控/离网110%过载":   `Sovraccarico 110% isola`,
"站级监控/离网120%过载":   `Sovraccarico Off-Grid 120%`,
"站级监控/孤岛保护":   `Protezione Isola Isolata`,
"站级监控/接地故障":   `Guasto a Terra`,
"站级监控/并网输出电流直流分量过大":   `Componente CC Corrente Uscita Grid Extra Large`,
"站级监控/离网输出电压直流分量过大":   `Componente CC Corrente Uscita Off-Grid Extra Large`,
"站级监控/逆变器故障锁定":   `Blocco Guasto Inverter`,
"站级监控/继电器自检故障":   `Guasto Autoverifica Relè`,
"站级监控/不控整流故障":   `Guasto Rettifica Non Controllata`,
"站级监控/母线绝缘检测故障":   `Guasto Verifica Isolamento Bus`,
"站级监控/逆变电压幅值相序故障":   `Guasto Ordine Ampiezza Tensione Inverter`,
"站级监控/电感电流检测异常":   `Anomalia Verifica Corrente Induttanza`,
"站级监控/平衡桥逐波限流故障":   `Limite Corrente Ponte Bilanciamento per Onde`,
"站级监控/平衡桥硬件过流故障":   `Guasto Sovracorrente Hardware Ponte Bilanciamento`,
"站级监控/半母线电压不平衡":   `Squilibrio Tensione Semi-Bus`,
"站级监控/逆变继电器自检故障":   `Guasto Autoverifica Relè Inverter`,
"站级监控/平衡桥自检故障":   `Guasto Autoverifica Ponte Bilanciamento`,
"站级监控/漏电流自检故障":   `Guasto Autoverifica Perdita Corrente`,
"站级监控/离网接地继电器故障":   `Guasto Relè Terra Off-Grid`,
"站级监控/逆变继电器运行断开故障":   `Guasto Interruzione Operazione Relè Inverter`,
"站级监控/PV1硬件过流":   `Sovracorrente Hardware PV1`,
"站级监控/PV1反接":   `Inversione PV1`,
"站级监控/PV1欠压":   `Sottotensione PV1`,
"站级监控/PV1过压":   `Sovratensione PV1`,
"站级监控/PV1启机失败":   `Accensione PV1 Fallita`,
"站级监控/PV2硬件过流":   `Sovracorrente Hardware PV2`,
"站级监控/PV2反接":   `Inversione PV2`,
"站级监控/PV2欠压":   `Sottotensione PV2`,
"站级监控/PV2过压":   `Sovratensione PV2`,
"站级监控/PV2启机失败":   `Accensione PV2 Fallita`,
"站级监控/PV3硬件过流":   `Sovracorrente Hardware PV3`,
"站级监控/PV3反接":   `Inversione PV3`,
"站级监控/PV3欠压":   `Sottotensione PV3`,
"站级监控/PV3过压":   `Sovratensione PV3`,
"站级监控/PV3启机失败":   `Accensione PV3 Fallita`,
"站级监控/PV4硬件过流":   `Sovracorrente Hardware PV4`,
"站级监控/PV4反接":   `Inversione PV4`,
"站级监控/PV4欠压":   `Sottotensione PV4`,
"站级监控/PV4过压":   `Sovratensione PV4`,
"站级监控/PV4启机失败":   `Accensione PV4 Fallita`,
"站级监控/PV散热器过温":   `Sovratemperatura Radiatore PV`,
"站级监控/PV绝缘阻抗异常":   `Isolamento PV Anomalia Impedenza`,
"站级监控/PV温度采样异常":   `Campionamento Temperatura PV Anomalia`,
"站级监控/PV总故障":   `Guasto Totale PV`,
"站级监控/故障锁存":   `Blocco Guasto`,
"站级监控/并联模式启机条件":   `Condizione Accensione Modalità Parallelo`,
"站级监控/低压侧一级过流":   `Sovracorrente Livello 1 Lato Bassa Tensione`,
"站级监控/低压侧二级过流":   `Sovracorrente Livello 2 Lato Bassa Tensione`,
"站级监控/低压侧一级过压":   `Sovratensione Livello 1 Lato Bassa Tensione`,
"站级监控/低压侧二级过压":   `Sovratensione Livello 2 Lato Bassa Tensione`,
"站级监控/低压侧一级欠压":   `Sottotensione Livello 1 Lato Bassa Tensione`,
"站级监控/低压侧二级欠压":   `Sottotensione Livello 2 Lato Bassa Tensione`,
"站级监控/一级离网过载":   `Sovraccarico Livello 1 Fuori Rete`,
"站级监控/二级离网过载":   `Sovraccarico Livello 2 Fuori Rete`,
"站级监控/环境过温":   `Temperatura Ambiente Troppo Alta`,
"站级监控/环境欠温":   `Temperatura Ambiente Troppo Bassa`,
"站级监控/继电器故障":   `Guasto Relè`,
"站级监控/绝缘阻抗自检故障":   `Guasto Autocontrollo Impedenza Isolamento`,
"站级监控/DCDC锁定故障":   `Guasto Blocco DCDC`,
"站级监控/电池电压过低":   `Tensione Batteria Molto Bassa`,
"站级监控/电池电压过高":   `Tensione Batteria Molto Alta`,
"站级监控/低压侧硬件过流故障1":   `Guasto Sovracorrente Hardware 1 Lato Bassa Tensione`,
"站级监控/低压侧硬件过流故障2":   `Guasto Sovracorrente Hardware 2 Lato Bassa Tensione`,
"站级监控/低压侧硬件过流故障3":   `Guasto Sovracorrente Hardware 3 Lato Bassa Tensione`,
"站级监控/低压侧硬件过流故障4":   `Guasto Sovracorrente Hardware 4 Lato Bassa Tensione`,
"站级监控/低压侧总硬件过流故障":   `Sovracorrente Hardware Totale Lato Bassa Tensione`,
"站级监控/电池电流互校故障":   `Guasto Calibrazione Mutua Corrente Batteria`,
"站级监控/实时故障信息1":   `Informazione Guasto Tempo Reale 1`,
"站级监控/实时故障信息2":   `Informazione Guasto Tempo Reale 2`,
"站级监控/实时故障信息3":   `Informazione Guasto Tempo Reale 3`,
"站级监控/实时故障信息4":   `Informazione Guasto Tempo Reale 4`,
"站级监控/实时故障信息5":   `Informazione Guasto Tempo Reale 5`,
"站级监控/实时故障信息6":   `Informazione Guasto Tempo Reale 6`,
"站级监控/实时故障信息7":   `Informazione Guasto Tempo Reale 7`,
"站级监控/实时故障信息8":   `Informazione Guasto Tempo Reale 8`,
"站级监控/系统锁定故障原因":   `Motivo Guasto Blocco Sistema`,
"站级监控/电网锁定故障原因":   `Motivo Guasto Blocco Rete`,
"站级监控/逆变器锁定故障原因":   `Motivo Guasto Blocco Inverter`,
"站级监控/PV锁定故障原因":   `Motivo Guasto Blocco PV`,
"站级监控/DCDC锁定故障原因":   `Motivo Guasto Blocco DCDC`,
"站级监控/系统关机故障":   `Guasto Spegnimento Sistema`,
"站级监控/交流侧电网关机故障":   `Guasto Spegnimento Rete AC`,
"站级监控/交流侧逆变关机故障":   `Guasto Spegnimento Inverter AC`,
"站级监控/PV测关机故障":   `Guasto Spegnimento PV`,
"站级监控/DCDC测关机故障":   `Guasto Spegnimento DCDC`,
"站级监控/BMS软件版本":   `Versione Software BMS`,
"站级监控/eBlock运行模式":   `Modalità Operativa eBlock`,
"站级监控/SOP控制模式":   `Modalità Controllo SOP`,
"站级监控/SOE充电上限":   `Limite Superiore Carica SOE`,
"站级监控/SOE放电下限":   `Limite Inferiore Scarica SOE`,
"站级监控/eBlock工作状态":   `Stato Operativo eBlock`,
"站级监控/上次工作状态":   `Ultimo Stato Operativo`,
"站级监控/SOH":   `SOH`,
"站级监控/上次充电SOC":   `Ultimo SOC di Carica`,
"站级监控/上次放电SOC":   `Ultimo SOC di Scarica`,
"站级监控/当前额定安时":   `Ah Nominali Correnti`,
"站级监控/当前额定电量":   `Energia Nominale Corrente`,
"站级监控/电池真实SOC":   `SOC Effettivo Batteria`,
"站级监控/电池显示SOC":   `SOC Indicato Batteria`,
"站级监控/电池显示剩余安时":   `Ah Residui Indicati Batteria`,
"站级监控/电池真实SOE":   `SOE Effettivo Batteria`,
"站级监控/电池显示SOE":   `SOE Indicato Batteria`,
"站级监控/电池显示剩余电量":   `Energia Residua Indicata Batteria`,
"站级监控/电池累计充电量":   `Energia di Carica Accumulata Batteria`,
"站级监控/电池累计放电量":   `Energia di Scarica Accumulata Batteria`,
"站级监控/电池最后一次充电Ah数":   `Ultimi Ah di Carica Batteria`,
"站级监控/电池最后一次放电Ah数":   `Ultimi Ah di Scarica Batteria`,
"站级监控/电池最后一次充电kWh数":   `Ultimi kWh di Carica Batteria`,
"站级监控/电池最后一次放电kWh数":   `Ultimi kWh di Scarica Batteria`,
"站级监控/Flash写成功次数":   `Numero Scritture Flash Riuscite`,
"站级监控/Flash写失败次数":   `Numero Scritture Flash Fallite`,
"站级监控/安时积分":   `Integrazione Ah`,
"站级监控/EMS正常运行时间":   `Durata Funzionamento Normale Ems`,
"站级监控/修正标志":   `Marcatura Modifica`,
"站级监控/电池系统最大允许充电功率":   `Potenza Massima di Carica Consentita Sistema Batteria`,
"站级监控/电池系统最大允许放电功率":   `Potenza Massima di Scarica Consentita Sistema Batteria`,
"站级监控/输入异常":   `Ingresso Anomalo`,
"站级监控/电芯均衡开关1":   `Interruttore Bilanciamento Cella 1`,
"站级监控/电芯均衡开关2":   `Interruttore Bilanciamento Cella 2`,
"站级监控/电芯均衡开关3":   `Interruttore Bilanciamento Cella 3`,
"站级监控/电芯均衡开关4":   `Interruttore Bilanciamento Cella 4`,
"站级监控/DC上次满充电量":   `Energia ultima carica completa DC`,
"站级监控/DC上次满放电量":   `Energia ultima scarica completa DC`,
"站级监控/DC上次满充容量":   `Capacità ultima carica completa DC`,
"站级监控/DC上次满放容量":   `Capacità ultima scarica completa DC`,
"站级监控/AC上次满充电量":   `Energia ultima carica completa AC`,
"站级监控/AC上次满放电量":   `Energia ultima scarica completa AC`,
"站级监控/交流侧充电效率":   `Efficienza di carica AC`,
"站级监控/交流侧额定电量":   `Energia nominale AC`,
"站级监控/AC显示SOE":   `SOE indicato AC`,
"站级监控/AC真实SOE":   `SOE effettivo AC`,
"站级监控/AC剩余电量":   `Energia residua AC`,
"站级监控/AC上次放电量":   `Energia ultima scarica AC`,
"站级监控/AC上次充电量":   `Energia ultima carica AC`,
"站级监控/AC电量截止标志":   `Segnale interruzione energia AC`,
"站级监控/AC累积放电量":   `Energia scarica accumulata AC`,
"站级监控/AC累积充电量":   `Energia carica accumulata AC`,
"站级监控/柜体累计充电量":   `Energia carica accumulata armadio`,
"站级监控/柜体累计放电量":   `Energia scarica accumulata armadio`,
"站级监控/均衡指令失效":   `Fallimento comando equalizzazione`,
"站级监控/电芯不均衡":   `Disuguaglianza celle`,
"站级监控/Flash写失败故障":   `Fallimento scrittura flash`,
"站级监控/BMS故障码":   `Codice guasto BMS`,
"站级监控/BMS故障属性":   `Attributo guasto BMS`,
"站级监控/电池总电压":   `Tensione totale batteria`,
"站级监控/电池总电流":   `Corrente totale batteria`,
"站级监控/电池充电限制电流":   `Limite corrente carica batteria`,
"站级监控/电池放电限制电流":   `Limite corrente scarica batteria`,
"站级监控/电池充电限制电压":   `Limite tensione carica batteria`,
"站级监控/电池放电限制电压":   `Limite tensione scarica batteria`,
"站级监控/直流侧安时积分":   `Integrazione Ah DC`,
"站级监控/电池平均电压":   `Tensione media batteria`,
"站级监控/电池电压有效数目":   `Numero tensione efficace batteria`,
"站级监控/电池平均温度":   `Temperatura media batteria`,
"站级监控/电池温度有效数目":   `Numero temperatura efficace batteria`,
"站级监控/最高电压":   `Tensione massima`,
"站级监控/最高电压BMU-ID":   `ID BMU tensione massima`,
"站级监控/最高电压电池位置":   `Indice cella tensione massima`,
"站级监控/最低电压":   `Tensione minima`,
"站级监控/最低电压BMU-ID":   `ID BMU tensione minima`,
"站级监控/最低电压电池位置":   `Indice cella tensione minima`,
"站级监控/最高温度":   `Temperatura Massima`,
"站级监控/最高温度BMU-ID":   `ID BMU Temperatura Massima`,
"站级监控/最高温度电池位置":   `Indice Cella Temperatura Massima`,
"站级监控/最低温度":   `Temperatura Minima`,
"站级监控/最低温度BMU-ID":   `ID BMU Temperatura Minima`,
"站级监控/最低温度电池位置":   `Indice Cella Temperatura Minima`,
"站级监控/柜体故障码1":   `Codice Guasto Armadio 1`,
"站级监控/柜体故障码1属性":   `Attributo Codice Guasto Armadio 1`,
"站级监控/柜体故障码2":   `Codice Guasto Armadio 2`,
"站级监控/柜体故障码2属性":   `Attributo Codice Guasto Armadio 2`,
"站级监控/柜体故障码3":   `Codice Guasto Armadio 3`,
"站级监控/柜体故障码3属性":   `Attributo Codice Guasto Armadio 3`,
"站级监控/PCS通信故障计数":   `Numero Guasto Comunicazione PCS`,
"站级监控/FLASH通信故障计数":   `Numero Guasto Comunicazione Flash`,
"站级监控/PCS通信丢包率":   `Rapporto Perdita Comunicazione PCS`,
"站级监控/Flash操作计数":   `Numero Operazioni Flash`,
"站级监控/EMS断网最大时长":   `Durata Massima Offline EMS`,
"站级监控/EMS接收计数":   `Numero Ricezioni EMS`,
"站级监控/EMS丢数据次数计数":   `Numero Perdite Dati EMS`,
"站级监控/EMS发送计数":   `Numero Invii EMS`,
"站级监控/均衡指令1":   `Comando Equalizzazione 1`,
"站级监控/均衡指令2":   `Comando Equalizzazione 2`,
"站级监控/均衡指令3":   `Comando Equalizzazione 3`,
"站级监控/均衡指令4":   `Comando Equalizzazione 4`,
"站级监控/BCS运行时长":   `Durata Operazione BCS`,
"站级监控/BCS心跳":   `Heartbeat BCS`,
"站级监控/PCS心跳":   `Heartbeat PCS`,
"站级监控/EMS心跳":   `Heartbeat EMS`,
"站级监控/BMU通信故障":   `Guasto Comunicazione BMU`,
"站级监控/EMS通信故障":   `Guasto Comunicazione EMS`,
"站级监控/PCS通信故障":   `Guasto Comunicazione PCS`,
"站级监控/电池管理芯片故障":   `Guasto Chip Gestione Batteria`,
"站级监控/锁机故障":   `Guasto Serratura`,
"站级监控/电池断线故障":   `Guasto Interruzione Batteria`,
"站级监控/水机故障":   `Guasto Macchina Acqua`,
"站级监控/电气火灾":   `Incendio Elettrico`,
"站级监控/电池热失控":   `Fuga Termica Batteria`,
"站级监控/电芯电压失效":   `Tensione Cella Inefficace`,
"站级监控/电芯多点温度无效":   `Temperatura Multipla Cella Inefficace`,
"站级监控/总压过压p1":   `Sovratensione Totale P1`,
"站级监控/总压欠压p1":   `Sottotensione Totale P1`,
"站级监控/电芯充电过流p1":   `Sovracorrente di Carica Cella P1`,
"站级监控/电芯放电过流p1":   `Sovracorrente di Scarica Cella P1`,
"站级监控/电芯充电过压p1":   `Sovratensione di Carica Cella P1`,
"站级监控/电芯充电欠压p1":   `Sottotensione di Carica Cella P1`,
"站级监控/电芯充电过温p1":   `Sovratemperatura di Carica Cella P1`,
"站级监控/电芯充电欠温p1":   `Sottotemperatura di Carica Cella P1`,
"站级监控/电芯放电过温p1":   `Sovratemperatura di Scarica Cella P1`,
"站级监控/电芯放电欠温p1":   `Sottotemperatura di Scarica Cella P1`,
"站级监控/电芯温度充电极差P1":   `Differenza Temperatura Carica Cella P1`,
"站级监控/电芯温度放电极差P1":   `Differenza Temperatura Scarica Cella P1`,
"站级监控/电芯电压充电极差P1":   `Differenza Tensione Carica Cella P1`,
"站级监控/电芯电压放电极差P1":   `Differenza Tensione Scarica Cella P1`,
"站级监控/水机通信故障":   `Guasto Comunicazione Macchina Acqua`,
"站级监控/门禁故障":   `Guasto Allarme Antintrusione`,
"站级监控/直流电压采样故障":   `Guasto Campionamento Tensione CC`,
"站级监控/MSD故障":   `Guasto MSD`,
"站级监控/BCS运行模式故障":   `Guasto Modalità Operativa BCS`,
"站级监控/水冷告警":   `Allarme Raffreddamento ad Acqua`,
"站级监控/水冷故障":   `Guasto Raffreddamento ad Acqua`,
"站级监控/烟感报警":   `Allarme Sensore Fumo`,
"站级监控/高温报警":   `Allarme Alta Temperatura`,
"站级监控/CO报警":   `Allarme CO`,
"站级监控/柜体气溶胶":   `Aerosol Armadio`,
"站级监控/水冷通信故障":   `Guasto Comunicazione Raffreddamento ad Acqua`,
"站级监控/FLASH通信故障":   `Guasto Comunicazione Flash`,
"站级监控/消防通信故障":   `Guasto Comunicazione Antincendio`,
"站级监控/电池管理芯片通信故障":   `Guasto Comunicazione Chip Gestione Batteria`,
"站级监控/风机通信故障":   `Guasto Comunicazione Turbina Eolica`,
"站级监控/除湿机通信故障":   `Guasto Comunicazione Deumidificatore`,
"站级监控/BMU1通信":   `Comunicazione BMU1`,
"站级监控/BMU2通信":   `Comunicazione BMU2`,
"站级监控/BMU3通信":   `Comunicazione BMU3`,
"站级监控/BMU4通信":   `Comunicazione BMU4`,
"站级监控/电池充电过压P1":   `Sovratensione Carica Batteria P1`,
"站级监控/电池充电过压P2":   `Sovratensione Carica Batteria P2`,
"站级监控/电池充电过压P3":   `Sovratensione Carica Batteria P3`,
"站级监控/电池充电过压截止":   `Interruzione Sovratensione Carica Batteria`,
"站级监控/电池放电欠压P1":   `Sottotensione Scarica Batteria P1`,
"站级监控/电池放电欠压P2":   `Sottotensione Scarica Batteria P2`,
"站级监控/电池放电欠压P3":   `Scarica batteria sotto tensione P3`,
"站级监控/电池放电欠压截止":   `Interruzione scarica batteria sotto tensione`,
"站级监控/电池总电压过压P1":   `Sovratensione totale batteria P1`,
"站级监控/电池总电压过压P2":   `Sovratensione totale batteria P2`,
"站级监控/电池总电压过压P3":   `Sovratensione totale batteria P3`,
"站级监控/电池总电压过压截止":   `Interruzione sovratensione totale batteria`,
"站级监控/电池总电压欠压P1":   `Sottotensione totale batteria P1`,
"站级监控/电池总电压欠压P2":   `Sottotensione totale batteria P2`,
"站级监控/电池总电压欠压P3":   `Sottotensione totale batteria P3`,
"站级监控/电池总电压欠压截止":   `Interruzione sottotensione totale batteria`,
"站级监控/电池充电电压极差P1":   `Differenza tensione carica batteria P1`,
"站级监控/电池充电电压极差P2":   `Differenza tensione carica batteria P2`,
"站级监控/电池充电电压极差P3":   `Differenza tensione carica batteria P3`,
"站级监控/电池充电电压极差截止":   `Interruzione differenza tensione carica batteria`,
"站级监控/电池放电电压极差P1":   `Differenza tensione scarica batteria P1`,
"站级监控/电池放电电压极差P2":   `Differenza tensione scarica batteria P2`,
"站级监控/电池放电电压极差P3":   `Differenza tensione scarica batteria P3`,
"站级监控/电池放电电压极差截止":   `Interruzione differenza tensione scarica batteria`,
"站级监控/电池电压失效":   `Tensione batteria inefficace`,
"站级监控/电池充电过温度P1":   `Sovratemperatura carica batteria P1`,
"站级监控/电池充电过温度P2":   `Sovratemperatura carica batteria P2`,
"站级监控/电池充电过温度P3":   `Sovratemperatura carica batteria P3`,
"站级监控/电池充电过温度截止":   `Interruzione sovratemperatura carica batteria`,
"站级监控/电池充电欠温度P1":   `Sottotemperatura carica batteria P1`,
"站级监控/电池充电欠温度P2":   `Sottotemperatura carica batteria P2`,
"站级监控/电池充电欠温度P3":   `Sottotemperatura carica batteria P3`,
"站级监控/电池充电欠温度截止":   `Interruzione sottotemperatura carica batteria`,
"站级监控/电池放电过温度P1":   `Sovratemperatura scarica batteria P1`,
"站级监控/电池放电过温度P2":   `Sovratemperatura scarica batteria P2`,
"站级监控/电池放电过温度P3":   `Sovratemperatura scarica batteria P3`,
"站级监控/电池放电过温度截止":   `Interruzione sovratemperatura scarica batteria`,
"站级监控/电池放电欠温度P1":   `Sottotemperatura scarica batteria P1`,
"站级监控/电池放电欠温度P2":   `Sottotemperatura scarica batteria P2`,
"站级监控/电池放电欠温度P3":   `Sottotemperatura scarica batteria P3`,
"站级监控/电池放电欠温度截止":   `Interruzione sottotemperatura scarica batteria`,
"站级监控/电池充电温度极差P1":   `Differenza temperatura carica batteria P1`,
"站级监控/电池充电温度极差P2":   `Differenza temperatura carica batteria P2`,
"站级监控/电池充电温度极差P3":   `Differenza temperatura carica batteria P3`,
"站级监控/电池充电温度极差STOP":   `Interruzione differenza temperatura carica batteria`,
"站级监控/电池放电温度极差P1":   `Differenza temperatura scarica batteria P1`,
"站级监控/电池放电温度极差P2":   `Differenza di Temperatura di Scarica della Batteria P2`,
"站级监控/电池放电温度极差P3":   `Differenza di Temperatura di Scarica della Batteria P3`,
"站级监控/电池放电温度极差STOP":   `Soglia di Differenza di Temperatura di Scarica della Batteria`,
"站级监控/电池单点温度无效":   `Temperatura Singola della Batteria Inefficace`,
"站级监控/电池多点温度无效":   `Temperature Multiple della Batteria Inefficaci`,
"站级监控/电芯充电过流P1":   `Sovracorrente di Carica della Cella P1`,
"站级监控/电芯充电过流P2":   `Sovracorrente di Carica della Cella P2`,
"站级监控/电芯充电过流P3":   `Sovracorrente di Carica della Cella P3`,
"站级监控/电芯充电过流截止":   `Soglia di Sovracorrente di Carica della Cella`,
"站级监控/电芯放电过流P1":   `Sovracorrente di Scarica della Cella P1`,
"站级监控/电芯放电过流P2":   `Sovracorrente di Scarica della Cella P2`,
"站级监控/电芯放电过流P3":   `Sovracorrente di Scarica della Cella P3`,
"站级监控/电芯放电过流截止":   `Soglia di Sovracorrente di Scarica della Cella`,
"站级监控/电器火灾锁定":   `Blocco Antincendio Elettrico`,
"站级监控/电池热失控锁定":   `Blocco per Fuga Termica della Batteria`,
"站级监控/DI1状态":   `Stato DI1`,
"站级监控/DI2状态":   `Stato DI2`,
"站级监控/DI3状态":   `Stato DI3`,
"站级监控/DI4状态":   `Stato DI4`,
"站级监控/DI5状态":   `Stato DI5`,
"站级监控/DI6状态":   `Stato DI6`,
"站级监控/DI7状态":   `Stato DI7`,
"站级监控/DI8状态":   `Stato DI8`,
"站级监控/DI9状态":   `Stato DI9`,
"站级监控/DI10状态":   `Stato DI10`,
"站级监控/DI11状态":   `Stato DI11`,
"站级监控/DI12状态":   `Stato DI12`,
"站级监控/DI13状态":   `Stato DI13`,
"站级监控/DI14状态":   `Stato DI14`,
"站级监控/DI15状态":   `Stato DI15`,
"站级监控/DI16状态":   `Stato DI16`,
"站级监控/DO1状态":   `Stato DO1`,
"站级监控/DO2状态":   `Stato DO2`,
"站级监控/DO3状态":   `Stato DO3`,
"站级监控/DO4状态":   `Stato DO4`,
"站级监控/DO5状态":   `Stato DO5`,
"站级监控/DO6状态":   `Stato DO6`,
"站级监控/DO7状态":   `Stato DO7`,
"站级监控/DO8状态":   `Stato DO8`,
"站级监控/DO9状态":   `Stato DO9`,
"站级监控/DO10状态":   `Stato DO10`,
"站级监控/DO11状态":   `Stato DO11`,
"站级监控/DO12状态":   `Stato DO12`,
"站级监控/DO13状态":   `Stato DO13`,
"站级监控/DO14状态":   `Stato DO14`,
"站级监控/DO15状态":   `Stato DO15`,
"站级监控/DO16状态":   `Stato DO16`,
"站级监控/PACK总电压":   `Tensione Totale PACK`,
"站级监控/PACK正焊接排温度":   `Temperatura Barra Positiva PACK`,
"站级监控/PACK负焊接排温度":   `Temperatura Barra Negativa PACK`,
"站级监控/露点温度":   `Temperatura Punto di Rugiada`,
"站级监控/电池管理芯片1温度":   `Temperatura Chip Gestione Batteria 1`,
"站级监控/电池管理芯片2温度":   `Temperatura Chip Gestione Batteria 2`,
"站级监控/BMU-APP版本号":   `Versione BMU-APP`,
"站级监控/BMU-BOOT版本号":   `Versione BMU-BOOT`,
"站级监控/BMU编号":   `Codice BMU`,
"站级监控/LTC6813-1通信故障":   `Guasto Comunicazione LTC6813-1`,
"站级监控/LTC6813-2通信故障":   `Guasto Comunicazione LTC6813-2`,
"站级监控/LTC6813-3通信故障":   `Guasto Comunicazione LTC6813-3`,
"站级监控/LTC6813-4通信故障":   `Guasto Comunicazione LTC6813-4`,
"站级监控/LTC6813-PEC通信故障":   `Guasto Comunicazione LTC6813-PEC`,
"站级监控/BMU-CAN通信故障":   `Guasto Comunicazione BMU-CAN`,
"站级监控/均衡异常":   `Equalizzazione Anomala`,
"站级监控/电池采样芯片1总负断线":   `Interruzione Principale Negativa Chip Campionamento Batteria 1`,
"站级监控/电池采样芯片2总负断线":   `Interruzione Principale Negativa Chip Campionamento Batteria 2`,
"站级监控/电池采样芯片3总负断线":   `Interruzione Principale Negativa Chip Campionamento Batteria 3`,
"站级监控/电池采样芯片4总负断线":   `Interruzione Principale Negativa Chip Campionamento Batteria 4`,
"站级监控/电池采集芯片高温":   `Temperatura Elevata Chip Campionamento Batteria`,
"站级监控/AFE-1采样故障":   `Guasto Campionamento AFE-1`,
"站级监控/AFE-2采样故障":   `Guasto Campionamento AFE-2`,
"站级监控/AFE-3采样故障":   `Guasto Campionamento AFE-3`,
"站级监控/AFE-4采样故障":   `Guasto Campionamento AFE-4`,
"站级监控/正母排温度断线":   `Interruzione Temperatura Barra Positiva`,
"站级监控/负母排温度断线":   `Interruzione Temperatura Barra Negativa`,
"站级监控/BCS均衡控制帧通信故障":   `Guasto Comunicazione Frame Controllo Equalizzazione BCS`,
"站级监控/电池焊接排温度断线":   `Interruzione Temperatura Barra Batteria`,
"站级监控/MSD温度断线":   `Interruzione Temperatura MSD`,
"站级监控/CELL-1均衡":   `Equalizzazione Cella-1`,
"站级监控/CELL-2均衡":   `Equalizzazione Cella-2`,
"站级监控/CELL-3均衡":   `Equalizzazione Cella-3`,
"站级监控/CELL-4均衡":   `Equalizzazione cella 4`,
"站级监控/CELL-5均衡":   `Equalizzazione cella 5`,
"站级监控/CELL-6均衡":   `Equalizzazione cella 6`,
"站级监控/CELL-7均衡":   `Equalizzazione cella 7`,
"站级监控/CELL-8均衡":   `Equalizzazione cella 8`,
"站级监控/CELL-9均衡":   `Equalizzazione cella 9`,
"站级监控/CELL-10均衡":   `Equalizzazione cella 10`,
"站级监控/CELL-11均衡":   `Equalizzazione cella 11`,
"站级监控/CELL-12均衡":   `Equalizzazione cella 12`,
"站级监控/CELL-13均衡":   `Equalizzazione cella 13`,
"站级监控/CELL-14均衡":   `Equalizzazione cella 14`,
"站级监控/CELL-15均衡":   `Equalizzazione cella 15`,
"站级监控/CELL-16均衡":   `Equalizzazione cella 16`,
"站级监控/CELL-17均衡":   `Equalizzazione cella 17`,
"站级监控/CELL-18均衡":   `Equalizzazione cella 18`,
"站级监控/CELL-19均衡":   `Equalizzazione cella 19`,
"站级监控/CELL-20均衡":   `Equalizzazione cella 20`,
"站级监控/CELL-21均衡":   `Equalizzazione cella 21`,
"站级监控/CELL-22均衡":   `Equalizzazione cella 22`,
"站级监控/CELL-23均衡":   `Equalizzazione cella 23`,
"站级监控/CELL-24均衡":   `Equalizzazione cella 24`,
"站级监控/CELL-25均衡":   `Equalizzazione cella 25`,
"站级监控/CELL-26均衡":   `Equalizzazione cella 26`,
"站级监控/CELL-27均衡":   `Equalizzazione cella 27`,
"站级监控/CELL-28均衡":   `Equalizzazione cella 28`,
"站级监控/CELL-29均衡":   `Equalizzazione cella 29`,
"站级监控/CELL-30均衡":   `Equalizzazione cella 30`,
"站级监控/CELL-31均衡":   `Equalizzazione cella 31`,
"站级监控/CELL-32均衡":   `Equalizzazione cella 32`,
"站级监控/CELL-1电压断线":   `Interruzione tensione cella 1`,
"站级监控/CELL-2电压断线":   `Interruzione tensione cella 2`,
"站级监控/CELL-3电压断线":   `Interruzione tensione cella 3`,
"站级监控/CELL-4电压断线":   `Interruzione tensione cella 4`,
"站级监控/CELL-5电压断线":   `Interruzione tensione cella 5`,
"站级监控/CELL-6电压断线":   `Interruzione tensione cella 6`,
"站级监控/CELL-7电压断线":   `Interruzione tensione cella 7`,
"站级监控/CELL-8电压断线":   `Interruzione tensione cella 8`,
"站级监控/CELL-9电压断线":   `Interruzione tensione cella 9`,
"站级监控/CELL-10电压断线":   `Interruzione tensione cella 10`,
"站级监控/CELL-11电压断线":   `Interruzione tensione cella 11`,
"站级监控/CELL-12电压断线":   `Interruzione tensione cella 12`,
"站级监控/CELL-13电压断线":   `Interruzione tensione cella 13`,
"站级监控/CELL-14电压断线":   `Interruzione tensione cella 14`,
"站级监控/CELL-15电压断线":   `Interruzione tensione cella 15`,
"站级监控/CELL-16电压断线":   `Interruzione tensione cella 16`,
"站级监控/CELL-17电压断线":   `Interruzione tensione cella 17`,
"站级监控/CELL-18电压断线":   `Interruzione tensione cella 18`,
"站级监控/CELL-19电压断线":   `Interruzione tensione cella 19`,
"站级监控/CELL-20电压断线":   `Interruzione tensione cella 20`,
"站级监控/CELL-21电压断线":   `Interruzione tensione cella 21`,
"站级监控/CELL-22电压断线":   `Interruzione tensione cella 22`,
"站级监控/CELL-23电压断线":   `Interruzione tensione cella 23`,
"站级监控/CELL-24电压断线":   `Interruzione tensione cella 24`,
"站级监控/CELL-25电压断线":   `Interruzione tensione cella 25`,
"站级监控/CELL-26电压断线":   `Interruzione tensione cella 26`,
"站级监控/CELL-27电压断线":   `Interruzione tensione cella 27`,
"站级监控/CELL-28电压断线":   `Interruzione tensione cella 28`,
"站级监控/CELL-29电压断线":   `Interruzione tensione cella 29`,
"站级监控/CELL-30电压断线":   `Interruzione tensione cella 30`,
"站级监控/CELL-31电压断线":   `Interruzione tensione cella 31`,
"站级监控/CELL-32电压断线":   `Interruzione tensione cella 32`,
"站级监控/CELL-1温度断线":   `Interruzione temperatura cella 1`,
"站级监控/CELL-2温度断线":   `Interruzione temperatura cella 2`,
"站级监控/CELL-3温度断线":   `Interruzione temperatura cella 3`,
"站级监控/CELL-4温度断线":   `Interruzione temperatura cella 4`,
"站级监控/CELL-5温度断线":   `Interruzione temperatura cella 5`,
"站级监控/CELL-6温度断线":   `Interruzione temperatura cella 6`,
"站级监控/CELL-7温度断线":   `Interruzione temperatura cella 7`,
"站级监控/CELL-8温度断线":   `Interruzione temperatura cella 8`,
"站级监控/CELL-9温度断线":   `Interruzione temperatura cella 9`,
"站级监控/CELL-10温度断线":   `Interruzione temperatura cella 10`,
"站级监控/CELL-11温度断线":   `Interruzione temperatura cella 11`,
"站级监控/CELL-12温度断线":   `Interruzione temperatura cella 12`,
"站级监控/CELL-13温度断线":   `Interruzione temperatura cella 13`,
"站级监控/CELL-14温度断线":   `Interruzione temperatura cella 14`,
"站级监控/CELL-15温度断线":   `Interruzione temperatura cella 15`,
"站级监控/CELL-16温度断线":   `Interruzione temperatura cella 16`,
"站级监控/CELL-17温度断线":   `Interruzione temperatura cella 17`,
"站级监控/CELL-18温度断线":   `Interruzione temperatura cella 18`,
"站级监控/CELL-19温度断线":   `Interruzione temperatura cella 19`,
"站级监控/CELL-20温度断线":   `Temperatura Cella-20`,
"站级监控/CELL-21温度断线":   `Temperatura Cella-21`,
"站级监控/CELL-22温度断线":   `Temperatura Cella-22`,
"站级监控/CELL-23温度断线":   `Temperatura Cella-23`,
"站级监控/CELL-24温度断线":   `Temperatura Cella-24`,
"站级监控/CELL-25温度断线":   `Temperatura Cella-25`,
"站级监控/CELL-26温度断线":   `Temperatura Cella-26`,
"站级监控/CELL-27温度断线":   `Temperatura Cella-27`,
"站级监控/CELL-28温度断线":   `Temperatura Cella-28`,
"站级监控/CELL-29温度断线":   `Temperatura Cella-29`,
"站级监控/CELL-30温度断线":   `Temperatura Cella-30`,
"站级监控/CELL-31温度断线":   `Temperatura Cella-31`,
"站级监控/CELL-32温度断线":   `Temperatura Cella-32`,
"站级监控/BMU软件ID":   `ID Software BMU`,
"站级监控/VOC浓度":   `Concentrazione VOC`,
"站级监控/探测器状态":   `Stato Rilevatore`,
"站级监控/上风机故障状态":   `Stato Guasto Turbina Superiore`,
"站级监控/上风机换气设置":   `Impostazione Ventilazione Turbina Superiore`,
"站级监控/上风机风门状态":   `Stato Porta Turbina Superiore`,
"站级监控/上风机状态":   `Stato Turbina Superiore`,
"站级监控/下风机故障状态":   `Stato Guasto Turbina Inferiore`,
"站级监控/下风机换气设置":   `Impostazione Ventilazione Turbina Inferiore`,
"站级监控/下风机风门状态":   `Stato Porta Turbina Inferiore`,
"站级监控/下风机状态":   `Stato Turbina Inferiore`,
"站级监控/电池火灾VOC浓度限值":   `Limite Concentrazione VOC Incendio Batteria`,
"站级监控/柜体火灾温度上限值":   `Limite Temperatura Incendio Armadio`,
"站级监控/柜体高温门限值":   `Limite Alta Temperatura Armadio`,
"站级监控/柜体烟雾门限值":   `Limite Fumo Armadio`,
"站级监控/加热开启温度":   `Temperatura Avvio Riscaldamento`,
"站级监控/环境温度值":   `Temperatura Ambiente`,
"站级监控/环境湿度值":   `Umidità Ambiente`,
"站级监控/加热状态":   `Stato Riscaldamento`,
"站级监控/除湿机状态":   `Stato Deumidificatore`,
"站级监控/除湿机控制模式":   `Modalità Controllo Deumidificatore`,
"站级监控/控湿开启值":   `Valore Avvio Umidità Controllo`,
"站级监控/控湿停止值":   `Valore Arresto Umidità Controllo`,
"站级监控/pack出水温度":   `Temperatura Uscita Acqua PACK`,
"站级监控/pack回水温度":   `Temperatura Ingresso Acqua PACK`,
"站级监控/pack进水口压力值":   `Pressione Ingresso Acqua PACK`,
"站级监控/pack出水口压力值":   `Pressione Uscita Acqua PACK`,
"站级监控/pack泵转速":   `Velocità Pompa PACK`,
"站级监控/BMS请求设定温度":   `Temperatura Impostata Richiesta BMS`,
"站级监控/BMS请求设定模式":   `Modalità Impostata Richiesta BMS`,
"站级监控/水机通信计数":   `Numero Comunicazione Macchina Acqua`,
"站级监控/pack工作状态":   `Stato Lavoro PACK`,
"站级监控/压缩机":   `Compressore`,
"站级监控/压缩机加热带":   `Resistenza Termica Compressore`,
"站级监控/电加热":   `Riscaldamento Elettrico`,
"站级监控/风机1":   `Turbina Eolica 1`,
"站级监控/风机2":   `Turbina Eolica 2`,
"站级监控/风机3":   `Turbina Eolica 3`,
"站级监控/风机4":   `Turbina Eolica 4`,
"站级监控/PCS泵转速":   `Velocità Pompa PCS`,
"站级监控/PCS工作状态":   `Stato Lavoro PCS`,
"站级监控/PCS出水温度":   `Temperatura Acqua Uscita PCS`,
"站级监控/PCS回水温度":   `Temperatura Acqua Ingresso PCS`,
"站级监控/PCS进水口压力值":   `Pressione Acqua Ingresso PCS`,
"站级监控/PCS出水口压力值":   `Pressione Acqua Uscita PCS`,
"站级监控/出风温度":   `Temperatura Aria Uscita`,
"站级监控/系统高压压力":   `Valore Pressione Alta Sistema`,
"站级监控/FC阀开度":   `Apertura Valvola FC`,
"站级监控/风扇1转速":   `Velocità Ventola 1`,
"站级监控/风扇2转速":   `Velocità Ventola 2`,
"站级监控/风扇3转速":   `Velocità Ventola 3`,
"站级监控/风扇4转速":   `Velocità Ventola 4`,
"站级监控/pack供水泵":   `Pompa Acqua PACK`,
"站级监控/pcs供水泵":   `Pompa Acqua PCS`,
"站级监控/压机转速":   `Velocità Compressore`,
"站级监控/进风温度":   `Temperatura Aria Ingresso`,
"站级监控/pack故障编码":   `Codice Guasto PACK`,
"站级监控/pack故障等级":   `Livello Guasto PACK`,
"站级监控/pcs故障编码":   `Codice Guasto PCS`,
"站级监控/pcs故障等级":   `Livello Guasto PCS`,
"站级监控/控制模式":   `Modalità Controllo`,
"站级监控/制冷设定温度":   `Temperatura Impostata Raffreddamento`,
"站级监控/制热设定温度":   `Temperatura Impostata Riscaldamento`,


// 光伏监控
'光伏监控/光伏': 'Fotovoltaico',
'光伏监控/光伏概况': 'Panoramica Fotovoltaico',
'光伏监控/光伏列表': 'Lista Fotovoltaico',
'光伏监控/更新时间': 'Tempo Aggiornamento',
'光伏监控/功率曲线': 'Curva di Potenza',
'光伏监控/总有功功率': 'Potenza Attiva Totale',
'光伏监控/总无功功率': 'Potenza Reattiva Totale',
'光伏监控/总功率因数': 'Fattore di Potenza Totale',
'光伏监控/日发电量': 'Generazione Giornaliera',
'光伏监控/总发电量': 'Generazione Totale',
'光伏监控/总功率': 'Potenza Totale',
'光伏监控/系统状态': 'Stato Sistema',
'光伏监控/有功功率': 'Potenza Attiva',
'光伏监控/查看日发电量统计': 'Visualizza Generazione Giornaliera',
'光伏监控/光伏个数': 'Numero Fotovoltaico',
'光伏监控/时间': 'Tempo',
'光伏监控/无功功率': 'Potenza Reattiva',
'光伏监控/日出': 'Alba',
'光伏监控/日落': 'Tramonto',
'光伏监控/日出日落时间': 'Alba e Tramonto',
'光伏监控/光伏每日发电量统计': 'Statistica Generazione Giornaliera',
'光伏监控/查询': 'Cerca',


"电站地图/点击地图进行面积测量，双击结束绘制":   `Clicca sulla mappa per misurare l'area, doppio clic per terminare il disegno`,
"电站地图/知道了":   `OK`,
"电站地图/搜索电站":   `Cerca Stazione`,
"电站地图/装机容量":   `Capacità Installata`,
"电站地图/点击进入":   `Clicca per Entrare`,
"电站地图/面积测量":   `Misurazione Area`,
"电站地图/清除面积测量":   `Cancella Misurazione Area`,
"电站地图/地址":   `Indirizzo`,
"站级监控/产品型号":   `Modello Prodotto`,
"站级监控/产品序列号":   `Numero Seriale Prodotto`,
"站级监控/硬件版本":   `Versione Hardware`,
"站级监控/BOOT版本":   `Versione BOOT`,
"站级监控/APP版本":   `Versione APP`,
"站级监控/MCU温度":   `Temperatura MCU`,
"站级监控/逆变A相IGBT温度":   `Temperatura IGBT Fase A Inverter`,
"站级监控/逆变B相IGBT温度":   `Temperatura IGBT Fase B Inverter`,
"站级监控/逆变C相IGBT温度":   `Temperatura IGBT Fase C Inverter`,
"站级监控/逆变不平衡桥温度":   `Temperatura Ponte Sbilanciato Inverter`,
"站级监控/DCDC_MOS温度":   `Temperatura MOS DCDC`,
"站级监控/MPPT_MOS温度":   `Temperatura MOS MPPT`,
"站级监控/24V蓄电池电压":   `Tensione Batteria 24V`,
"站级监控/（电表）A相电压":   `Tensione Fase A Contatore`,
"站级监控/（电表）B相电压":   `Tensione Fase B Contatore`,
"站级监控/（电表）C相电压":   `Tensione Fase C Contatore`,
"站级监控/（电表）AB线电压":   `Tensione Linea AB Contatore`,
"站级监控/（电表）BC线电压":   `Tensione Linea BC Contatore`,
"站级监控/（电表）CA线电压":   `Tensione Linea CA Contatore`,
"站级监控/（电表）A相电流":   `Corrente Fase A Contatore`,
"站级监控/（电表）B相电流":   `Corrente Fase B Contatore`,
"站级监控/（电表）C相电流":   `Corrente Fase C Contatore`,
"站级监控/（电表）A相有功功率":   `Potenza Attiva Fase A Contatore`,
"站级监控/（电表）B相有功功率":   `Potenza Attiva Fase B Contatore`,
"站级监控/（电表）C相有功功率":   `Potenza Attiva Fase C Contatore`,
"站级监控/（电表）合相有功功率":   `Potenza Attiva Totale Contatore`,
"站级监控/（电表）A相无功功率":   `Potenza Reattiva Fase A Contatore`,
"站级监控/（电表）B相无功功率":   `Potenza Reattiva Fase B Contatore`,
"站级监控/（电表）C相无功功率":   `Potenza Reattiva Fase C Contatore`,
"站级监控/（电表）合相无功功率":   `Potenza Reattiva Totale Contatore`,
"站级监控/（电表）A相功率因数":   `Fattore di Potenza Fase A Contatore`,
"站级监控/（电表）B相功率因数":   `Fattore di Potenza Fase B Contatore`,
"站级监控/（电表）C相功率因数":   `Fattore di Potenza Fase C Contatore`,
"站级监控/（电表）总功率因数":   `Fattore di Potenza Totale Contatore`,
"站级监控/（电表）频率":   `Frequenza Contatore`,
"站级监控/（电表）正向有功总电能":   `Energia Attiva Totale Positiva Contatore`,
"站级监控/（电表）A相正向有功电能":   `Energia Attiva Positiva Fase A del Contatore`,
"站级监控/（电表）B相正向有功电能":   `Energia Attiva Positiva Fase B del Contatore`,
"站级监控/（电表）C相正向有功电能":   `Energia Attiva Positiva Fase C del Contatore`,
"站级监控/（电表）正向有功净电能":   `Energia Attiva Neta Positiva del Contatore`,
"站级监控/反向有功总电能":   `Energia Reattiva Totale Negativa del Contatore`,
"站级监控/A相反向有功电能":   `Energia Attiva Negativa Fase A del Contatore`,
"站级监控/B相反向有功电能":   `Energia Attiva Negativa Fase B del Contatore`,
"站级监控/C相反向有功电能":   `Energia Attiva Negativa Fase C del Contatore`,
"站级监控/反向有功净电能":   `Energia Attiva Neta Negativa del Contatore`,
"站级监控/EMS运行状态":   `Stato Operativo EMS`,
"站级监控/并离网状态":   `Stato Connessione/Sconnessione alla Rete`,
"站级监控/负载消耗状态":   `Stato Consumo Carico`,
"站级监控/PV输出功率状态":   `Stato Potenza Uscita Fotovoltaico`,
"站级监控/电网电能状态":   `Stato Energia della Rete`,
"站级监控/门碰":   `Serratura Porta`,
"站级监控/急停":   `Arresto di Emergenza`,
"站级监控/黑启动":   `Avvio in Nero`,
"站级监控/DRM1":   `DRM1`,
"站级监控/DRM2":   `DRM2`,
"站级监控/DRM3":   `DRM3`,
"站级监控/DRM4":   `DRM4`,
"站级监控/DRM5":   `DRM5`,
"站级监控/DRM6":   `DRM6`,
"站级监控/BCS通信故障":   `Guasto Comunicazione BCS`,
"站级监控/BCS通信CRC故障":   `Guasto CRC Comunicazione BCS`,
"站级监控/1路SCI通信故障":   `Guasto Comunicazione SCI Bus1`,
"站级监控/2路SCI通信故障":   `Guasto Comunicazione SCI Bus2`,
"站级监控/电表通信故障":   `Guasto Comunicazione Contatore`,
"站级监控/Flash通信故障":   `Guasto Comunicazione Flash`,
"站级监控/EEprom通信故障":   `Guasto Comunicazione EEPROM`,
"站级监控/排风机通信故障":   `Guasto Comunicazione Ventilazione`,
"站级监控/逆变A相IGBT过温保护":   `Protezione Sovratemperatura IGBT Fase A Inverter`,
"站级监控/逆变B相IGBT过温保护":   `Protezione Sovratemperatura IGBT Fase B Inverter`,
"站级监控/逆变C相IGBT过温保护":   `Protezione Sovratemperatura IGBT Fase C Inverter`,
"站级监控/逆变平衡桥过温保护":   `Protezione Sovratemperatura Ponte Bilanciato Inverter`,
"站级监控/DCDC_MOS过温保护":   `Protezione Sovratemperatura MOS DCDC`,
"站级监控/MPPT_MOS过温保护":   `Protezione Sovratemperatura MOS MPPT`,
"站级监控/电网电压A相互校异常":   `Anomalia Calibrazione Mutua Tensione Fase A Rete`,
"站级监控/电网电压B相互校异常":   `Anomalia Calibrazione Mutua Tensione Fase B Rete`,
"站级监控/电网电压C相互校异常":   `Anomalia Calibrazione Mutua Tensione Fase C Rete`,
"站级监控/逆变电压A相互校异常":   `Inverter Fase A Tensione Calibrazione Mutua Anomala`,
"站级监控/逆变电压B相互校异常":   `Inverter Fase B Tensione Calibrazione Mutua Anomala`,
"站级监控/逆变电压C相互校异常":   `Inverter Fase C Tensione Calibrazione Mutua Anomala`,
"站级监控/逆变A相IGBT过温告警":   `Inverter Fase A IGBT Allarme Sovratemperatura`,
"站级监控/逆变B相IGBT过温告警":   `Inverter Fase B IGBT Allarme Sovratemperatura`,
"站级监控/逆变C相IGBT过温告警":   `Inverter Fase C IGBT Allarme Sovratemperatura`,
"站级监控/离网过载":   `Sovraccarico Off-Grid`,
"站级监控/逆变A相IGBT NTC开路":   `Inverter Fase A IGBT NTC Circuito Aperto`,
"站级监控/逆变A相IGBT NTC短路":   `Inverter Fase A IGBT NTC Cortocircuito`,
"站级监控/逆变B相IGBT NTC开路":   `Inverter Fase B IGBT NTC Circuito Aperto`,
"站级监控/逆变B相IGBT NTC短路":   `Inverter Fase B IGBT NTC Cortocircuito`,
"站级监控/逆变C相IGBT NTC开路":   `Inverter Fase C IGBT NTC Circuito Aperto`,
"站级监控/逆变C相IGBT NTC短路":   `Inverter Fase C IGBT NTC Cortocircuito`,
"站级监控/逆变不平衡桥 NTC开路":   `Inverter Ponte Sbilanciato NTC Circuito Aperto`,
"站级监控/逆变不平衡桥 NTC短路":   `Inverter Ponte Sbilanciato NTC Cortocircuito`,
"站级监控/DCDC_MOS NTC开路":   `DCDC MOS NTC Circuito Aperto`,
"站级监控/DCDC_MOS NTC短路":   `DCDC MOS NTC Cortocircuito`,
"站级监控/MPPT_MOS NTC开路":   `MPPT MOS NTC Circuito Aperto`,
"站级监控/MPPT_MOS NTC短路":   `MPPT MOS NTC Cortocircuito`,
"站级监控/24V蓄电池过压":   `Batteria 24V Sovratensione`,
"站级监控/24V蓄电池欠压":   `Batteria 24V Sottotensione`,
"站级监控/RTC时间类型异常":   `Tipo Ora RTC Anomalo`,
"站级监控/SD卡检测任务创建失败":   `Creazione Task Controllo SD Fallita`,
"站级监控/SD卡HOST初始化失败":   `Inizializzazione Host SD Fallita`,
"站级监控/SD卡不存在":   `SD Non Presente`,
"站级监控/SD卡挂在失败":   `Montaggio SD Fallito`,
"站级监控/SD卡格式化失败":   `Formattazione SD Fallita`,
"站级监控/SD卡修改驱动盘符失败":   `Modifica Simbolo Disco Driver SD Fallita`,
"站级监控/SD卡打开文件失败":   `Apertura File SD Fallita`,
"站级监控/SD卡写文件失败":   `Scrittura File SD Fallita`,
"站级监控/SD卡读文件失败":   `Lettura File SD Fallita`,
"站级监控/天":   `Giorno`,
"站级监控/元":   `Yuan`,
"站级监控/光伏":   `Fotovoltaico`,
"站级监控/eBlock详情":   `Dettagli eBlock`,
"站级监控/电压":   `Tensione`,
"站级监控/电流":   `Corrente`,
"站级监控/温度":   `Temperatura`,
"站级监控/内阻":   `Resistenza`,
"站级监控/系统内存占用":   `Utilizzo Memoria di Sistema`,
"站级监控/电芯数量":   `Numero`,
"站级监控/电芯温度":   `T`,
"站级监控/电芯电压":   `V`,
"站级监控/电芯内阻":   `R`,
"站级监控/正常电芯":   `Normale`,
"站级监控/低温电芯":   `Bassa Temperatura`,
"站级监控/高温电芯":   `Alta Temperatura`,
"站级监控/电芯":   `Cella`,
"站级监控/pack编号":   `Indice Pacco`,
"站级监控/电芯编号":   `Indice Cella`,
"站级监控/号":   `N.`,
"站级监控/全部":   `Tutto`,
"站级监控/空调详情":   `Dettagli Condizionatore`,

"时段电价/自定义电价":   `Prezzo Personalizzato`,
"时段电价/时段电价":   `Prezzo Periodico`,
"时段电价/当前电站使用的电价":   `Prezzo Attuale Stazione`,
"时段电价/电价名称":   `Nome Prezzo`,
"时段电价/新增电价":   `Aggiungi Prezzo`,
"时段电价/尖峰":   `Picco`,
"时段电价/高峰":   `Massimo`,
"时段电价/平":   `Piano`,
"时段电价/低谷":   `Valle`,
"时段电价/深谷":   `Valle Profonda`,
"时段电价/预设状态":   `Stato Preimpostato`,
"时段电价/已预设":   `Preimpostato`,
"时段电价/未预设":   `Non Preimpostato`,
"时段电价/创建人":   `Creatore`,
"时段电价/创建时间":   `Ora Creazione`,
"时段电价/生效月份":   `Mese Effettivo`,
"时段电价/操作":   `Operazione`,
"时段电价/查看":   `Visualizza`,
"时段电价/设为默认":   `Imposta come Predefinito`,
"时段电价/编辑":   `Modifica`,
"时段电价/此表为当前电站所使用的电价，纯展示":   `Questa tabella mostra il prezzo attuale della stazione, solo visualizzazione`,
"时段电价/需要修改电价时，先在右侧电价表中查看，如有需要的电价则直接设为默认电价，如无则新增电价":   `Per modificare il prezzo, prima controlla nella tabella dei prezzi a destra. Se esiste il prezzo che ti serve, impostalo come predefinito direttamente, altrimenti aggiungi un nuovo prezzo`,
"时段电价/新增电价必须输入电价名称，按格式规范填写":   `Il nuovo prezzo deve includere il nome del prezzo e rispettare il formato specificato`,
"时段电价/确定要将此电价设置为默认吗":   `Sei sicuro di voler impostare questo prezzo come predefinito?`,
"时段电价/当前电价已更新":   `Il prezzo attuale è stato aggiornato`,
"时段电价/是否删除该电价记录":   `Sei sicuro di voler eliminare questo record di prezzo?`,
"时段电价/删除成功":   `Eliminazione Riuscita`,
"时段电价/确定":   `Conferma`,
"时段电价/取消":   `Annulla`,
"时段电价/提示":   `Avviso`,
"时段电价/电价名称示例":   `Esempio Nome Prezzo`,
"时段电价/选择月份":   `Seleziona Mese`,
"时段电价/同步国网电价":   `Sincronizza Prezzo Rete Nazionale`,
"时段电价/请输入电价名称":   `Inserisci Nome Prezzo`,
"时段电价/请选择日期":   `Seleziona Data`,
"时段电价/充电":   `Carica`,
"时段电价/放电":   `Scarica`,
"时段电价/同步成功":   `Sincronizzazione Riuscita`,
"时段电价/暂无国网电价，以新增为准":   `Nessun Prezzo Rete Nazionale, aggiungi come nuovo`,
"时段电价/新增成功":   `Aggiunta Riuscita`,
"时段电价/尖峰时段":   `Periodo Picco Massimo`,
"时段电价/高峰时段":   `Periodo Picco`,
"时段电价/平时段":   `Periodo Normale`,
"时段电价/低谷时段":   `Periodo Valle`,
"时段电价/深谷时段":   `Periodo Valle Profonda`,
"时段电价/充放电状态":   `Stato Carica-Scarica`,
"时段电价/时段":   `Periodo`,
"时段电价/电价(元)":   `Prezzo (Yuan)`,
"时段电价/充放":   `Carica-Scarica`,
"时段电价/充":   `Carica`,
"时段电价/放":   `Scarica`,
"时段电价/时段电价设置提示":   `Imposta Prezzo Periodico, Passo 1: Seleziona Data a sinistra, Passo 2: Configura Prezzo a destra. Doppio click sulla data a sinistra per inserire il prezzo nella tabella`,
"时段电价/全选":   `Seleziona Tutto`,
"时段电价/月":   `Mese`,
"时段电价/清空已选":   `Cancella Selezionati`,
"时段电价/上个月":   `Mese Scorso`,
"时段电价/今天":   `Oggi`,
"时段电价/下个月":   `Mese Prossimo`,
"时段电价/已经是最后一个时段":   `Ultimo Periodo Raggiunto`,
"时段电价/请检查时间格式":   `Controlla Formato Ora`,
"时段电价/到":   `A`,
"时段电价/开始时间":   `Ora Inizio`,
"时段电价/结束时间":   `Ora Fine`,
"时段电价/时间":   `Ora`,
"时段电价/电价(元/kWh)":   `Prezzo (Yuan/kWh)`,
"时段电价/元/kWh":   `Yuan/kWh`,
"时段电价/添加":   `Aggiungi`,
"时段电价/删除":   `Elimina`,
"时段电价/暂无数据":   `Nessun dato`,
"时段电价/请选择要设置的日期":   `Seleziona data`,
"时段电价/设置成功":   `Impostazione riuscita`,
"时段电价/正在保存,请稍后":   `Salvataggio in corso, attendere`,
"时段电价/请选择生效日期":   `Seleziona data effettiva`,
"时段电价/生效日期不能与已有日期重叠":   `La data effettiva non può sovrapporsi a date esistenti`,
"时段电价/电价时段未覆盖 0-24h":   `Il periodo di prezzo non copre 0-24h`,
"时段电价/重新计算中，请稍候":   `Ricalcolo in corso, attendere`,
"时段电价/确定要删除吗?":   `Confermi l'eliminazione?`,
"时段电价/序号":   `No`,
"时段电价/时段名称":   `Nome periodo`,
"时段电价/电价":   `Prezzo`,
"时段电价/请选择名称":   `Seleziona nome`,
"时段电价/请选择颜色":   `Seleziona colore`,
"时段电价/选择颜色":   `Scegli colore`,
"时段电价/生效日期":   `Data effettiva`,
"时段电价/电价历史":   `Cronologia prezzi`,
"时段电价/创建电价":   `Crea prezzo`,
"时段电价/创建/编辑电价":   `Crea/Modifica prezzo`,
"时段电价/正在重新计算收益，请稍等":   `Ricalcolo profitto in corso, attendere`,
"时段电价/状态":   `Stato`,
"时段电价/开始日期":   `Data inizio`,
"时段电价/结束日期":   `Data fine`,
"时段电价/操作人":   `Operatore`,
"时段电价/操作时间":   `Ora operazione`,
"时段电价/已生效":   `Effettivo`,
"时段电价/已删除":   `Eliminato`,
"数据补录/能量链":   `eLink`,
"数据补录/时间段":   `Ora`,
"数据补录/选择数据类型":   `Seleziona tipo di dato`,
"数据补录/请输入备注":   `Inserisci nota`,
"数据补录/开始":   `Inizio`,
"数据补录/传输历史":   `Cronologia trasmissione`,
"数据补录/操作人":   `Operatore`,
"数据补录/操作时间":   `Ora operazione`,
"数据补录/起始时间-结束时间":   `Ora inizio - Ora fine`,
"数据补录/数据类型":   `Tipo di dato`,
"数据补录/传输结果":   `Risultato trasmissione`,
"数据补录/备注":   `Nota`,
"数据补录/操作":   `Operazione`,
"数据补录/删除":   `Elimina`,
"数据补录/eLink数据":   `Dati eLink`,
"数据补录/eBlock数据":   `Dati eBlock`,
"数据补录/电芯数据":   `Dati Cella`,
"数据补录/电表数据":   `Dati Contatore`,
"数据补录/无任何数据得到重传":   `Nessun Dato Ritrasmesso`,
"数据补录/部分数据得到重传":   `Parte dei Dati Ritrasmessi`,
"数据补录/所有数据都得到了重传":   `Tutti i Dati Ritrasmessi`,
"数据补录/请求数据格式错误":   `Errore Formato Richiesta Dati`,
"数据补录/数据正在补充中":   `Dati in Integrazione`,
"数据补录/确认补录?":   `Confermare Integrazione?`,
"数据补录/确认删除?":   `Confermare Eliminazione?`,
"数据补录/删除成功":   `Eliminazione Riuscita`,
"站级监控/空状态":   `Vuoto`,
"站级监控/停机":   `Fermo`,
"站级监控/待机":   `Inattivo`,
"站级监控/充电":   `Carica`,
"站级监控/放电":   `Scarica`,
"站级监控/降额":   `Degrado`,
"站级监控/告警":   `Allarme`,
"站级监控/故障":   `Guasto`,
"站级监控/正常":   `Normale`,
"站级监控/关机":   `Spento`,
"站级监控/初始状态":   `Stato Iniziale`,
"站级监控/正常状态":   `Stato Normale`,
"站级监控/禁充":   `Carica Vietata`,
"站级监控/禁放":   `Scarica Vietata`,
"站级监控/报警":   `Allarme`,
"站级监控/未知":   `Sconosciuto`,
"站级监控/提示":   `Avviso`,
"站级监控/建议":   `Consiglio`,
"站级监控/设备无该配置":   `Apparecchiatura senza Questa Configurazione`,
"站级监控/系统正常":   `Sistema Normale`,
"站级监控/系统故障":   `Guasto al Sistema`,
"站级监控/通信故障":   `Guasto alla Comunicazione`,
"站级监控/液位正常":   `Livello Liquido Normale`,
"站级监控/未喷洒":   `Non Spruzzare`,
"站级监控/制热":   `Riscaldamento`,
"站级监控/制冷":   `Raffreddamento`,
"站级监控/除湿":   `Deumidificazione`,
"站级监控/送风":   `Soffio`,
"站级监控/开关机":   `Accensione-spegnimento`,
"站级监控/BMU故障":   `Guasto BMU`,
"站级监控/BMU告警":   `Allarme BMU`,
"站级监控/电池电压故障":   `Guasto tensione batteria`,
"站级监控/电池电压告警":   `Allarme tensione batteria`,
"站级监控/电池温度故障":   `Guasto temperatura batteria`,
"站级监控/电池温度告警":   `Allarme temperatura batteria`,
"站级监控/柜体通信故障":   `Guasto comunicazione armadio`,
"站级监控/柜体通信告警":   `Allarme comunicazione armadio`,
"站级监控/直流接触器":   `Contattore CC`,
"站级监控/充放电过流":   `Sovracorrente carica-scarica`,
"站级监控/电流传感器故障":   `Guasto sensore corrente`,
"站级监控/绝缘故障":   `Guasto isolamento`,
"站级监控/火灾":   `Incendio`,
"站级监控/水冷空调故障":   `Guasto climatizzatore raffreddamento ad acqua`,
"站级监控/水冷空调告警":   `Allarme climatizzatore raffreddamento ad acqua`,
"站级监控/门禁":   `Controllo accessi`,
"站级监控/烟感":   `Sensore fumo`,
"站级监控/温感":   `Sensore temperatura`,
"站级监控/气溶胶":   `Aerosol`,
"站级监控/SOC高":   `SOC alto`,
"站级监控/SOC低":   `SOC basso`,
"站级监控/电箱气溶胶":   `Aerosol scatola elettrica`,
"站级监控/水箱缺水":   `Serbatoio acqua insufficiente`,
"站级监控/通信板24V电压低":   `Tensione 24V scheda comunicazione bassa`,
"站级监控/消防中继在线状态":   `Stato online relè incendio`,
"站级监控/一级预警":   `Preallarme livello 1`,
"站级监控/二级预警":   `Preallarme livello 2`,
"站级监控/三级预警":   `Preallarme livello 3`,
"站级监控/液位低":   `Livello liquido basso`,
"站级监控/正在喷洒":   `Spruzzatura`,
"站级监控/热失控":   `Fuga termica`,
"站级监控/异常":   `Anomalia`,
"站级监控/按下":   `Pressione`,
"站级监控/设备ID":   `ID apparecchiatura`,
"站级监控/当前功率":   `Potenza corrente`,
"站级监控/设置功率":   `Potenza impostata`,
"站级监控/单设备":   `Apparecchiatura singola`,
"站级监控/汇总":   `Riepilogo`,
"站级监控/Pack消防预警级别":   `LIVELLO DI PREALLARME INCENDIO PACK`,
"站级监控/Pack温度":   `TEMPERATURA PACK`,
"站级监控/Pack湿度":   `UMIDITÀ PACK`,
"站级监控/Pack状态":   `STATO PACK`,
"站级监控/消防探测器在线状态":   `STATO ONLINE RILEVATORE INCENDI`,
"站级监控/voc(可燃气体浓度)":   `COV (Composti Organici Volatili)`,
"站级监控/水冷":   `RAFFREDDAMENTO A LIQUIDO`,
"站级监控/开关机状态":   `STATO ACCENSIONE/SPEGNIMENTO`,
"站级监控/空调机组状态":   `STATO GRUPPO CONDIZIONATORE`,
"站级监控/湿度":   `UMIDITÀ`,
"站级监控/回风温度":   `TEMPERATURA ARIA DI RITORNO`,
"站级监控/回风温度详情":   `TEMPERATURA ARIA DI RITORNO DETTAGLI`,
"站级监控/外风机":   `TURBINA ESTERNA`,
"站级监控/膨胀阀":   `VALVOLA DI ESPANSIONE`,
"站级监控/加热器":   `RISCALDATORE`,
"站级监控/蒸发器":   `EVAPORATORE`,
"站级监控/蒸发温度":   `TEMPERATURA EVAPORATORE`,
"站级监控/压缩机高低压开关":   `INTERRUTTORE TENSIONE ALTA/BASSA COMPRESSORE`,
"站级监控/过欠压模块":   `MODULO SOTTO TENSIONE`,
"站级监控/冷凝器":   `CONDENSATORE`,
"站级监控/内风机":   `TURBINA INTERNA`,
"站级监控/空调厂家信息":   `PRODUTTORE CONDIZIONATORE`,
"站级监控/空调产品型号":   `MODELLO PRODOTTO CONDIZIONATORE`,
"站级监控/空调软件版本":   `VERSIONE SOFTWARE CONDIZIONATORE`,
"站级监控/柜内温度":   `TEMPERATURA ARMADIO INTERNO`,
"站级监控/冷凝器温度":   `TEMPERATURA CONDENSATORE`,
"站级监控/蒸发器温度":   `TEMPERATURA EVAPORATORE`,
"站级监控/柜外温度":   `TEMPERATURA ARMADIO ESTERNO`,
"站级监控/交流电压":   `TENSIONE AC`,
"站级监控/内风机转速":   `VELOCITÀ TURBINA INTERNA`,
"站级监控/外风机转速":   `VELOCITÀ TURBINA ESTERNA`,
"站级监控/湿度值":   `UMIDITÀ`,
"站级监控/制冷开启温度":   `TEMPERATURA INIZIO REFRIGERAZIONE`,
"站级监控/制冷停止温度":   `TEMPERATURA FINE REFRIGERAZIONE`,
"站级监控/制热开启温度":   `TEMPERATURA INIZIO RISCALDAMENTO`,
"站级监控/制热停止温度":   `TEMPERATURA FINE RISCALDAMENTO`,
"站级监控/柜内高温告警点":   `ALLARME ALTA TEMPERATURA ARMADIO INTERNO`,
"站级监控/柜内低温告警点":   `ALLARME BASSA TEMPERATURA ARMADIO INTERNO`,
"站级监控/冷凝器温度高温保护点":   `PROTEZIONE ALTA TEMPERATURA CONDENSATORE`,
"站级监控/蒸发器温度冻结保护点":   `PROTEZIONE GELO EVAPORATORE`,
"站级监控/除湿开启湿度":   `UMIDITÀ INIZIO DEUMIDIFICAZIONE`,
"站级监控/除湿停止湿度":   `Disattiva Deumidificazione Umidità`,
"站级监控/湿度告警限制":   `Limite Allarme Umidità`,
"站级监控/湿度校正值":   `Valore Calibrazione Umidità`,
"站级监控/除湿开启温度":   `Temperatura Avvio Deumidificazione`,
"站级监控/除湿停止温度":   `Temperatura Arresto Deumidificazione`,
"站级监控/制冷状态":   `Stato Refrigerazione`,
"站级监控/内风机状态":   `Stato Ventilatore Interno`,
"站级监控/外风机状态":   `Stato Ventilatore Esterno`,
"站级监控/应急风机状态":   `Stato Ventilatore Emergenza`,
"站级监控/预留开关量1输出":   `Valore Uscita Interruttore Riservato 1`,
"站级监控/预留开关量2输出":   `Valore Uscita Interruttore Riservato 2`,
"站级监控/监控关机":   `Arresto Monitoraggio`,
"站级监控/除湿状态":   `Stato Deumidificazione`,
"站级监控/压缩机状态":   `Stato Compressore`,
"站级监控/加热器状态":   `Stato Riscaldatore`,
"站级监控/柜内传感器故障":   `Guasto Sensore Interno Armadio`,
"站级监控/蒸发器温度传感器故障":   `Guasto Sensore Temperatura Evaporatore`,
"站级监控/冷凝器温度传感器故障":   `Guasto Sensore Temperatura Condensatore`,
"站级监控/柜外温度传感器故障":   `Guasto Sensore Temperatura Esterna Armadio`,
"站级监控/湿度传感器故障":   `Guasto Sensore Umidità`,
"站级监控/湿度过高告警":   `Allarme Umidità Extra Alta`,
"站级监控/内风机告警":   `Allarme Ventilatore Interno`,
"站级监控/外风机告警":   `Allarme Ventilatore Esterno`,
"站级监控/空调门禁告警":   `Allarme Ingresso Condizionatore`,
"站级监控/冷凝器高压告警":   `Allarme Alta Pressione Condensatore`,
"站级监控/蒸发器冻结告警":   `Allarme Evaporatore Congelato`,
"站级监控/制冷告警（压缩机&制冷系统告警）":   `Allarme Refrigerazione (Allarme Compressore & Sistema Refrigerazione)`,
"站级监控/高温告警":   `Allarme Alta Temperatura`,
"站级监控/低温告警":   `Allarme Bassa Temperatura`,
"站级监控/加热器告警":   `Allarme Riscaldatore`,
"站级监控/过电压告警":   `Allarme Sovratensione`,
"站级监控/欠电压告警":   `Allarme Sottotensione`,
"站级监控/高低电压告警":   `Allarme Alta-Bassa Tensione`,
"站级监控/高低压力告警":   `Allarme Alta-Bassa Pressione`,
"站级监控/高低温度告警":   `Allarme Alta-Bassa Temperatura`,
"站级监控/eBlock序号":   `Ordine eBlock`,
"站级监控/eBlock型号":   `Modello eBlock`,
"站级监控/查看":   `Visualizza`,
"站级监控/关闭":   `Chiudi`,
"站级监控/离线":   `Offline`,
"站级监控/在线":   `Online`,
"站级监控/开启":   `Avvio`,
"站级监控/停止":   `Arresto`,
"站级监控/运行":   `Esecuzione`,
"站级监控/空调参数":   `Parametro Condizionatore`,
"站级监控/冷凝温度":   `Temperatura Condensatore`,
"站级监控/总功率":   `Potenza Totale`,
"站级监控/选择设备":   `Seleziona Dispositivo`,
"站级监控/重置":   `Ripristina`,
"站级监控/功率曲线":   `Curva di Potenza`,
"站级监控/CO2减排量":   `Riduzione CO2`,
"站级监控/节约标准煤":   `Risparmio Carbone Standard`,
"站级监控/减少森林砍伐":   `Riduzione Forestale`,
"站级监控/吨":   `Tonnellata`,
"站级监控/棵":   `Albero`,
"站级监控/日充电量":   `Energia di Ricarica Giornaliera`,
"站级监控/日放电量":   `Energia di Scarica Giornaliera`,
"站级监控/电量":   `Energia`,
"站级监控/电量统计":   `Statistiche Energia`,
"站级监控/节能减排":   `Risparmio Energetico e Riduzione Emissioni`,
"站级监控/功率跟踪":   `Monitoraggio Potenza`,
"站级监控/SOC曲线":   `Curva SOC`,
"站级监控/独立逆变":   `Inverter Indipendente`,
"站级监控/直流恒功率":   `Potenza CC Costante`,
"站级监控/直流恒压":   `Tensione CC Costante`,
"站级监控/交流恒压":   `Tensione CA Costante`,
"站级监控/直流恒流":   `Corrente CC Costante`,
"站级监控/交流恒流":   `Corrente CA Costante`,
"站级监控/老化模式":   `Modalità Invecchiamento`,
"站级监控/自检":   `Autoverifica`,
"站级监控/小时":   `Ora`,
"站级监控/分":   `Minuto`,
"站级监控/IGBT-A温度":   `Temperatura Fase IGBT-A`,
"站级监控/IGBT-B温度":   `Temperatura Fase IGBT-B`,
"站级监控/IGBT-C温度":   `Temperatura Fase IGBT-C`,
"站级监控/电网信息":   `Informazioni Rete`,
"站级监控/系统状态":   `Stato Sistema`,
"站级监控/电池功率":   `Potenza Batteria`,
"站级监控/重要负载功率":   `Potenza Carico Importante`,
"站级监控/光伏功率":   `Potenza Fotovoltaica`,
"站级监控/BMU状态帧丢失计数":   `Numero di perdita frame stato BMU`,
"站级监控/BMU均衡帧丢失计数":   `Numero di perdita frame bilanciamento BMU`,
"站级监控/BMU电压帧丢失计数":   `Numero di perdita frame tensione BMU`,
"站级监控/BMU温度帧丢失计数":   `Numero di perdita frame temperatura BMU`,
"站级监控/BMU帧芯片丢失计数":   `Numero di perdita frame chip BMU`,
"站级监控/BMU帧pack丢失计数":   `Numero di perdita frame pacco BMU`,
"站级监控/BMS算法版本":   `Versione algoritmo BMS`,
"站级监控/SOE算法版本":   `Versione algoritmo SOE`,
"站级监控/SOH算法版本":   `Versione algoritmo SOH`,
"站级监控/SOP算法版本":   `Versione algoritmo SOP`,
"站级监控/SOS算法版本":   `Versione algoritmo SOS`,
"站级监控/被动均衡算法版本":   `Versione algoritmo bilanciamento passivo`,
"站级监控/CLB算法版本":   `Versione algoritmo CLB`,
"站级监控/电池最高电压":   `Tensione massima batteria`,
"站级监控/电池最低电压":   `Tensione minima batteria`,
"站级监控/电池最高温度":   `Temperatura massima batteria`,
"站级监控/电池最低温度":   `Temperatura minima batteria`,
"站级监控/eBlock消防主机状态":   `Stato computer antincendio eBlock`,
"站级监控/eBlock消防抑制剂液位状态":   `Stato livello liquido inibitore eBlock`,
"站级监控/eBlock消防喷洒状态":   `Stato spruzzo antincendio eBlock`,
"站级监控/Pack消防信息":   `Informazioni Antincendio Pack`,
"站级监控/补电": 'Carica',
'站级监控/电池仓': 'Armadio Batteria',
"生产概览/按日":   `Giornaliero`,
"生产概览/按月":   `Mensile`,
"生产概览/按年":   `Annuale`,
"生产概览/日期":   `Data`,
"生产概览/至":   `A`,
"生产概览/查询":   `Cerca`,
"生产概览/导出":   `Scarica`,
"生产概览/重置":   `Ripristina`,
"生产概览/节省电费":   `Risparmio`,
"生产概览/充电量":   `Energia di carica`,
"生产概览/放电量":   `Energia di scarica`,
"生产概览/充放电效率":   `Efficienza carica-scarica`,
"生产概览/充放电量统计":   `Energia carica-scarica`,
"生产概览/全部":   `Totale`,
"生产概览/柱状图":   `Istogramma`,
"生产概览/表格":   `Tabella`,
"生产概览/收益":   `Guadagno`,
"生产概览/电量":   `Energia`,
"生产概览/储能收益柱状图":   `Istogramma guadagni accumulo energia`,
"生产概览/放电（尖峰）":   `Scarica (picco)`,
"生产概览/放电（高峰）":   `Scarica(Picco)`,
"生产概览/放电（平）":   `Scarica(Piano)`,
"生产概览/放电（低谷）":   `Scarica(Valle)`,
"生产概览/放电（深谷）":   `Scarica(Valle Profonda)`,
"生产概览/充电（尖峰）":   `Carica(Punta)`,
"生产概览/充电（高峰）":   `Carica(Picco)`,
"生产概览/充电（平）":   `Carica(Piano)`,
"生产概览/充电（低谷）":   `Carica(Valle)`,
"生产概览/充电（深谷）":   `Carica(Valle Profonda)`,
"生产概览/时间":   `Data`,
"生产概览/效率":   `Efficienza`,
"生产概览/总放电":   `Energia Totale di Scarica`,
"生产概览/总充电":   `Energia Totale di Carica`,
"生产概览/元":   `Yuan`,
"生产概览/电价":   `Prezzo dell'Elettricità`,
"生产概览/充电":   `Carica`,
"生产概览/放电":   `Scarica`,
"生产概览/类型":   `Tipo`,
"生产概览/尖峰":   `Punta`,
"生产概览/高峰":   `Picco`,
"生产概览/平":   `Piano`,
"生产概览/低谷":   `Valle`,
"生产概览/深谷":   `Valle Profonda`,
"生产概览/储能收益统计":   `Statistiche dei Guadagni dall'Accumulo di Energia`,
"生产概览/总":   `Totale`,
"告警信息/离线告警":   `Allarme Offline`,
"告警信息/非计划运行":   `Operazione Non Pianificata`,
"告警信息/故障预警":   `Preallarme Guasto`,
"告警信息/故障历史":   `Cronologia Guasti`,
"告警信息/起始时间":   `Data`,
"告警信息/告警等级":   `Livello di Allarme`,
"告警信息/全部":   `Totale`,
"告警信息/查询":   `Cerca`,
"告警信息/重置":   `Ripristina`,
"告警信息/设备名称":   `Nome dell'Attrezzatura`,
"告警信息/设备UUID":   `UUID dell'Attrezzatura`,
"告警信息/故障等级":   `Livello del Guasto`,
"告警信息/故障属性":   `Attributo del Guasto`,
"告警信息/故障动作":   `Azione del Guasto`,
"告警信息/持续时间":   `Durata`,
"告警信息/故障描述":   `Descrizione del Guasto`,
"告警信息/故障码":   `Codice del Guasto`,
"告警信息/备注":   `Osservazione`,
"告警信息/时间":   `Ora`,
"告警信息/请输入设备名称":   `Inserisci il Nome dell'Apparecchiatura`,
"告警信息/设备ID":   `ID dell'Apparecchiatura`,
"告警信息/请输入设备ID":   `Inserisci l'ID dell'Apparecchiatura`,
"告警信息/类型":   `Tipo`,
"告警信息/请选择类型":   `Seleziona il Tipo`,
"告警信息/整站":   `Stazione Completa`,
"告警信息/能量链":   `eLink`,
"告警信息/能量块":   `eBlock`,
"告警信息/电表":   `Contatore`,
"告警信息/至":   `A`,
"告警信息/开始时间":   `Ora di Inizio`,
"告警信息/结束时间":   `Ora di Fine`,
"告警信息/提示":   `Nota`,
"告警信息/告警":   `Allarme`,
"告警信息/故障":   `Guasto`,
"告警信息/严重故障":   `Guasto Grave`,
"告警信息/请输入备注":   `Inserisci un'Osservazione`,
"告警信息/告警确认":   `Conferma Allarme`,
"告警信息/确认中...":   `Conferma in Corso...`,
"告警信息/告警已确认":   `Allarme Confermato`,
"告警管理/实时告警":   `Allarme in Tempo Reale`,
"告警管理/告警历史":   `Cronologia Allarmi`,
"告警管理/起始时间":   `Data`,
"告警管理/告警等级":   `Livello di Allarme`,
"告警管理/故障动作":   `Azione sul Guasto`,
"告警管理/能量链":   `eLink`,
"告警管理/能量块":   `eBlock`,
"告警管理/查询":   `Cerca`,
"告警管理/重置":   `Ripristina`,
"告警管理/导出":   `Scarica`,
"告警管理/上报时间":   `Ora del Rapporto`,
"告警管理/故障编码表":   `Tabella dei Codici di Guasto`,
"告警管理/请输入故障编码":   `Inserisci il Codice di Guasto`,
"告警管理/设备名称":   `Nome dell'Apparecchiatura`,
"告警管理/设备UUID":   `ID dell'Apparecchiatura`,
"告警管理/故障等级":   `Livello del Guasto`,
"告警管理/故障属性":   `Attributo di Guasto`,
"告警管理/持续时间":   `Durata`,
"告警管理/状态":   `Stato`,
"告警管理/审核人":   `Revisore`,
"告警管理/审核时间":   `Tempo di Revisione`,
"告警管理/故障描述":   `Descrizione del Guasto`,
"告警管理/备注":   `Nota`,
"告警管理/操作":   `Operazione`,
"告警管理/全部":   `Totale`,
"告警管理/提示":   `Osservazione`,
"告警管理/告警":   `Allarme`,
"告警管理/故障":   `Guasto`,
"告警管理/严重故障":   `Guasto Grave`,
"告警管理/故障触发":   `Attivazione del Guasto`,
"告警管理/故障消失":   `Scomparsa del Guasto`,
"告警管理/新增":   `Aggiungi`,
"告警管理/设备类型":   `Modello dell'Attrezzatura`,
"告警管理/故障详情":   `Dettagli del Guasto`,
"告警管理/编辑":   `Modifica`,
"告警管理/删除":   `Elimina`,
"告警管理/修改故障编码":   `Modifica Codice di Guasto`,
"告警管理/故障编码":   `Codice di Guasto`,
"告警管理/取消":   `Annulla`,
"告警管理/确定":   `Conferma`,
"告警管理/编码":   `Codice`,
"告警管理/请输入编码搜索":   `Inserisci Codice per Cercare`,
"告警管理/绝缘阻抗低":   `Impedenza di Isolamento Bassa`,
"告警管理/电池正负极绝缘阻抗值过低":   `Impedenza di Isolamento Positiva/Negativa della Batteria Molto Bassa`,
"告警管理/直流接触器断开":   `Interruzione del Contattore in Corrente Continua`,
"告警管理/直流断路器未闭合":   `Interruttore in Corrente Continua Non Chiuso`,
"告警管理/逆变相序错误":   `Fallimento dell'Ordine dell'Inverter`,
"告警管理/PCS内部逆变相序错误":   `Fallimento dell'Ordine dell'Inverter Interno al PCS`,
"告警管理/逆变电压异常":   `Tensione dell'Inverter Anomala`,
"告警管理/逆变电压软起失败":   `Fallimento dell'Avvio Dolce dell'Inverter`,
"告警管理/交流电压采样故障":   `Guasto al Campionamento della Tensione Alternata`,
"告警管理/交流电压采样值异常":   `Valore di Campionamento della Tensione Alternata Anomalo`,
"告警管理/直流母线电压异常":   `Tensione del Bus in Corrente Continua Anomala`,
"告警管理/直流电压采样值异常":   `Valore di Campionamento della Tensione Continua Anomalo`,
"告警管理/交流电流异常":   `Corrente Alternata Anomala`,
"告警管理/交流电流采样值异常":   `Valore di Campionamento della Corrente Alternata Anomalo`,
"告警管理/直流电流异常":   `Corrente Continua Anomala`,
"告警管理/直流电流采样值异常":   `Valore di Campionamento Corrente Continua Anomalo`,
"告警管理/电池正负极反接":   `Inversione Polo Positivo/Negativo Batteria`,
"告警管理/直流正负极接反":   `Inversione Polo Positivo/Negativo Corrente Continua`,
"告警管理/故障录波存储故障":   `Memoria Registratore Guasti Difettosa`,
"告警管理/铁电存储器故障（故障录播功能）":   `Guasto FRAM (Funzione Registrazione Guasti)`,
"告警管理/参数设置存储故障":   `Memoria Set Parametri Difettosa`,
"告警管理/EEPROM存储故障，换机":   `Guasto Memoria EEPROM, Cambiare Macchina`,
"告警管理/交流AC辅源24V异常":   `Ausiliario AC 24V Anomalo`,
"告警管理/直流DC辅源24V异常":   `Ausiliario DC 24V Anomalo`,
"告警管理/辅源停机故障":   `Guasto Arresto Ausiliario`,
"告警管理/并机通信故障":   `Guasto Comunicazione Macchine Parallele`,
"告警管理/并机CAN通信故障":   `Guasto Comunicazione CAN Macchine Parallele`,
"告警管理/BCS通信故障（485端口）":   `Guasto Comunicazione BCS (Porta 485)`,
"告警管理/RS485与BCS通信故障":   `Guasto Comunicazione RS485 e BCS`,
"告警管理/CPU1与CPU2通信故障":   `Guasto Comunicazione CPU1 e CPU2`,
"告警管理/FPGA通信故障":   `Guasto Comunicazione FPGA`,
"告警管理/DSP与FPGA通信故障":   `Guasto Comunicazione DSP e FPGA`,
"告警管理/接口板通信故障":   `Guasto Comunicazione Scheda Interfaccia`,
"告警管理/相对地短路故障":   `Guasto Cortocircuito Fase-Terra`,
"告警管理/发生电网单相对地短路故障":   `Guasto Cortocircuito Monofase-Terra Rete`,
"告警管理/电网相序错误":   `Guasto Ordine Rete`,
"告警管理/电网相序接线错误":   `Guasto Cavo Ordine Rete`,
"告警管理/三相电流不均衡":   `Squilibrio Corrente Trifase`,
"告警管理/交流三相电流不平衡":   `Squilibrio Corrente Alternata Trifase`,
"告警管理/模块ID错误":   `Fallimento ID Modulo`,
"告警管理/并机模块地址设置异常(超过最大值10)":   `Indirizzo Modulo Macchine Parallele Anomalo (Oltre Max 10)`,
"告警管理/电网谐振关机":   `Sintonizzazione Rete Spenta`,
"告警管理/并网电流发生谐振，电流谐波过大":   `Sintonizzazione Corrente Connessione Rete Rilevata, Armoniche Corrente Eccessive`,
"告警管理/直流分量告警":   `Allarme Componente Continua`,
"告警管理/并网电流直流分量超标":   `Componente Continua Connessione Rete Fuori Standard`,
"告警管理/机型、系列号、版本信息参数异常":   `Parametri Modello, Numero Seriale, Versione Anomali`,
"告警管理/产品未被授权":   `Prodotto Non Autorizzato`,
"告警管理/程序升级":   `Aggiornamento Programma`,
"告警管理/程序正在接收升级数据":   `Ricezione Dati Aggiornamento Programma`,
"告警管理/电网电压高":   `Tensione Rete Alta`,
"告警管理/电网有效值过高告警":   `Allarme Valore Efficace Rete Eccessivamente Alto`,
"告警管理/电网电压低":   `Tensione Rete Bassa`,
"告警管理/电网有效值过低告警":   `Allarme Valore Efficace Rete Eccessivamente Basso`,
"告警管理/电网频率高":   `Frequenza Rete Alta`,
"告警管理/电网频率过高告警":   `Allarme Frequenza di Rete Molto Alta`,
"告警管理/电网频率低":   `Frequenza di Rete Bassa`,
"告警管理/电网频率过低告警":   `Allarme Frequenza di Rete Molto Bassa`,
"告警管理/直流母线电压高":   `Tensione Bus Corrente Continua Alta`,
"告警管理/直流母线电压过高":   `Tensione Bus Corrente Continua Molto Alta`,
"告警管理/直流母线电压低":   `Tensione Bus Corrente Continua Bassa`,
"告警管理/直流母线电压过低":   `Tensione Bus Corrente Continua Molto Bassa`,
"告警管理/直流输入电压高":   `Tensione Ingresso Corrente Continua Molto Bassa`,
"告警管理/直流电池电压过高告警":   `Allarme Tensione Batteria Corrente Continua Molto Alta`,
"告警管理/直流输入电压低":   `Tensione Ingresso Corrente Continua Bassa`,
"告警管理/直流电池电压过低告警":   `Allarme Tensione Batteria Corrente Continua Molto Bassa`,
"告警管理/软起电路故障":   `Guasto Circuito Soft Start`,
"告警管理/直流母线电压软起故障，换机":   `Guasto Soft Start Tensione Bus CC, Cambiare Macchina`,
"告警管理/直流母线连接故障":   `Guasto Collegamento Bus CC`,
"告警管理/正负母线偏压故障":   `Guasto Tensione di Polarizzazione Bus Positivo/Negativo`,
"告警管理/环境温度过高":   `Temperatura Ambiente Molto Alta`,
"告警管理/PCS内部腔体温度＞80℃":   `Temperatura Interna PCS > 80℃`,
"告警管理/环境温度过低":   `Temperatura Ambiente Molto Alta`,
"告警管理/A相IGBT温度过高":   `Temperatura IGBT Fase A > 95℃`,
"告警管理/IGBTA温度＞95℃":   `Temperatura IGBT Fase B Molto Alta`,
"告警管理/B相IGBT温度过高":   `Temperatura IGBT Fase B Molto Alta`,
"告警管理/C相IGBT温度过高":   `Temperatura IGBT Fase C Molto Alta`,
"告警管理/A相IGBT-NTC故障":   `Guasto NTC IGBT Fase A`,
"告警管理/IGBTA温度检测电路故障":   `Guasto Circuito Controllo Temperatura IGBT A`,
"告警管理/B相IGBT-NTC故障":   `Guasto NTC IGBT Fase B`,
"告警管理/IGBTB温度检测电路故障":   `Guasto Circuito Controllo Temperatura IGBT B`,
"告警管理/C相IGBT-NTC故障":   `Guasto NTC IGBT Fase C`,
"告警管理/IGBTC温度检测电路故障":   `Guasto Circuito Controllo Temperatura IGBT C`,
"告警管理/环境温度传感器故障":   `Guasto Sensore Temperatura Ambiente`,
"告警管理/IGBT温度过温降额":   `Derating per Sovratemperatura IGBT`,
"告警管理/环境温度降额":   `Derating per Temperatura Ambiente`,
"告警管理/IGBT温度不平衡":   `Squilibrio Temperatura IGBT`,
"告警管理/IGBT温度差异＞10℃":   `Differenza Temperatura IGBT > 10℃`,
"告警管理/IGBT温度过低":   `Temperatura IGBT Molto Bassa`,
"告警管理/IGBT温度过低降额":   `Derating per Temperatura IGBT Molto Bassa`,
"告警管理/任一IGBT温度小于-25℃":   `Temperatura Qualsiasi IGBT < -25℃`,
"告警管理/直流输入过压":   `Sovratensione Ingresso Corrente Continua`,
"告警管理/直流母线过压":   `Sovratensione Bus Corrente Continua`,
"告警管理/A相限流保护":   `Protezione Limite Corrente Fase A`,
"告警管理/B相限流保护":   `Protezione Limite Corrente Fase B`,
"告警管理/C相限流保护":   `Protezione da Limite di Corrente Fase C`,
"告警管理/A相过流":   `Sovracorrente Fase A`,
"告警管理/B相过流":   `Sovracorrente Fase B`,
"告警管理/C相过流":   `Sovracorrente Fase C`,
"告警管理/正母线硬件过压":   `Sovratensione Hardware Bus Positivo`,
"告警管理/负母线硬件过压":   `Sovratensione Hardware Bus Negativo`,
"告警管理/直流辅源告警":   `Allarme Ausiliario Corrente Continua`,
"告警管理/交流辅源告警":   `Allarme Ausiliario Corrente Alternata`,
"告警管理/辅源电压与额定电压相差超过10%":   `Differenza Tensione Ausiliaria e Nominale > 10%`,
"告警管理/直流硬件过流":   `Sovracorrente Hardware Corrente Continua`,
"告警管理/直流过流":   `Sovracorrente Corrente Continua`,
"告警管理/急停":   `Arresto di Emergenza`,
"告警管理/PCS外部干接点1急停信号触发":   `Segnale di Arresto Emergenza da Contatto Secco Esterno PCS`,
"告警管理/内部风扇故障":   `Guasto Ventilatore Interno`,
"告警管理/内部风扇故障告警":   `Allarme Guasto Ventilatore Interno`,
"告警管理/外部风扇故障":   `Guasto Ventilatore Esterno`,
"告警管理/外部风机故障告警":   `Allarme Guasto Ventilatore Esterno`,
"告警管理/并机同步信号异常":   `Segnale di Sincronismo Macchine Parallele Anomalo`,
"告警管理/并机CAN同步信号故障":   `Guasto Segnale CAN Sincronismo Macchine Parallele`,
"告警管理/交流防雷":   `Protezione da Fulmine Corrente Alternata`,
"告警管理/交流防雷告警":   `Allarme Protezione da Fulmine Corrente Alternata`,
"告警管理/CPU2-CPU1通信故障":   `Guasto Comunicazione CPU2-CPU1`,
"告警管理/正母线软件过压":   `Sovratensione Software Bus Positivo`,
"告警管理/负母线软件过压":   `Sovratensione Software Bus Negativo`,
"告警管理/锁相环故障":   `Guasto Circuito Blocco Fase`,
"告警管理/软件锁相环故障":   `Guasto Software Circuito Blocco Fase`,
"告警管理/中点不平衡故障":   `Guasto Sbilanciamento Punto Neutro`,
"告警管理/无法响应主MCU命令":   `Fallimento Risposta Comando MCU Master`,
"告警管理/直流电压不适合运行":   `Tensione CC Non Adatta all'Operazione`,
"告警管理/直流电池电压不满足运行条件":   `Tensione Batteria CC Non Soddisfa Condizioni Operative`,
"告警管理/电网电压不适合运行":   `Tensione di Rete Non Adatta all'Operazione`,
"告警管理/电网电压不满足运行条件":   `Tensione di Rete Non Soddisfa Condizioni Operative`,
"告警管理/电网频率不适合运行":   `Frequenza di Rete Non Adatta all'Operazione`,
"告警管理/电网频率不满足运行条件":   `Frequenza di Rete Non Soddisfa Condizioni Operative`,
"告警管理/BCS关机":   `BCS Spento`,
"告警管理/BCS下发关机命令":   `BCS Invia Comando di Spegnimento`,
"告警管理/老化模式启动":   `Avvio Modalità Invecchiamento`,
"告警管理/故障禁止启机":   `Avvio Blocco Guasti`,
"告警管理/不允许再次启机":   `Blocco Nuovo Avvio`,
"告警管理/系统不存在主机":   `Sistema Master Non Esiste`,
"告警管理/并机模式未识别到主机":   `Modalità Macchina Parallela Master Non Identificato`,
"告警管理/绝缘阻抗未检测":   `Impedenza di Isolamento Non Controllata`,
"告警管理/远程关机":   `Spegnimento Remoto`,
"告警管理/功率调度降额":   `Riduzione della Potenza da Dispacciamento`,
"告警管理/0XX ， XX=降额百分比（0~99）":   `0XX, XX=Percentuale di Riduzione (0~99)`,
"告警管理/1XX ， XX=降额百分比（0~99）":   `1XX, XX=Percentuale di Riduzione (0~99)`,
"告警管理/IGBT温度降额":   `Riduzione per Temperatura IGBT`,
"告警管理/3XX ， XX=降额百分比（0~99）":   `3XX, XX=Percentuale di Riduzione (0~99)`,
"告警管理/过载降额":   `Riduzione per Sovraccarico`,
"告警管理/4XX ， XX=降额百分比（0~99）":   `4XX, XX=Percentuale di Riduzione (0~99)`,
"告警管理/PCS通信故障":   `Guasto Comunicazione PCS`,
"告警管理/全部PCS通信故障":   `Guasto Totale Comunicazione PCS`,
"告警管理/BMU通信故障":   `Guasto Comunicazione BMU`,
"告警管理/eLink通信故障":   `Guasto Comunicazione eLink`,
"告警管理/eLink与eBlock通信故障":   `Guasto Comunicazione eLink e eBlock`,
"告警管理/消防监控通信故障":   `Guasto Comunicazione Monitoraggio Antincendio`,
"告警管理/水冷机组通信故障":   `Guasto Comunicazione Unità di Raffreddamento ad Acqua`,
"告警管理/1号或者2号水冷机组通信故障":   `Guasto Comunicazione Unità di Raffreddamento ad Acqua 1# o 2#`,
"告警管理/空调通信故障":   `Guasto Comunicazione Condizionatore d'Aria`,
"告警管理/1号或者2号空调通信故障":   `Guasto Comunicazione Condizionatore d'Aria 1# o 2#`,
"告警管理/H2传感器通信故障":   `Guasto Comunicazione Sensore H2`,
"告警管理/CO2传感器通信故障":   `Guasto Comunicazione Sensore CO2`,
"告警管理/VOC传感器通信故障":   `Guasto Comunicazione Sensore VOC`,
"告警管理/温湿度传感器通信故障":   `Guasto Comunicazione Sensore Temperatura e Umidità`,
"告警管理/水温传感器通信故障":   `Guasto Comunicazione Sensore Temperatura Acqua`,
"告警管理/flash芯片通信故障":   `Guasto Comunicazione Chip Flash`,
"告警管理/电池热失控":   `Fuga Termica Batteria`,
"告警管理/柜体电池热失控":   `Fuga Termica Batteria Armadio`,
"告警管理/电气火灾":   `Incendio Elettrico`,
"告警管理/储能柜体电气火灾":   `Incendio Elettrico Armadio di Accumulo`,
"告警管理/绝缘故障":   `Guasto Isolamento`,
"告警管理/储能柜体绝缘阻抗故障":   `Guasto Impedenza di Isolamento Armadio di Accumulo`,
"告警管理/eBlock柜体锁定":   `Blocco Armadio eBlock`,
"告警管理/消防由eLink主导监测时，发生电池热失控或电气火灾时，eLink对储能柜体执行了锁定动作":   `In Caso di Fuga Termica Batteria o Incendio Elettrico, eLink Blocca l'Armadio di Accumulo Sotto Controllo Antincendio Dominato da eLink`,
"告警管理/eBlock运行模式故障":   `Guasto Modalità Operativa eBlock`,
"告警管理/eBlock372柜体，设为裸机模式时，监测到BMU通信":   `eBlock372 Rileva Comunicazione BMU in Modalità Macchina Nuda`,
"告警管理/传感器通信故障":   `Guasto Comunicazione Sensore`,
"告警管理/电流传感器通信故障":   `Guasto Comunicazione Sensore di Corrente`,
"告警管理/电流传感器故障":   `Guasto Sensore di Corrente`,
"告警管理/电流传感器电流值和PCS电流相差太大":   `Differenza Extra Grande tra Valore Corrente e Corrente PCS nel Sensore di Corrente`,
"告警管理/直流接触器故障":   `Guasto di Contatto in Corrente Continua`,
"告警管理/BCS检测到PCS直流电压合不上，报直流接触器故障":   `BCS Rileva che la Tensione CC del PCS non si Chiude, ma Segnala un Guasto di Contatto Diretto`,
"告警管理/直流总压异常":   `Tensione Totale CC Anomala`,
"告警管理/PCS直流总压和电池总压相差太大":   `Differenza Eccessiva tra Tensione Totale CC del PCS e Tensione Totale della Batteria`,
"告警管理/电池总压过压":   `Tensione Totale della Batteria in Sovratensione`,
"告警管理/电池总压过高":   `Tensione Totale della Batteria Eccessivamente Alta`,
"告警管理/电池总压欠压":   `Tensione Totale della Batteria in Sottotensione`,
"告警管理/电池总压过低":   `Tensione Totale della Batteria Eccessivamente Bassa`,
"告警管理/禁止开机":   `Divieto di Accensione`,
"告警管理/开机旋钮位于禁止开机":   `Pulsante di Accensione Impostato su Divieto`,
"告警管理/柜体急停按下":   `Arresto di Emergenza dell'Armadio Premuto`,
"告警管理/MSD故障":   `Guasto MSD`,
"告警管理/PACK高压信号故障":   `Guasto del Segnale di Alta Tensione del PACK`,
"告警管理/水浸故障":   `Guasto per Allagamento`,
"告警管理/上水浸被水淹没":   `Allagamento Superiore Immergendo in Acqua`,
"告警管理/可燃气体浓度异常":   `Concentrazione VOC Anomala`,
"告警管理/消防气体传感器值超标":   `Sensore Gas Antincendio Oltre lo Standard`,
"告警管理/烟感异常":   `Sensore Fumo Anomalo`,
"告警管理/烟感信号告警":   `Allarme Segnale del Sensore Fumo`,
"告警管理/门禁异常":   `Guardia d'Ingresso Anomala`,
"告警管理/门禁信号告警":   `Allarme Segnale della Guardia d'Ingresso`,
"告警管理/空调工作异常":   `Condizionatore d'Aria Funzionamento Anomalo`,
"告警管理/消防水箱缺水":   `Serbatoio Acqua Antincendio Scarso`,
"告警管理/SOC高":   `SOC Alto`,
"告警管理/电池充电SOC超过设定上限值":   `Carica Batteria SOC Oltre il Limite Superiore`,
"告警管理/SOC低":   `SOC Basso`,
"告警管理/电池放电SOC超过设定下限值":   `Scarica Batteria SOC Sotto il Limite Inferiore`,
"告警管理/SOE高":   `SOE Alto`,
"告警管理/电池充电SOE超过设定上限值":   `Carica Batteria SOE Oltre il Limite Superiore`,
"告警管理/SOE低":   `SOE Basso`,
"告警管理/电池放电SOE超过设定下限值":   `Scarica Batteria SOE Sotto il Limite Inferiore`,
"告警管理/柜体温度1":   `Temperatura dell'Armadio`,
"告警管理/储能柜体温度过高":   `Temperatura di Accumulo Eccessivamente Alta`,
"告警管理/柜体湿度1":   `Umidità dell'Armadio 1`,
"告警管理/储能柜体湿度过高":   `Umidità di Accumulo Eccessivamente Alta`,
"告警管理/储能柜体温度过低":   `Temperatura di Accumulo Eccessivamente Bassa`,
"告警管理/P型设备一台PCS与BCS通信故障":   `Guasto di Comunicazione tra PCS e BCS in un Dispositivo di Tipo P`,
"告警管理/下水浸被水淹没":   `Allagamento Inferiore Immergendo in Acqua`,
"告警管理/水冷机组工作告警":   `Allarme Funzionamento dell'Unità di Raffreddamento ad Acqua`,
"告警管理/0x0001：水冷机组制冷制热告警； 0x0002：水冷机组压力告警； 0x0003：水冷机组制冷制热和压力均告警；":   `0x0001: Allarme Raffreddamento e Riscaldamento nell'Unità di Raffreddamento ad Acqua; 0x0002: Allarme Pressione nell'Unità di Raffreddamento ad Acqua; 0x0003: Allarme Raffreddamento, Riscaldamento e Pressione nell'Unità di Raffreddamento ad Acqua`,
"告警管理/水冷机组工作故障":   `Guasto al funzionamento dell'unità di raffreddamento ad acqua`,
"告警管理/PCS不具备启机条件":   `Condizioni di avvio PCS non soddisfatte`,
"告警管理/PCS交流电压故障。":   `Guasto alla tensione alternata PCS`,
"告警管理/PACK端子温度过温保护":   `Protezione da sovratemperatura terminale PACK`,
"告警管理/PACK正/负极母排端子过温故障":   `Guasto da sovratemperatura terminale bus positivo/negativo PACK`,
"告警管理/PACK端子温度过温告警":   `Allarme sovratemperatura terminale PACK`,
"告警管理/PACK正/负极母排端子过温告警":   `Allarme sovratemperatura terminale bus positivo/negativo PACK`,
"告警管理/PACK端子温度过温提示":   `Notifica sovratemperatura terminale PACK`,
"告警管理/PACK正/负极母排端子过温提示":   `Notifica sovratemperatura terminale bus positivo/negativo PACK`,
"告警管理/BMU采样故障":   `Guasto al campionamento BMU`,
"告警管理/0x0001:第一个BMU采样故障； 0x0002:第二个BMU采样故障； 0x0004:第三个BMU采样故障； 0x0007:第一、二、三个BMU均采样故障。":   `0x0001: Guasto al campionamento del primo BMU; 0x0002: Guasto al campionamento del secondo BMU; 0x0004: Guasto al campionamento del terzo BMU; 0x0007: Guasto al campionamento del primo, secondo e terzo BMU`,
"告警管理/功率回路故障":   `Guasto al circuito di alimentazione`,
"告警管理/eBlock能量块功率回路故障。":   `Guasto al circuito di alimentazione eBlock`,
"告警管理/BMS初始化故障":   `Guasto all'inizializzazione BMS`,
"告警管理/BCS初始化故障":   `Guasto all'inizializzazione BCS`,
"告警管理/门禁故障":   `Guasto al controllo d'accesso`,
"告警管理/门禁故障。（运行模式）":   `Guasto al controllo d'accesso (Modalità operativa)`,
"告警管理/空调故障":   `Guasto al condizionatore d'aria`,
"告警管理/0x0001：第一台空调故障； 0x0002：第二台空调故障； 0x0003：二台空调均故障；":   `0x0001: Guasto al primo condizionatore d'aria; 0x0002: Guasto al secondo condizionatore d'aria; 0x0003: Guasto al primo e secondo condizionatore d'aria`,
"告警管理/均衡启动提示":   `Notifica avvio equalizzazione`,
"告警管理/（1）电池实际衰减和设计控制衰减不一致。默认阈值：3KWh。 （2）启动均衡调整电量差值。":   `(1) La degradazione effettiva della batteria non corrisponde a quella progettata. Soglia predefinita: 3kWh. (2) Avviare l'equalizzazione per regolare la differenza energetica`,
"告警管理/人工补电告警":   `Supplemento energetico manuale`,
"告警管理/（1）电池实际衰减和设计控制衰减不一致。默认阈值：3KWh。 （2）均衡调整3天，电量实际衰减仍无法调整至设计值。":   `(1) La degradazione effettiva della batteria non corrisponde a quella progettata. Soglia predefinita: 3kWh. (2) Equalizzazione regolata per 3 giorni, ma la degradazione effettiva non corrisponde ancora a quella progettata`,
"告警管理/PCS校准异常":   `Calibrazione PCS anomala`,
"告警管理/（1）小功率时，PCS功率不准，导致电池电压抬升。":   `(1) L'imprecisione della potenza PCS provoca un aumento della tensione della batteria quando la potenza è BASSA`,
"告警管理/风机通信告警":   `Allarme comunicazione turbina eolica`,
"告警管理/4&1模块通信告警":   `Allarme comunicazione modulo 4&1`,
"告警管理/除湿机通信告警":   `Allarme comunicazione deumidificatore`,
"告警管理/消防急停通信告警":   `Allarme comunicazione arresto d'emergenza antincendio`,
"告警管理/消防中继运行故障":   `Guasto al funzionamento del relè antincendio`,
"告警管理/1:pack 1级告警 2:pack 2级告警 3:手报按钮按下 4:手动报警":   `1: Allarme PACK Livello1 2: Allarme PACK Livello2 3: Pulsante premuto manualmente 4: Allarme manuale`,
"告警管理/4&1运行故障":   `Guasto al funzionamento 4&1`,
"告警管理/1:1级告警 2:2级告警 3:3级告警 4:运行故障":   `1: Allarme Livello1 2: Allarme Livello2 3: Allarme Livello3 4: Guasto al funzionamento`,
"告警管理/风机故障":   `Guasto alla turbina eolica`,
"告警管理/电池充满":   `Batteria completamente carica`,
"告警管理/电池单体充电终止过压":   `Tensione eccessiva fine carica cella`,
"告警管理/电池放空":   `Batteria completamente scarica`,
"告警管理/电池单体充电终止欠压":   `Tensione insufficiente fine scarica cella`,
"告警管理/电池电压无效":   `Tensione batteria non valida`,
"告警管理/电池温度无效":   `Temperatura batteria non valida`,
"告警管理/多个电池温度采样值无效":   `Valori di campionamento multipli della batteria non validi`,
"告警管理/单体过压保护":   `Protezione da sovratensione della cella`,
"告警管理/电池单体保护级欠压":   `Protezione da sottotensione della cella`,
"告警管理/单体欠压保护":   `Protezione da sottotensione della cella`,
"告警管理/电池单体保护级过压":   `Protezione da sovratensione della cella`,
"告警管理/单体过压1":   `Sovratensione della cella 1`,
"告警管理/电池单体1级欠压":   `Livello 1 di sovratensione della cella`,
"告警管理/单体欠压1":   `Sottotensione della cella 1`,
"告警管理/电池单体1级过压":   `Livello 1 di sottotensione della cella`,
"告警管理/充电高温保护":   `Protezione da alta temperatura di carica`,
"告警管理/电池单体保护级充电高温":   `Protezione da alta temperatura di carica della cella`,
"告警管理/充电低温保护":   `Protezione da bassa temperatura di carica`,
"告警管理/电池单体保护级充电低温":   `Protezione da bassa temperatura di carica della cella`,
"告警管理/放电高温保护":   `Protezione da alta temperatura di scarica`,
"告警管理/电池单体保护级放电高温":   `Protezione da temperatura di scarica della cella`,
"告警管理/放电低温保护":   `Protezione da bassa temperatura di scarica`,
"告警管理/电池单体保护级放电低温":   `Protezione da bassa temperatura di scarica della cella`,
"告警管理/充电高温告警":   `Allarme alta temperatura di carica`,
"告警管理/电池单体1级充电高温":   `Livello 1 di alta temperatura di carica della cella`,
"告警管理/充电低温告警":   `Allarme bassa temperatura di carica`,
"告警管理/电池单体1级充电低温":   `Livello 1 di bassa temperatura di carica della cella`,
"告警管理/放电高温告警":   `Allarme alta temperatura di scarica`,
"告警管理/电池单体1级放电高温":   `Livello 1 di alta temperatura di scarica della cella`,
"告警管理/放电低温告警":   `Allarme bassa temperatura di scarica`,
"告警管理/电池单体1级放电低温":   `Livello 1 di bassa temperatura di scarica della cella`,
"告警管理/充电高温终止":   `Fine alta temperatura di carica`,
"告警管理/电池单体充电终止高温":   `Fine alta temperatura di carica della cella`,
"告警管理/充电低温终止":   `Fine bassa temperatura di carica`,
"告警管理/电池单体充电终止低温":   `Fine bassa temperatura di carica della cella`,
"告警管理/放电高温终止":   `Fine alta temperatura di scarica`,
"告警管理/电池单体放电终止高温":   `Fine alta temperatura di scarica della cella`,
"告警管理/放电低温终止":   `Fine bassa temperatura di scarica`,
"告警管理/电池单体放电终止低温":   `Fine bassa temperatura di scarica della cella`,
"告警管理/电芯采样故障":   `Guasto al campionamento della cella`,
"告警管理/LTC6813采样故障":   `Guasto al campionamento LTC6813`,
"告警管理/电池单体电压不平衡":   `Squilibrio di tensione della cella`,
"告警管理/电池单体温度不平衡":   `Squilibrio di temperatura della cella`,
"告警管理/一个电池温度采样值无效":   `Valore di campionamento della temperatura di una batteria non valido`,
"告警管理/电池单体P3级过压告警":   `Livello 3 di allarme sovratensione della cella`,
"告警管理/电池单体P3级过压。":   `Livello 3 di sovratensione della cella`,
"告警管理/电池单体P3级欠压告警":   `Livello di allarme tensione cella insufficiente P3`,
"告警管理/电池单体P3级欠压。":   `Livello tensione cella insufficiente P3`,
"告警管理/模组充电P1级过压":   `Sovratensione carica modulo P1`,
"告警管理/模组充电P2级过压":   `Sovratensione carica modulo P2`,
"告警管理/模组充电P3级过压":   `Sovratensione carica modulo P3`,
"告警管理/模组放电P1级欠压":   `Sottotensione scarica modulo P1`,
"告警管理/模组放电P2级欠压":   `Sottotensione scarica modulo P2`,
"告警管理/模组放电P3级欠压":   `Sottotensione scarica modulo P3`,
"告警管理/模组充电截止":   `Interruzione carica modulo`,
"告警管理/模组放电截止":   `Interruzione scarica modulo`,
"告警管理/电池簇充电P1级过压":   `Sovratensione carica cluster batterie P1`,
"告警管理/电池簇充电P2级过压":   `Sovratensione carica cluster batterie P2`,
"告警管理/电池簇充电P3级过压":   `Sovratensione carica cluster batterie P3`,
"告警管理/电池簇放电P1级欠压":   `Sottotensione scarica cluster batterie P1`,
"告警管理/电池簇放电P2级欠压":   `Sottotensione scarica cluster batterie P2`,
"告警管理/电池簇放电P3级欠压":   `Sottotensione scarica cluster batterie P3`,
"告警管理/电池簇充电截止":   `Interruzione carica cluster batterie`,
"告警管理/电池簇放电截止":   `Interruzione scarica cluster batterie`,
"告警管理/电池单体充电P3级高温告警":   `Allarme alta temperatura carica cella P3`,
"告警管理/电池单体充电P3级低温告警":   `Allarme bassa temperatura carica cella P3`,
"告警管理/电池单体放电P3级高温告警":   `Allarme alta temperatura scarica cella P3`,
"告警管理/电池单体放电P3级低温告警":   `Allarme bassa temperatura scarica cella P3`,
"告警管理/电池单体充电电压极差P1级告警":   `Allarme differenza tensione carica cella P1`,
"告警管理/电池单体充电电压极差P2级告警":   `Allarme differenza tensione carica cella P2`,
"告警管理/电池单体充电电压极差P3级告警":   `Allarme differenza tensione carica cella P3`,
"告警管理/电池单体放电电压极差P1级告警":   `Allarme differenza tensione scarica cella P1`,
"告警管理/电池单体放电电压极差P2级告警":   `Allarme differenza tensione scarica cella P2`,
"告警管理/电池单体放电电压极差P3级告警":   `Allarme differenza tensione scarica cella P3`,
"告警管理/电池单体充电电压极差截止":   `Interruzione differenza carica cella`,
"告警管理/电池单体放电电压极差截止":   `Interruzione differenza scarica cella`,
"告警管理/电池模组充电电压极差P1级告警":   `Allarme differenza tensione carica modulo P1`,
"告警管理/电池模组充电电压极差P2级告警":   `Allarme differenza tensione carica modulo P2`,
"告警管理/电池模组充电电压极差P3级告警":   `Allarme differenza tensione carica modulo P3`,
"告警管理/电池模组放电电压极差P1级告警":   `Allarme differenza tensione scarica modulo P1`,
"告警管理/电池模组放电电压极差P2级告警":   `Allarme differenza tensione scarica modulo P2`,
"告警管理/电池模组放电电压极差P3级告警":   `Allarme differenza tensione scarica modulo P3`,
"告警管理/电池模组充电电压极差截止":   `Interruzione differenza tensione carica modulo`,
"告警管理/电池模组放电电压极差截止":   `Interruzione differenza tensione scarica modulo`,
"告警管理/电池单体充电温度极差P1级告警":   `Allarme differenza temperatura carica cella P1`,
"告警管理/电池单体充电温度极差P2级告警":   `Allarme differenza temperatura carica cella P2`,
"告警管理/电池单体充电温度极差P3级告警":   `Allarme Differenza Temperatura Carica Cella P3`,
"告警管理/电池单体放电温度极差P1级告警":   `Allarme Differenza Temperatura Scarica Cella P1`,
"告警管理/电池单体放电温度极差P2级告警":   `Allarme Differenza Temperatura Scarica Cella P2`,
"告警管理/电池单体放电温度极差P3级告警":   `Allarme Differenza Temperatura Scarica Cella P3`,
"告警管理/电池单体充电温度极差截止":   `Interruzione Differenza Carica Cella`,
"告警管理/电池单体放电温度极差截止":   `Interruzione Differenza Scarica Cella`,
"告警管理/电池电压断线":   `Interruzione Tensione Batteria`,
"告警管理/电池温度断线":   `Interruzione Temperatura Batteria`,
"告警管理/电量充满":   `Carica Completa Energia`,
"告警管理/充电过流P1":   `Sovracorrente Carica P1`,
"告警管理/充电过流P2":   `Sovracorrente Carica P2`,
"告警管理/充电过流P3":   `Sovracorrente Carica P3`,
"告警管理/充电过流P4":   `Sovracorrente Carica P4`,
"告警管理/放电过流P1":   `Sovracorrente Scarica P1`,
"告警管理/放电过流P2":   `Sovracorrente Scarica P2`,
"告警管理/放电过流P3":   `Sovracorrente Scarica P3`,
"告警管理/放电过流P4":   `Sovracorrente Scarica P4`,
"告警管理/eBlock降额":   `Derating eBlock`,
"告警管理/eBlock限功率":   `Limite Potenza eBlock`,
"告警管理/eLink调度关机":   `Spegnimento Potenza eLink Dispatch`,
"告警管理/PCS故障关机":   `Spegnimento per Guasto PCS`,
"告警管理/电芯持续一般欠压风险-预警3级":   `Rischio Sottotensione Continuo Generale Cella - Preavviso Livello 3`,
"告警管理/最低电芯电压＜2.85V且最低电芯电压≠0，持续5min":   `Tensione Minima Cella < 2,85V e Tensione Minima Cella ≠0, Durata 5min`,
"告警管理/电芯持续中度欠压风险-预警2级":   `Rischio Sottotensione Continuo Medio Cella - Preavviso Livello 2`,
"告警管理/最低电芯电压＜2.75V且最低电芯电压≠0，持续5min":   `Tensione Minima Cella < 2,75V e Tensione Minima Cella ≠0, Durata 5min`,
"告警管理/电芯持续严重欠压风险-预警1级":   `Rischio Sottotensione Continuo Grave Cella - Preavviso Livello 2`,
"告警管理/最低电芯电压＜2.5V且最低电芯电压≠0，持续5min":   `Tensione Minima Cella < 2,5V e Tensione Minima Cella ≠0, Durata 5min`,
"告警管理/电芯持续过压风险-预警1级":   `Rischio Sovratensione Continuo Cella - Preavviso Livello 1`,
"告警管理/最高电芯电压大于3.65V持续5min":   `Tensione Massima Cella > 3,65V e Durata 5min`,
"告警管理/电芯工作区间偏移一般风险-预警3级":   `Scostamento Area Lavoro Cella - Rischio Generale Preavviso Livello 3`,
"告警管理/eBlock电芯最小容量的96%＜系统容量＜eBlock电芯最小容量的98%":   `96% * Capacità Minima Cella eBlock < Capacità Sistema < 98% * Capacità Minima Cella eBlock`,
"告警管理/电芯工作区间偏移恶化风险-预警2级":   `Peggioramento Spostamento Area Lavoro Cella - Rischio Preavviso Livello 2`,
"告警管理/3004风险未消除的情况下，充电截止时最高电芯电压和平均电压的偏差逐渐拉大":   `Differenza Tensione Massima Cella e Tensione Media Aumenta Gradualmente a Fine Carica, con Rischio 3004 Presente`,
"告警管理/电芯缺电一般风险-预警3级":   `Carenza Energia Cella - Rischio Generale Preavviso Livello 3`,
"告警管理/系统容量＜eBlock电芯最小容量的96%":   `Capacità Sistema < 96% * Capacità Minima Cella eBlock`,
"告警管理/电芯缺电恶化风险-预警2级":   `Peggioramento Carenza Energia Cella - Rischio Preavviso Livello 2`,
"告警管理/3006风险未消除情况下，充电截止时最低电芯电压与平均电压的偏差逐渐拉大":   `Differenza Tensione Minima Cella e Tensione Media Aumenta Gradualmente a Fine Scarica, con Rischio 3004 Presente`,
"告警管理/电芯离群一般风险-预警3级":   `Anomalia Cella - Rischio Generale Preavviso Livello 3`,
"告警管理/同时满足下述两个条件：①充电至75%SOC时电芯电压高于平均电压15mV,②放电至30%SOC时电芯电压低于平均电压15mV":   `Tensione Cella 15mV Sopra Media a 75% SOC e 15mV Sotto Media a 30% SOC`,
"告警管理/电芯离群恶化风险-预警2级":   `Peggioramento Anomalia Cella - Rischio Preavviso Livello 2`,
"告警管理/3008风险未消除的情况下，充电截止平均电压逐渐减小":   `Diminuzione graduale della tensione media alla fine della carica, quando esiste il rischio 3004`,
"告警管理/簇间电压不均衡一般风险-预警3级":   `Cluster tra squilibrio di tensione - Livello di preallarme generale 3`,
"告警管理/5%SOC对应压差（100%与95%SOC的压差）＜目标eBlock与首台满充截止eBlock最高电压偏差＜10%SOC对应压差（100%与90%SOC的压差）":   `Differenza di tensione sotto il 5% SOC (differenza tra 100% e 95% SOC) < Massima differenza di tensione tra l'eBlock target e il primo < Differenza di tensione sotto il 10% SOC (differenza tra 100% e 90% SOC)`,
"告警管理/簇间电压不均衡严重风险-预警2级":   `Cluster tra squilibrio di tensione - Livello di preallarme rischio serio 2`,
"告警管理/目标eBlock与首台满充截止eBlock最高电压偏差＞10%SOC对应压差（100%与90%SOC的压差）":   `Massima differenza di tensione tra l'eBlock target e il primo > Differenza di tensione sotto il 10% SOC (differenza tra 100% e 90% SOC)`,
"告警管理/电芯跳水/寿命终止风险-预警1级":   `Rischio fine vita/capacità cella - Livello di preallarme 1`,
"告警管理/满足下述任意一个条件：①电芯容量低于70%出厂容量；②电芯容量相比上一次存储值降低比例超过50%":   `Capacità cella < 70% * capacità di fabbrica e riduzione capacità rispetto all'ultimo in memoria > 50%`,
"告警管理/簇内电芯SOC偏离一般风险-预警3级":   `Cluster tra variazione SOC celle - Livello di preallarme generale 3`,
"告警管理/满足下述任意一个条件：①充电截止时，3%＜SOC跳变量＜6%;②放电截止时，3%＜SOC跳变量＜6%":   `Uno tra: ① 3% < variazione SOC < 6% a fine carica e 3% < variazione SOC < 6% a fine scarica`,
"告警管理/簇内电芯SOC偏离中度风险-预警2级":   `Cluster tra variazione SOC celle - Livello di preallarme rischio medio 2`,
"告警管理/满足下述任意一个条件：①充电截止时，6%＜SOC跳变量＜9%;②放电截止时，6%＜SOC跳变量＜9%":   `Uno tra: ① 6% < variazione SOC < 9% a fine carica e 6% < variazione SOC < 9% a fine scarica`,
"告警管理/簇内电芯SOC偏离严重风险-预警1级":   `Cluster tra variazione SOC celle - Livello di preallarme rischio serio 1`,
"告警管理/满足下述任意一个条件：①充电截止时，SOC跳变量＞9%;②放电截止时，SOC跳变量＞9%":   `Uno tra: ① Variazione SOC > 9% a fine carica e variazione SOC > 9% a fine scarica`,
"告警管理/eBlock容量异常衰减一般风险-预警3级":   `Degenerazione anomala capacità eBlock - Livello di preallarme generale 3`,
"告警管理/eBlock单次循环容量衰减量＞0.3Ah":   `Degenerazione capacità eBlock per singolo ciclo > 0.3Ah`,
"告警管理/簇间容量离群一般风险-预警3级":   `Cluster tra valori anomali capacità - Livello di preallarme generale 3`,
"告警管理/eBlock容量＜方阵系统容量平均值*90%":   `Capacità eBlock < 90% * capacità media matrice`,
"告警管理/簇内电芯温度离群一般风险-预警3级":   `Cluster tra valori anomali temperatura celle - Livello di preallarme generale 3`,
"告警管理/两次采样的簇内最大温差升高速率大于1.5℃/5min":   `Tasso massimo aumento temperatura interno cluster > 1.5℃/5min tra due campionamenti`,
"告警管理/簇间温度离群一般风险-预警3级":   `Cluster tra valori anomali temperatura - Livello di preallarme generale 3`,
"告警管理/在簇间温差大于15℃的前提下，eBlock平均温度超过eBlock簇平均温度分布3/4分位点":   `Temperatura media eBlock > 75° percentile temperatura media cluster quando temperatura tra cluster > 15℃`,
"告警管理/簇内电芯内阻不一致一般风险-预警3级":   `Incoerenza resistenza interna celle cluster - Livello di preallarme generale 3`,
"告警管理/满足下述任意一个条件：①1000μΩ＜最大欧姆内阻＜1200μΩ；②2500μΩ＜最大极化内阻＜3000μΩ":   `Uno tra: ①1000μΩ < resistenza ohmica max <1200μΩ; ②2500μΩ < resistenza polarizzazione max <3000μΩ`,
"告警管理/簇内电芯内阻不一致中度风险-预警2级":   `Incoerenza resistenza interna celle cluster - Livello di preallarme rischio medio 3`,
"告警管理/满足下述任意一个条件：①1200μΩ＜最大欧姆内阻＜1500μΩ；②3000μΩ＜最大极化内阻＜3750μΩ":   `Uno tra: ①1200μΩ < resistenza ohmica max <1500μΩ; ②3000μΩ < resistenza polarizzazione max <3750μΩ`,
"告警管理/簇内电芯内阻不一致严重风险-预警1级":   `Incoerenza resistenza interna celle cluster - Livello di preallarme rischio serio 3`,
"告警管理/满足下述任意一个条件：①最大欧姆内阻＞1500μΩ；②最大极化内阻＞3750μΩ":   `Uno tra: ① Resistenza ohmica max > 1500μΩ; ② Resistenza polarizzazione max <375μΩ`,
"告警管理/簇间内阻不一致一般风险-预警3级":   `Cluster tra incoerenza resistenze - Livello di preallarme generale 3`,
"告警管理/满足下述任意一个条件：①eBlock最大欧姆内阻＞eBlock间欧姆内阻最大值的平均值*1.5；②eBlock最大极化内阻＞eBlock间极化内阻最大值的平均值*1.5":   `Uno tra: ①Resistenza ohmica max eBlock > Media resistenze ohmiche max eBlock*1.5; ②Resistenza polarizzazione max eBlock > Media resistenze polarizzazione max eBlock*1.5`,
"告警管理/控制柜急停按下":   `Cabinet controllo: arresto di emergenza`,
"告警管理/跳闸":   `Scatto`,
"告警管理/支路断路器部分跳闸":   `Scatto interruttore parziale ramo`,
"告警管理/支路断路器全部跳闸":   `Scatto interruttori tutti i rami`,
"告警管理/主断路器跳闸":   `Scatto interruttore principale`,
"告警管理/雷击":   `Fulmine`,
"告警管理/防雷触发，防雷模块击穿":   `Attivazione protezione fulmini, guasto modulo protezione`,
"告警管理/eBlock通信故障":   `Guasto comunicazione eBlock`,
"告警管理/部分eBlock通信故障":   `Guasto comunicazione parziale eBlock`,
"告警管理/全部eBlock通信故障":   `Guasto comunicazione tutti eBlock`,
"告警管理/电表通信故障（连接异常）":   `Guasto comunicazione contatore (connessione anomala)`,
"告警管理/某一类型电表中部分或全部电表连续10次未收到数据":   `Dati mancanti consecutivi per 10 volte su alcuni o tutti i contatori dello stesso tipo`,
"告警管理/电表通信故障（数据异常）":   `Guasto comunicazione contatore (dati anomali)`,
"告警管理/某一类型电表中部分或者全部电表连续10次数据异常（有数据但数据异常）":   `Dati anomali consecutivi per 10 volte su alcuni o tutti i contatori dello stesso tipo (dati presenti ma anomali)`,
"告警管理/并网点电表通信故障 （通讯异常）":   `Guasto comunicazione contatore GCP (comunicazione anomala)`,
"告警管理/部分或者全部并网点电表连续10次未收到数据":   `Dati mancanti consecutivi per 10 volte su alcuni o tutti i contatori GCP`,
"告警管理/并网点电表通信故障 （数据异常）":   `Guasto comunicazione contatore GCP (dati anomali)`,
"告警管理/部分或者全部并网点电表连续10次数据异常":   `Dati anomali consecutivi per 10 volte su alcuni o tutti i contatori GCP`,
"告警管理/计量电表通信故障":   `Guasto comunicazione contatore di misura`,
"告警管理/客户并网点计量电表连续10次未收到数据":   `Dati mancanti consecutivi per 10 volte sul contatore di misura GCP del cliente`,
"告警管理/客户并网点计量电表连续10次数据异常":   `Dati anomali consecutivi per 10 volte sul contatore di misura GCP del cliente`,
"告警管理/辅源计量电表连续10次未收到数据":   `Dati mancanti consecutivi per 10 volte sul contatore di misura ausiliario`,
"告警管理/辅源计量电表连续10次数据异常":   `Dati anomali consecutivi per 10 volte sul contatore di misura ausiliario`,
"告警管理/空调计量电表连续10次未收到数据":   `Dati mancanti consecutivi per 10 volte sul contatore di misura del condizionatore`,
"告警管理/空调计量电表连续10次数据异常":   `Dati anomali consecutivi per 10 volte sul contatore di misura del condizionatore`,
"告警管理/柜内空调连续10次未收到数据":   `Dati mancanti consecutivi per 10 volte all'interno del cabinet`,
"告警管理/柜内空调连续10次数据异常":   `Dati anomali consecutivi per 10 volte all'interno del cabinet`,
"告警管理/ups通信故障":   `Guasto comunicazione UPS`,
"告警管理/柜内ups连续10次未收到数据":   `Dati mancanti consecutivi per 10 volte all'interno del cabinet`,
"告警管理/柜内ups连续10次数据异常":   `Dati anomali consecutivi per 10 volte all'interno del cabinet`,
"告警管理/IO模块通信故障":   `Guasto comunicazione modulo IO`,
"告警管理/IO模块连续10次未收到数据":   `Dati mancanti consecutivi per 10 volte sul modulo IO`,
"告警管理/IO模块连续10次数据异常":   `Dati anomali consecutivi per 10 volte sul modulo IO`,
"告警管理/CAN模块通信故障":   `Guasto comunicazione modulo CAN`,
"告警管理/CAN转网络模块连续10次未收到数据":   `Dati mancanti consecutivi per 10 volte sul modulo di rete CAN Switch`,
"告警管理/消防系统通信故障":   `Guasto comunicazione sistema antincendio`,
"告警管理/消防系统连续10次未收到数据":   `Dati mancanti consecutivi per 10 volte sul sistema antincendio`,
"告警管理/消防系统连续10次数据异常":   `Dati anomali consecutivi per 10 volte sul sistema antincendio`,
"告警管理/串口服务器通信故障":   `Guasto comunicazione server COM`,
"告警管理/串口服务器连续10次未收到数据":   `Dati mancanti consecutivi per 10 volte sul server COM`,
"告警管理/消防触发":   `Attivazione allarme incendio`,
"告警管理/eBlock触发消防信息":   `Attivazione messaggio incendio eBlock`,
"告警管理/独立消防系统3触发":   `Attivazione sistema antincendio indipendente 3`,
"告警管理/消防1":   `Incendio1`,
"告警管理/独立消防系统1触发":   `Attivazione sistema antincendio indipendente1`,
"告警管理/消防0":   `Incendio0`,
"告警管理/独立消防系统0触发":   `Attivazione sistema antincendio indipendente0`,
"告警管理/消防传感器故障":   `Guasto sensore incendio`,
"告警管理/独立消防系统传感器故障":   `Guasto sensore sistema antincendio indipendente`,
"告警管理/UPS故障":   `Guasto UPS`,
"告警管理/UPS未启用条件下故障(取自UPS数据)":   `Guasto UPS durante l'arresto (dati dall'UPS)`,
"告警管理/交流电压异常":   `Tensione Corrente Alternata Anomala`,
"告警管理/交流供电异常，UPS启用":   `Alimentazione Corrente Alternata Anomala, UPS Avviato`,
"告警管理/UPS电池电压低":   `Tensione Batteria UPS Bassa`,
"告警管理/UPS启用条件下电池电压过低":   `Tensione Batteria Molto Bassa all'Avvio UPS`,
"告警管理/UPS未启用，交流供电正常条件下，UPS电池电压低":   `Tensione Batteria UPS Bassa all'Arresto e Alimentazione Corrente Alternata Normale`,
"告警管理/空调制冷":   `Aria Condizionata in Raffreddamento`,
"告警管理/空调制冷开启":   `Avvio Raffreddamento Aria Condizionata`,
"告警管理/空调制热":   `Aria Condizionata in Riscaldamento`,
"告警管理/空调制热开启":   `Avvio Riscaldamento Aria Condizionata`,
"告警管理/空调任意告警或者故障触发":   `Allarme o Guasto Qualsiasi Aria Condizionata`,
"告警管理/网络异常":   `Rete Anomala`,
"告警管理/对外通信网络异常（4G异常或者网线异常，异常时记录，恢复时上报）":   `Rete di Comunicazione Esterna (4G Anomalo o Cavo Normale, Registra Anomalia, Segnala Ripristino)`,
"告警管理/运行模式异常":   `Modalità Operativa Anomala`,
"告警管理/方阵eBlock运行模式不一致":   `Modalità Operativa Matrix eBlock Non Coerente`,
"告警管理/eLink 内存资源异常":   `Risorsa Memoria eLink Anomala`,
"告警管理/eLink 内存资源异常超限":   `Risorsa Memoria eLink Anomala oltre Limite`,
"告警管理/eLink CPU资源异常":   `Risorsa CPU eLink Anomala`,
"告警管理/eLink CPU资源异常超限":   `Risorsa CPU eLink Anomala oltre Limite`,
"告警管理/空调制冷异常":   `Raffreddamento Aria Condizionata Anomalo`,
"告警管理/柜体达到制冷温度未制冷":   `Raffreddamento Armadio Disabilitato a Temperatura Raggiunta`,
"告警管理/空调制热异常":   `Riscaldamento Aria Condizionata Anomalo`,
"告警管理/柜体达到制冷热度未制热":   `Riscaldamento Armadio Disabilitato a Temperatura Raggiunta`,
"告警管理/消防设备告警":   `Allarme Antincendio`,
"告警管理/告警码删除提示":  (code) => `Sei sicuro di voler eliminare il codice allarme ${code}?`,
"告警管理/请选择故障等级":   `Selezionare Livello Allarme`,
"告警管理/请选择设备类型":   `Selezionare Modello Apparecchiatura`,
"告警管理/请输入故障描述":   `Inserire Descrizione Allarme`,
"告警管理/请输入故障详情":   `Inserire Dettagli Allarme`,
"告警管理/消防":   `Incendio`,
"告警管理/删除成功":   `Eliminazione Riuscita`,
"告警管理/开始":   `Ora Inizio`,
"告警管理/结束":   `Ora Fine`,
"告警管理/未审校":   `Non Verificato`,
"告警管理/已审校":   `Verificato`,
"告警管理/确认":   `Conferma`,
"告警管理/告警确认":   `Conferma Allarme`,
"告警管理/请输入备注":   `Inserire Osservazione`,
'告警管理/故障描述_英文': `Descrizione(Inglese)`,
'告警管理/故障详情_英文': `Dettagli(Inglese)`,
'告警管理/故障描述_意大利语': `Descrizione(Italiano)`,
'告警管理/故障详情_意大利语': `Dettagli(Italiano)`,
'告警管理/100C设备故障编码': `Codice Allarme per eBlock100C`,
'告警管理/非100C设备故障编码': `Codice Allarme per Altro Apparecchiatura`,
"运行策略/能量链":   `eLink`,
"运行策略/当前模式":   `Modalità Corrente`,
"运行策略/削峰填谷模式":   `Modalità Picco`,
"运行策略/切换模式":   `Cambio Modalità`,
"运行策略/刷新":   `Aggiorna`,
"运行策略/定时设置":   `Impostazioni pianificazione`,
"运行策略/各项参数以及运行策略将会在指定日期之后生效":   `Tutti i parametri e le strategie operative avranno effetto dopo la data personalizzata`,
"运行策略/新增":   `Nuovo`,
"运行策略/取消":   `Annulla`,
"运行策略/保存":   `Salva`,
"运行策略/生效日期":   `Data effettiva`,
"运行策略/策略模式":   `Modalità strategia`,
"运行策略/需量":   `Domanda`,
"运行策略/充放电模式":   `Modalità carica/scarica`,
"运行策略/无休":   `Nessun riposo`,
"运行策略/单休":   `Riposo singolo`,
"运行策略/双休":   `Riposo doppio`,
"运行策略/虚拟电厂调度":   `Dispacciamento centrale virtuale`,
"运行策略/禁止":   `Vietato`,
"运行策略/允许":   `Consentito`,
"运行策略/运行策略":   `Strategia operativa`,
"运行策略/工作日策略":   `Strategia giorni lavorativi`,
"运行策略/休息日策略":   `Strategia giorni di riposo`,
"运行策略/复制":   `Copia`,
"运行策略/粘贴":   `Incolla`,
"运行策略/清空":   `Azzeramento`,
"运行策略/开始时间":   `Ora inizio`,
"运行策略/结束时间":   `Ora fine`,
"运行策略/功率":   `Potenza`,
"运行策略/充电上限":   `Limite superiore carica`,
"运行策略/放电下限":   `Limite inferiore scarica`,
"运行策略/操作":   `Funzionamento`,
"运行策略/暂无数据":   `Nessun dato`,
"运行策略/推送":   `Invia`,
"运行策略/取消对比":   `Annulla`,
"运行策略/已同步":   `Sincronizzato`,
"运行策略/未同步":   `Non sincronizzato`,
"运行策略/同步中":   `Sincronizzazione in corso`,
"运行策略/同步时间":   `Ora sincronizzazione`,
"运行策略/策略":   `Strategia`,
"运行策略/允许虚拟电厂调度":   `Consenti dispacciamento centrale virtuale`,
"运行策略/否":   `No`,
"运行策略/策略信息":   `Informazioni strategia`,
"运行策略/本月最大需量":   `Domanda massima mese corrente`,
"运行策略/修改":   `Modifica`,
"运行策略/确定":   `Conferma`,
"运行策略/当前充放电模式":   `Modalità corrente di carica e scarica`,
"运行策略/所有日期都执行工作日策略":   `Strategia feriale per tutti i giorni`,
"运行策略/日历视图":   `Vista calendario`,
"运行策略/本月最大需量由关口电表的历史数据而来，请在设置需量时根据实际情况酌情设置":   `Domanda di riferimento del mese corrente basata sulla previsione dei dati storici del contatore PCC, impostare la domanda in base alla situazione reale`,
"运行策略/上个月":   `Mese scorso`,
"运行策略/今天":   `Oggi`,
"运行策略/下个月":   `Mese prossimo`,
"运行策略/预约策略生效日期":   `Data di entrata in vigore della strategia`,
"运行策略/预约策略生效提示":  (s, d) => `La distanza dalla data effettiva di "${s}" è di ${d} giorni`,
"运行策略/切换":   `Cambia`,
"运行策略/对比":   `Confronto`,
"运行策略/请先设置需量":   `Impostare prima la domanda`,
"运行策略/动作":   `Azione`,
"运行策略/请选择":   `Selezionare`,
"运行策略/SOC上限":   `Limite superiore SOC`,
"运行策略/SOC下限":   `Limite inferiore SOC`,
"运行策略/变压器容量上限":   `Limite superiore capacità trasformatore`,
"运行策略/变压器容量下限":   `Limite inferiore capacità trasformatore`,
"运行策略/持续时间":   `Durata`,
"运行策略/功率模式":   `Modalità potenza`,
"运行策略/零功率且关机":   `Potenza zero e arresto`,
"运行策略/零功率且待机":   `Potenza zero e inattivo`,
"运行策略/按照设定功率运行":   `Operare sotto la potenza impostata`,
"运行策略/范围为":   `Intervallo`,
"运行策略/按照额定功率运行":   `Operare sotto la potenza nominale`,
"运行策略/按照变压器负载率上限为目标":   `Obiettivo con limite superiore fattore di carico trasformatore`,
"运行策略/按照变压器负载率下限为目标":   `Obiettivo con limite inferiore fattore di carico trasformatore`,
"运行策略/若策略模式未切换成功，请点击此按钮刷新。":   `Premere questo pulsante di aggiornamento se il cambio di modalità strategia fallisce`,
"运行策略/若长时间后仍未成功，请联系管理员！":   `Contattare l'amministratore se l'operazione continua a fallire dopo molto tempo`,
"运行策略/当前生效":   `Efficacia corrente`,
"运行策略/同步结果":   `Risultato sincrono`,
"运行策略/请输入需量":   `Inserire la domanda`,
"运行策略/运行策略管理":   `Gestione strategia operativa`,
"运行策略/关闭":   `Chiudi`,
"运行策略/打开":   `Apri`,
"运行策略/请选择一种模式":   `Selezionare una modalità`,
"运行策略/时段与运行功率":   `Periodi e potenza operativa`,
"运行策略/变压器扩容":   `Espansione capacità trasformatore`,
"运行策略/提示":   `Avviso`,
"运行策略/停机切换为其他模式时，时间有延迟":   `C'è un ritardo quando la modalità di arresto passa a un'altra`,
"运行策略/请输入时段名称":   `Inserisci il Nome del Periodo`,
"运行策略/增加规则":   `Nuove Regole`,
"运行策略/增加时段":   `Nuovi Periodi`,
"运行策略/需量必须大于0":   `La domanda deve essere maggiore di 0`,
"运行策略/需量修改成功":   `Modifica della Domanda Avvenuta con Successo`,
"运行策略/推送失败":   `Invio Fallito`,
"运行策略/确定切换":   `Conferma per Cambiare`,
"运行策略/您未设置休息日策略，请先点击下方“运行策略”按钮进行设置":   `Non hai impostato la Strategia per il Weekend, premi il pulsante "Strategia Operativa" qui sotto per impostarla`,
"运行策略/计划修改成功":   `Modifica del Piano Avvenuta con Successo`,
"运行策略/切换成功":   `Cambio Avvenuto con Successo`,
"运行策略/工作日策略不能为空":   `La strategia per i giorni lavorativi non può essere vuota`,
"运行策略/周日执行休息日策略，其他时间执行工作日策略":   `Strategia Weekend per Domeniche e Strategia Feriale per il Resto del Tempo`,
"运行策略/周六和周日执行休息日策略，其他时间执行工作日策略":   `Strategia Weekend per Sabati e Domeniche e Strategia Feriale per il Resto del Tempo`,
"运行策略/新建变压器保护策略":   `Nuova strategia di protezione del trasformatore`,
"运行策略/尖":   `Picco`,
"运行策略/峰":   `Massimo`,
"运行策略/平":   `Medio`,
"运行策略/谷":   `Minimo`,
"运行策略/放电":   `Scarica`,
"运行策略/充电":   `Carica`,
"运行策略/关机":   `Spento`,
"运行策略/待机":   `Inattivo`,
"运行策略/额定":   `Nominale`,
"运行策略/扩容":   `Espansione`,
"运行策略/设定":   `Impostazione`,
"运行策略/变压器保护策略":   `Strategia di Protezione del Trasformatore`,
"运行策略/时段不能为空":   `Il Periodo di Tempo non può essere Vuoto`,
"运行策略/SOC上限不能小于SOC下限":   `Il Limite Superiore SOC non può essere Inferiore al Limite Inferiore SOC`,
"运行策略/变压器容量上限不能小于变压器容量下限":   `Il Limite Superiore della Capacità del Trasformatore non può essere Inferiore al Limite Inferiore`,
"运行策略/功率模式设定值不能为空":   `Il Valore Impostato della Modalità di Potenza non può essere Vuoto`,
"运行策略/功率模式不能为空":   `La Modalità di Potenza non può essere Vuota`,
"运行策略/功率模式设定值不能超过":   `Il Valore Impostato della Modalità di Potenza non può essere Maggiore di`,
"运行策略/或小于0":   `o Inferiore a 0`,
"运行策略/持续时间不能为空":   `La Durata non può essere Vuota`,
"运行策略/动作不能为空":   `L'Azione non può essere Vuota`,
"运行策略/SOC不能为空":   `Il SOC non può essere Vuoto`,
"运行策略/变压器容量不能为空":   `La Capacità del Trasformatore non può essere Vuota`,
"运行策略/时段内的规则存在交集":   `Le Regole dei Periodi di Tempo Presentano Sovrapposizioni`,
"运行策略/时段内的规则未覆盖全部区域":   `Le Regole dei Periodi di Tempo non Coprono Tutte le Aree`,
"运行策略/以下时间存在交集，请修改":   `I Seguenti Periodi di Tempo Presentano Sovrapposizioni, Si Prega di Modificarli`,
"运行策略/策略时间槽不正确，请设置连续的时段，且范围覆盖 00:00-23:59":   `Lo slot temporale della strategia è errato, imposta periodi di tempo continui coprendo 00:00-23:59`,
"运行策略/更新成功":   `Aggiornamento riuscito`,
"运行策略/复制成功":   `Copia riuscita`,
"运行策略/粘贴成功":   `Incolla riuscito`,
"运行策略/剪切板数据格式错误":   `Errore nel formato dei dati negli appunti`,
"运行策略/请先开启浏览器读取剪贴板的权限":   `Abilita prima il permesso del browser per leggere gli appunti`,
"运行策略/时段":   `Periodo di tempo`,
"运行策略/编辑":   `Modifica`,
"运行策略/确认":   `Conferma`,
"运行策略/变压器保护模式":   `Modalità protezione trasformatore`,
"运行策略/预约运行策略管理":   `Gestione strategia operativa programmata`,
"运行策略/生效日期不能为空":   `La data di validità non può essere vuota`,
"运行策略/需量不能为空":   `La richiesta non può essere vuota`,
"运行策略/充放电模式不能为空":   `La modalità carica/scarica non può essere vuota`,
"运行策略/策略模式不能为空":   `La modalità strategia non può essere vuota`,
"运行策略/未执行":   `Non eseguito`,
"运行策略/已执行":   `Eseguito`,
"运行策略/执行中":   `In esecuzione`,
"运行策略/休息日策略不能为空":   `La strategia per i giorni di riposo non può essere vuota`,
"运行策略/需量不能为0":   `La richiesta non può essere 0`,
"运行策略/修改成功!":   `Modificato con successo!`,
"运行策略/新增成功!":   `Aggiunto con successo!`,
"运行策略/确定要删除吗?":   `Sei sicuro di voler eliminare?`,
"运行策略/生效日期重复提示":  (s) => `La data effettiva è in conflitto con ${s}`,
"运行策略/策略模式切换":   `Cambio modalità strategia`,
"运行策略/策略切换成功":   `Strategia cambiata con successo`,
"运行策略/eLink策略":   `Strategia eLink`,
"运行策略/eMind策略":   `Strategia eMind`,
"运行策略/是":   `Sì`,
"运行策略/策略满足条件":   `La strategia soddisfa le condizioni`,
"运行策略/策略未覆盖24小时":   `La strategia non copre 24 ore`,
"运行策略/控制模式为本地控制":   `La modalità di controllo è controllo locale`,
"运行策略/控制源为非eMind控制":   `La fonte di controllo non è eMind`,
"运行策略/预约策略":   `Strategia su appuntamento`,
"运行策略/新增一行":   `Aggiungi riga`,
"运行策略/策略文本":   `Testo strategia`,
"运行策略/请将策略文本粘贴到这里":   `Incolla qui il testo della strategia`,
"运行策略/已经存在策略，确定要替换吗？":   `La strategia esiste già, sei sicuro di sostituirla?`,
"运行策略/策略格式不正确":   `Formato strategia non valido`,
"运行策略/粘贴失败":   `Incolla fallito`,
"运行策略/请输入正确的":   `Inserisci il valore corretto`,
"运行策略/工作日":   `Giorno lavorativo`,
"运行策略/休息日":   `Giorno di riposo`,
"运行策略/推送成功":   `Push eseguito con successo`,
"运行策略/预约策略保存提示":  (s) => `Salva prima la "${s}"`,
"运行策略/删除":   `Elimina`,
"运行策略/eLink最后一次上报的需量和策略数据与eMind不一致":   `I dati di domanda e strategia riportati da eLink sono inconsistenti con eMind`,
"运行策略/操作者":   `Operatore`,
"运行策略/操作类型":   `Tipo di operazione`,
"运行策略/修改时间":   `Ora di modifica`,
"运行策略/操作内容":   `Contenuto dell'operazione`,
"运行策略/策略模式更改":   `Modalità strategia modificata`,
"运行策略/策略内容变更":   `Contenuto strategia modificato`,
"运行策略/需量变更":   `Domanda modificata`,
"运行策略/计划变更":   `Piano modificato`,
"运行策略/策略类型变更":   `Tipo strategia modificato`,
"运行策略/虚拟电厂调度更改":   `Dispatching Virtual Power Plant modificato`,
"运行策略/自定义策略":   `Strategia personalizzata`,
"运行策略/修改了自定义策略":   `Strategia personalizzata modificata`,
"运行策略/删除了自定义策略":   `Strategia personalizzata eliminata`,
"运行策略/增加了自定义策略":   `Strategia personalizzata aggiunta`,
"运行策略/了虚拟电厂调度选项":   `Opzione di dispatching Virtual Power Plant`,
"运行策略/修改了工作日策略":   `Strategia giorno lavorativo modificata`,
"运行策略/修改了休息日策略":   `Strategia giorno di riposo modificata`,
"运行策略/策略类型修改记录":  (d, t) => `Modificata la strategia per ${d} a una strategia "${t}"`,
"运行策略/充放电计划修改记录":  (o, n) => `Modificato il piano di carica/scarica da "${o}" a "${n}"`,
"运行策略/需量变更记录":  (o, n) => `Modificata la richiesta da "${o}" a "${n}"`,
"运行策略/修改了变压器保护策略":   `Strategia protezione trasformatore modificata`,
"运行策略/模式修改记录":  (m) => `Modificata la modalità a "${m}"`,
"运行策略/查看详情":   `Visualizza dettagli`,
"运行策略/策略详情":   `Dettagli strategia`,
"运行策略/表格":   `Tabella`,
"运行策略/差异":   `Differenza`,
"运行策略/修改前策略数据":   `Strategia precedente`,
"运行策略/修改后策略数据":   `Nuova strategia`,
"运行策略/自定义策略详情":   `Dettagli strategia personalizzata`,
"运行策略/修改前":   `Precedente`,
"运行策略/修改后":   `Nuovo`,
"运行策略/策略名称":   `Nome strategia`,
"运行策略/策略修改详情":   `Dettagli modifica strategia`,
"运行策略/工作日策略中充电上限不能小于放电下限":   `Il limite superiore di carico nella strategia della giornata non può essere inferiore al limite inferiore di scarica`,
"运行策略/休息日策略中充电上限不能小于放电下限":   `Il limite superiore di carico nella strategia del giorno di riposo non deve essere inferiore al limite inferiore di carico`,

"抄表结算/日期":   `Dati`,
"抄表结算/至":   `A`,
"抄表结算/查询":   `Cerca`,
"抄表结算/抄表详情":   `Dettagli lettura contatore`,
"抄表结算/收益类别":   `Tipo guadagno`,
"抄表结算/电价类型":   `Tipo tariffa`,
"抄表结算/天数":   `Giorni`,
"抄表结算/时段":   `Periodi`,
"抄表结算/尖峰时段":   `Periodo Puntuale`,
"抄表结算/高峰时段":   `Periodo di Picco`,
"抄表结算/平时段":   `Periodo Piano`,
"抄表结算/低谷时段":   `Periodo di Valle`,
"抄表结算/深谷时段":   `Periodo di Valle Profonda`,
"抄表结算/市电单价":   `Prezzo dell'Energia Urbana`,
"抄表结算/计量方向":   `Tipo di Misura`,
"抄表结算/电量":   `Energia`,
"抄表结算/电费":   `Addebito`,
"抄表结算/合计":   `Totale`,
"抄表结算/峰谷价差收益":   `Guadagno da Differenza Prezzi Picco-Valle`,
"抄表结算/峰谷价差总收益-合计":   `Guadagno Totale da Differenza Prezzi Picco-Valle`,
"抄表结算/电表数据详情":   `Dettagli Metadati`,
"抄表结算/并网点电表":   `Contatore GCP`,
"抄表结算/抄表时间":   `Data di Lettura del Contatore`,
"抄表结算/正向有功":   `Attivo Positivo`,
"抄表结算/反向有功":   `Attivo Negativo`,
"抄表结算/修复":   `Riparazione`,
"抄表结算/换表":   `Cambio Contatore`,
"抄表结算/换标详情":   `Dettagli Cambio Contatore`,
"抄表结算/复制":   `Copia`,
"抄表结算/打印":   `Stampa`,
"抄表结算/导出":   `Scarica`,
"抄表结算/确认导出":   `Sei sicuro di voler scaricare i dati di regolazione della lettura del contatore?`,
"抄表结算/确定修复":   `Sei sicuro di voler riparare?`,
"抄表结算/暂无数据":   `Nessun Dato Disponibile`,
"抄表结算/充电":   `Carica`,
"抄表结算/放电":   `Scarica`,
"抄表结算/注":   `Nota`,
"抄表结算/注说明":   `Nota: La tariffa mensile del servizio di accumulo di energia pagata dalla Parte A alla Parte B è la somma dei ricavi derivanti dalla differenza dei prezzi picco-valle. La misurazione dell'energia è basata sulla misurazione totale del contatore al punto di connessione alla rete della centrale di accumulo, e il prezzo dell'energia corrispondente al periodo si basa sul prezzo effettivo applicato dal dipartimento locale di fornitura energetica. La formula di calcolo specifica è la seguente:`,
"抄表结算/收益修复":   `Addebito di scarica = ∑(Energia scaricata × prezzo del periodo corrispondente)`,
"抄表结算/换表详情":   `Addebito di carica = ∑(Energia caricata × prezzo del periodo corrispondente)`,
"抄表结算/选择":   `Ricavo da differenza prezzi picco-valle = Addebito di scarica - Addebito di carica`,
"抄表结算/复制成功":   `Ricavo della centrale di accumulo = Ricavo da differenza prezzi picco-valle`,
"抄表结算/尖峰":   `Riparazione Guadagno`,
"抄表结算/高峰":   `Dettagli Cambio Contatore`,
"抄表结算/平":   `Seleziona`,
"抄表结算/低谷":   `Copia Riuscita`,
"抄表结算/深谷":   `Valle Profonda`,
"抄表结算/总":   `Totale`,
"抄表结算/尖":   `Nitido`,
"抄表结算/峰":   `Picco`,
"抄表结算/谷":   `Valle`,
"抄表结算/更换电表":   `Cambia Contatore`,
"抄表结算/取消":   `Annulla`,
"抄表结算/确定":   `Conferma`,
"抄表结算/电表名称":   `Nome Contatore`,
"抄表结算/电表UUID":   `UUID Contatore`,
"抄表结算/旧表开始值":   `Valore Iniziale Vecchio Contatore`,
"抄表结算/旧表结束值":   `Valore Finale Vecchio Contatore`,
"抄表结算/新表开始值":   `Valore Iniziale Nuovo Contatore`,
"抄表结算/新表结束值":   `Valore Finale Nuovo Contatore`,
"抄表结算/请选择":   `Seleziona`,
"抄表结算/旧表结束值和新表开始值必须要选":   `È necessario selezionare il valore finale del vecchio contatore e il valore iniziale del nuovo contatore`,
"抄表结算/选择电表数据":   `Seleziona Dati Contatore`,
"抄表结算/修复电表数据":   `Ripara Dati Contatore`,
"抄表结算/请选择一条电表数据":   `Seleziona un dato del contatore`,
"参数设置/命令记录":   `Registro Comandi`,
"参数设置/参数设置":   `Impostazioni Parametri`,
"参数设置/箱变容量配比":   `Rapporto Capacità Trasformatore`,
"参数设置/最小需量":   `Domanda Minima`,
"参数设置/最大需量":   `Domanda Massima`,
"参数设置/无功工作模式":   `Modalità Lavoro Reattivo`,
"参数设置/修改":   `Modifica`,
"参数设置/不出无功":   `Nessuna Potenza Reattiva`,
"参数设置/优先出无功":   `Priorità Potenza Reattiva`,
"参数设置/优先出有功":   `Priorità Potenza Attiva`,
"参数设置/启停":   `Accendi/Spegni`,
"参数设置/启用":   `Avvia`,
"参数设置/停用":   `Ferma`,
"参数设置/设置协议帧":   `Imposta Frame Protocollo`,
"参数设置/请输入协议帧":   `Inserisci Frame Protocollo`,
"参数设置/发送":   `Invia`,
"参数设置/发送内容":   `Contenuto Inviato`,
"参数设置/发送时间":   `Ora Invio`,
"参数设置/协议帧":   `Frame Protocollo`,
"参数设置/接收内容":   `Contenuto Ricevuto`,
"参数设置/接收时间":   `Ora Ricezione`,
"参数设置/EMS控制参数":   `Controllo EMS`,
"参数设置/水机控制参数":   `Controllo Macchina dell'Acqua`,
"参数设置/消防控制参数":   `Controllo Antincendio`,
"参数设置/BMS控制参数":   `Controllo BMS`,
"参数设置/PCS控制参数":   `Controllo PCS`,
"参数设置/BCS控制参数":   `Controllo BCS`,
"参数设置/开始时间":   `Ora di Inizio`,
"参数设置/结束时间":   `Ora di Fine`,
"参数设置/功率":   `Potenza`,
"参数设置/操作":   `Operazione`,
"参数设置/暂无数据":   `Nessun Dato`,
"参数设置/新增":   `Nuovo`,
"参数设置/读取":   `Leggi`,
"参数设置/设置":   `Imposta`,
"参数设置/正在设置，请稍后":   `Configurazione in Corso, Attendere`,
"参数设置/请选择":   `Seleziona`,
"参数设置/EMS工作模式":   `Modalità di Lavoro EMS`,
"参数设置/最大充电功率":   `Potenza Massima di Carica`,
"参数设置/最大放电功率":   `Potenza Massima di Scarica`,
"参数设置/余电上网功率限值":   `Limite di Immissione in Rete dell'Energia Residua`,
"参数设置/电网买电功率限值":   `Limite di Potenza`,
"参数设置/系统开关机命令":   `Comando Accensione/Spegnimento Sistema`,
"参数设置/备电截止SOC":   `SOC di Interruzione dell'Alimentazione di Riserva`,
"参数设置/充电截止SOC":   `SOC di Interruzione della Carica`,
"参数设置/放电截止SOC":   `SOC di Interruzione della Scarica`,
"参数设置/余电上网使能开关":   `Interruttore Abilitazione Immissione in Rete dell'Energia Residua`,
"参数设置/AC充电使能开关":   `Interruttore Abilitazione Carica AC`,
"参数设置/非重要负载关闭":   `Chiusura Carichi Non Importanti`,
"参数设置/DRM需求响应开关":   `Interruttore di Risposta DRM`,
"参数设置/干节点输出模式":   `Modalità Uscita Contatto Secco`,
"参数设置/手动控制开关使能":   `Abilitazione Interruttore Controllo Manuale`,
"参数设置/干节点时间控制开始时间：周时":   `Ora di Inizio Controllo Contatto Secco: SettimanaOra`,
"参数设置/干节点时间控制开始时间：分秒":   `Ora di Inizio Controllo Contatto Secco: MinutoSecondo`,
"参数设置/干节点时间控制结束时间：周时":   `Ora di Fine Controllo Contatto Secco: SettimanaOra`,
"参数设置/干节点时间控制结束时间：分秒":   `Ora di Fine Controllo Contatto Secco: MinutoSecondo`,
"参数设置/并机模式使能":   `Abilitazione Modalità Parallelo`,
"参数设置/并机通信地址":   `Indirizzo Comunicazione Parallelo`,
"参数设置/系统时钟：年月":   `Orologio di Sistema: AnnoMese`,
"参数设置/系统时钟：日时":   `Orologio di Sistema: GiornoOra`,
"参数设置/系统时钟：分秒":   `Orologio di Sistema: MinutoSecondo`,
"参数设置/清除电能记录":   `Cancella Registro Energia`,
"参数设置/电表数据清零":   `Cancella Dati Contatore`,
"参数设置/恢复出厂设置":   `Ripristino Impostazioni Fabbrica`,
"参数设置/故障复位":   `Reset Guasti`,
"参数设置/重启命令":   `Comando Riavvio`,
"参数设置/清除故障记录":   `Cancella Registro Guasti`,
"参数设置/强制充电":   `Carica Forzata`,
"参数设置/强充功率门限":   `Limite Potenza Carica Forzata`,
"参数设置/ARM装备控制":   `Controllo ARM`,
"参数设置/柜体1手动设置无功功率":   `Impostazione Manuale Potenza Reattiva Cabinet1`,
"参数设置/柜体1手动设置PV功率":   `Impostazione Manuale Potenza FV Cabinet1`,
"参数设置/柜体1手动设置DCDC功率":   `Impostazione Manuale Potenza DCDC Cabinet1`,
"参数设置/禁能":   `Disabilita`,
"参数设置/时间控制":   `Controllo Orario`,
"参数设置/手动开关控制":   `Interruttore Controllo Manuale`,
"参数设置/backup负载控制":   `Controllo Carico Backup`,
"参数设置/干节点输出模式为手动开关控制模式可见":   `Modalità Uscita Contatto Secco per Controllo Manuale Visibile`,
"参数设置/负载优先":   `Priorità Carico`,
"参数设置/备电优先":   `Priorità Alimentazione Backup`,
"参数设置/电网优先":   `Priorità Rete`,
"参数设置/经济模式":   `Modalità Economica`,
"参数设置/纯离网":   `Off-Grid`,
"参数设置/开机":   `Accensione`,
"参数设置/关机":   `Spegnimento`,
"参数设置/存储":   `Salva`,
"参数设置/默认禁能":   `Predefinito: Disabilita`,
"参数设置/控制模式":   `Modalità Controllo`,
"参数设置/运行模式":   `Modalità Operativa`,
"参数设置/制冷设定温度":   `Temperatura Impostata Raffreddamento`,
"参数设置/制热设定温度":   `Temperatura Impostata Riscaldamento`,
"参数设置/手动控制":   `Controllo Manuale`,
"参数设置/自动控制":   `Controllo Automatico`,
"参数设置/休眠模式":   `Modalità Standby`,
"参数设置/制冷模式":   `Modalità Raffreddamento`,
"参数设置/加热模式":   `Modalità Riscaldamento`,
"参数设置/自循环模式":   `Modalità Autocircolazione`,
"参数设置/电池火灾VOC浓度限值":   `Limite Concentrazione VOC Incendio Batteria`,
"参数设置/柜体火灾温度上限值":   `Limite Temperatura Incendio Cabinet`,
"参数设置/柜体高温门限值":   `Limite Alta Temperatura Cabinet`,
"参数设置/柜体烟雾门限值":   `Limite Fumo Cabinet`,
"参数设置/eBlock总容量":   `Capacità Totale eBlock`,
"参数设置/eBlock总电量":   `Energia Totale eBlock`,
"参数设置/ACSOE设置":   `Impostazione SOE AC`,
"参数设置/DCSOE设置":   `Impostazione SOE DC`,
"参数设置/eBlock运行模式":   `Modalità Operativa eBlock`,
"参数设置/SOP控制模式":   `Modalità Controllo SOP`,
"参数设置/手动ocv开关":   `Interruttore Manuale OCV`,
"参数设置/柜体累积充电量":   `Energia di Carica Accumulata Armadio`,
"参数设置/小斜坡修正":   `Modifica Piccola Pendenza`,
"参数设置/小斜坡容量修正触发开关":   `Interruttore Trigger Modifica Capacità Piccola Pendenza`,
"参数设置/小斜坡计算过程的容量步长":   `Passo Capacità Calcolo Piccola Pendenza`,
"参数设置/小斜坡触发的电流偏差阈值":   `Trigger Piccola Pendenza per Limite Corrente Bias`,
"参数设置/标准额定容量":   `Capacità Nominale Standard`,
"参数设置/电池能量计量模式":   `Modalità Misura Energia Batteria`,
"参数设置/满充满放次数":   `Numero Carica-Scarica Completa`,
"参数设置/充放电截止次数":   `Numero Interruzione Carica-Scarica`,
"参数设置/电池内阻测量开关":   `Interruttore Misura Resistenza Batteria`,
"参数设置/均衡时间占空比":   `Fattore di Lavoro Tempo Equalizzazione`,
"参数设置/均衡类型":   `Tipo Equalizzazione`,
"参数设置/均衡应用工况":   `Condizioni Applicazione Equalizzazione`,
"参数设置/均衡触发模式":   `Modalità Trigger Equalizzazione`,
"参数设置/SOP算法开关":   `Interruttore Algoritmo SOP`,
"参数设置/SOP充电限制系数":   `Coefficiente Limite Carica SOP`,
"参数设置/SOP放电限制系数":   `Coefficiente Limite Scarica SOP`,
"参数设置/SOP保护时间":   `Tempo Protezione SOP`,
"参数设置/SOP阶梯功率":   `Potenza a Livelli SOP`,
"参数设置/主动均衡开关":   `Interruttore Equalizzazione Attiva`,
"参数设置/电压偏差门限":   `Limite Bias Tensione`,
"参数设置/电压差值区间":   `Intervallo Differenza Tensione`,
"参数设置/SOC偏差门限":   `Limite Bias SOC`,
"参数设置/SOC差值区间":   `Intervallo Differenza SOC`,
"参数设置/算法调用频率":   `Frequenza Invocazione Algoritmo`,
"参数设置/单次均衡调节量":   `Quantità Regolata Singola Equalizzazione`,
"参数设置/均衡最大调节量":   `Quantità Massima Regolata Equalizzazione`,
"参数设置/均衡柜体数量":   `Numero Armadio Equalizzazione`,
"参数设置/均衡功率占比":   `Rapporto Potenza Equalizzazione`,
"参数设置/分配总功率":   `Potenza Totale Allocata`,
"参数设置/柜体可用状态":   `Stato Disponibile Armadio`,
"参数设置/SOC均衡开启的电压阈值":   `Avvio Equalizzazione SOC per Limite Tensione`,
"参数设置/输出值更新的延迟倍数":   `Multiplo Ritardo Aggiornamento Uscita`,
"参数设置/分配系数的最大变化范围":   `Allocazione Coefficiente Massimo Intervallo`,
"参数设置/生产老化":   `Invecchiamento Produzione`,
"参数设置/现场运行":   `Operazioni Sito`,
"参数设置/关闭":   `Chiudi`,
"参数设置/打开":   `Apri`,
"参数设置/不可分配":   `Non Allocato`,
"参数设置/可以分配":   `Allocato`,
"参数设置/远程开关机指令":   `Comando Remoto Accensione/Spegnimento Alimentazione`,
"参数设置/清除故障":   `Riparazione Guasto`,
"参数设置/EMS模式":   `Modalità EMS`,
"参数设置/硬件故障屏蔽":   `Scudo Guasto Hardware`,
"参数设置/标准设置":   `Set Standard`,
"参数设置/无功功率变化率设置":   `Set Tasso Variazione Potenza Reattiva`,
"参数设置/有功功率变化率设置":   `Set Tasso Variazione Potenza Attiva`,
"参数设置/电网代码":   `Codice di Rete`,
"参数设置/装备控制字":   `Parola Controllo Apparecchiatura`,
"参数设置/额定电压设置":   `Set Tensione Nominale`,
"参数设置/额定频率设置":   `Set Frequenza Nominale`,
"参数设置/额定功率设置":   `Set Potenza Nominale`,
"参数设置/过载系数设置":   `Set Coefficiente Sovraccarico`,
"参数设置/AFCI使能设置":   `Set Abilitazione AFCI`,
"参数设置/AFCI阈值设置":   `Set Soglia AFCI`,
"参数设置/绝缘阻抗告警阈值设置":   `Set Soglia Allarme Impedenza Isolamento`,
"参数设置/电网一级过压阈值设置":   `Set Soglia Livello1 Sovratensione Rete`,
"参数设置/电网一级过压时间设置":   `Set Soglia Tempo Livello1 Sovratensione Rete`,
"参数设置/电网二级过压阈值设置":   `Set Soglia Livello2 Sovratensione Rete`,
"参数设置/电网二级过压时间设置":   `Set Soglia Tempo Livello2 Sovratensione Rete`,
"参数设置/电网一级欠压阈值设置":   `Set Soglia Livello1 Sottotensione Rete`,
"参数设置/电网一级欠压时间设置":   `Set Soglia Tempo Livello1 Sottotensione Rete`,
"参数设置/电网二级欠压阈值设置":   `Set Soglia Livello2 Sottotensione Rete`,
"参数设置/电网二级欠压时间设置":   `Set Soglia Tempo Livello2 Sottotensione Rete`,
"参数设置/电网一级过频阈值设置":   `Set Soglia Livello1 Sovrafrequenza Rete`,
"参数设置/电网一级过频时间设置":   `Set Soglia Tempo Livello1 Sovrafrequenza Rete`,
"参数设置/电网二级过频阈值设置":   `Set Soglia Livello2 Sovrafrequenza Rete`,
"参数设置/电网二级过频时间设置":   `Set Soglia Tempo Livello2 Sovrafrequenza Rete`,
"参数设置/电网一级欠频阈值设置":   `Set Soglia Livello1 Sottofrequenza Rete`,
"参数设置/电网一级欠频时间设置":   `Set Soglia Tempo Livello1 Sottofrequenza Rete`,
"参数设置/电网二级欠频阈值设置":   `Set Soglia Livello2 Sottofrequenza Rete`,
"参数设置/电网二级欠频时间设置":   `Set Soglia Tempo Livello2 Sottofrequenza Rete`,
"参数设置/程序默认值(只读)":   `Valore Predefinito (Sola Lettura)`,
"参数设置/事件记录存储地址(只读)":   `Indirizzo Salvataggio Registro Eventi (Sola Lettura)`,
"参数设置/历史事件记录数量(只读)":   `Numero Registro Eventi Storici (Sola Lettura)`,
"参数设置/PV侧电流给定":   `Impostazione Corrente PV`,
"参数设置/非标设置字":   `Parola Impostazione Non Standard`,
"参数设置/PV并联模式使能":   `Abilitazione Modalità Connessione Parallela PV`,
"参数设置/孤岛保护使能":   `Abilitazione Protezione Isola`,
"参数设置/总母线电压环Kp":   `Kp Anello Tensione Bus Principale`,
"参数设置/总母线电压环Ki":   `Ki Anello Tensione Bus Principale`,
"参数设置/并网电感电流环 Kp":   `Kp Anello Corrente Induttanza Connessione Rete`,
"参数设置/并网电感电流环 Ki":   `Ki Anello Corrente Induttanza Connessione Rete`,
"参数设置/离网逆变电压环 Kp":   `Kp Anello Tensione Inverter Off-Grid`,
"参数设置/离网逆变电压环 Ki":   `Ki Anello Tensione Inverter Off-Grid`,
"参数设置/离网逆变电流环 Kp":   `Kp Anello Corrente Inverter Off-Grid`,
"参数设置/离网逆变电流环 Ki":   `Ki Anello Corrente Inverter Off-Grid`,
"参数设置/平衡桥电压环 Kp":   `Kp Anello Tensione Ponte Bilanciamento`,
"参数设置/平衡桥电压环 Ki":   `Ki Anello Tensione Ponte Bilanciamento`,
"参数设置/平衡桥电流环 Kp":   `Kp Anello Corrente Ponte Bilanciamento`,
"参数设置/平衡桥电流环 Ki":   `Ki Anello Corrente Ponte Bilanciamento`,
"参数设置/离网逆变直流电压分量环 Kp":   `Kp Anello Componente CC Tensione Inverter Off-Grid`,
"参数设置/离网逆变直流电压分量环 Ki":   `Ki Anello Componente CC Tensione Inverter Off-Grid`,
"参数设置/A相电网电压校准系数K":   `Coefficiente Calibrazione K Tensione Rete Fase A`,
"参数设置/A相电网电压偏置系数B":   `Coefficiente Scostamento B Tensione Rete Fase A`,
"参数设置/B相电网电压校准系数K":   `Coefficiente Calibrazione K Tensione Rete Fase B`,
"参数设置/B相电网电压偏置系数B":   `Coefficiente Scostamento B Tensione Rete Fase B`,
"参数设置/C相电网电压校准系数K":   `Coefficiente Calibrazione K Tensione Rete Fase C`,
"参数设置/C相电网电压偏置系数B":   `Coefficiente Scostamento B Tensione Rete Fase C`,
"参数设置/A相电感电流校准系数K":   `Coefficiente Calibrazione K Corrente Induttanza Fase A`,
"参数设置/A相电感电流偏置系数B":   `Coefficiente Scostamento B Corrente Induttanza Fase A`,
"参数设置/B相电感电流校准系数K":   `Coefficiente Calibrazione K Corrente Induttanza Fase B`,
"参数设置/B相电感电流偏置系数B":   `Coefficiente Scostamento B Corrente Induttanza Fase B`,
"参数设置/C相电感电流校准系数K":   `Coefficiente Calibrazione K Corrente Induttanza Fase C`,
"参数设置/C相电感电流偏置系数B":   `Coefficiente Scostamento B Corrente Induttanza Fase C`,
"参数设置/PV1电压校准系数K":   `Coefficiente Calibrazione K Tensione PV1`,
"参数设置/PV1电压校准系数B":   `Coefficiente Scostamento B Tensione PV1`,
"参数设置/PV2电压校准系数K":   `Coefficiente Calibrazione K Tensione PV2`,
"参数设置/PV2电压校准系数B":   `Coefficiente Scostamento B Tensione PV2`,
"参数设置/PV3电压校准系数K":   `Coefficiente Calibrazione K Tensione PV3`,
"参数设置/PV3电压校准系数B":   `Coefficiente Scostamento B Tensione PV3`,
"参数设置/PV4电压校准系数K":   `Coefficiente Calibrazione K Tensione PV4`,
"参数设置/PV4电压校准系数B":   `Coefficiente Scostamento B Tensione PV4`,
"参数设置/PV1电流校准系数K":   `Coefficiente di Calibrazione Corrente PV1 K`,
"参数设置/PV1电流校准系数B":   `Coefficiente di Calibrazione Corrente PV1 B`,
"参数设置/PV2电流校准系数K":   `Coefficiente di Calibrazione Corrente PV2 K`,
"参数设置/PV2电流校准系数B":   `Coefficiente di Calibrazione Corrente PV2 B`,
"参数设置/PV3电流校准系数K":   `Coefficiente di Calibrazione Corrente PV3 K`,
"参数设置/PV3电流校准系数B":   `Coefficiente di Calibrazione Corrente PV3 B`,
"参数设置/PV4电流校准系数K":   `Coefficiente di Calibrazione Corrente PV4 K`,
"参数设置/PV4电流校准系数B":   `Coefficiente di Calibrazione Corrente PV4 B`,
"参数设置/DCDC1电流校准系数K":   `Coefficiente di Calibrazione Corrente DCDC1 K`,
"参数设置/DCDC1电流校准系数B":   `Coefficiente di Calibrazione Corrente DCDC1 B`,
"参数设置/DCDC2电流校准系数K":   `Coefficiente di Calibrazione Corrente DCDC2 K`,
"参数设置/DCDC2电流校准系数B":   `Coefficiente di Calibrazione Corrente DCDC2 B`,
"参数设置/DCDC3电流校准系数K":   `Coefficiente di Calibrazione Corrente DCDC3 K`,
"参数设置/DCDC3电流校准系数B":   `Coefficiente di Calibrazione Corrente DCDC3 B`,
"参数设置/DCDC4电流校准系数K":   `Coefficiente di Calibrazione Corrente DCDC4 K`,
"参数设置/DCDC4电流校准系数B":   `Coefficiente di Calibrazione Corrente DCDC4 B`,
"参数设置/DCDC低压侧电压校准系数K":   `Coefficiente di Calibrazione Tensione DCDC K Lato Bassa Tensione`,
"参数设置/DCDC低压侧电压校准系数B":   `Coefficiente di Calibrazione Tensione DCDC B Lato Bassa Tensione`,
"参数设置/电池电压校准系数K":   `Coefficiente di Calibrazione Tensione Batteria K`,
"参数设置/电池电压校准系数B":   `Coefficiente di Calibrazione Tensione Batteria B`,
"参数设置/电池电流校准系数K":   `Coefficiente di Calibrazione Corrente Batteria K`,
"参数设置/电池电流校准系数B":   `Coefficiente di Calibrazione Corrente Batteria B`,
"参数设置/直流母线准校系数K":   `Coefficiente di Calibrazione Bus CC K`,
"参数设置/直流母线准校系数B":   `Coefficiente di Calibrazione Tensione Bus CC B`,
"参数设置/直流正半母线校准系数K":   `Coefficiente di Calibrazione Tensione Semi-Bus Positivo CC K`,
"参数设置/直流正半母线校准系数B":   `Coefficiente di Calibrazione Semi-Bus Positivo CC B`,
"参数设置/直流负半母线校准系数K":   `Coefficiente di Calibrazione Semi-Bus Negativo CC K`,
"参数设置/直流负半母线校准系数B":   `Coefficiente di Calibrazione Semi-Bus Negativo CC B`,
"参数设置/离网电流A相校准系数K":   `Coefficiente di Calibrazione Corrente Fase A Fuori Rete K`,
"参数设置/离网电流A相校准系数B":   `Coefficiente di Calibrazione Corrente Fase A Fuori Rete B`,
"参数设置/离网电流B相校准系数K":   `Coefficiente di Calibrazione Corrente Fase B Fuori Rete K`,
"参数设置/离网电流B相校准系数B":   `Coefficiente di Calibrazione Corrente Fase B Fuori Rete B`,
"参数设置/离网电流C相校准系数K":   `Coefficiente di Calibrazione Corrente Fase C Fuori Rete K`,
"参数设置/离网电流C相校准系数B":   `Coefficiente di Calibrazione Corrente Fase C Fuori Rete B`,
"参数设置/并网":   `Connessione alla Rete`,
"参数设置/离网":   `Fuori Rete`,
"参数设置/不清除":   `Non Chiaro`,
"参数设置/故障清除":   `Chiaro`,
"参数设置/不屏蔽":   `Non Schermato`,
"参数设置/屏蔽":   `Schermato`,
"参数设置/意大利标准":   `Standard Italia`,
"参数设置/eBlock解锁开关":   `Interruttore Sblocco eBlock`,
"参数设置/均衡算法开关":   `Interruttore Algoritmo Equalizzazione`,
"参数设置/电池电压充电P1级过压":   `Sovratensione Carica Batteria P1`,
"参数设置/电池电压充电P2级过压":   `Sovratensione Carica Batteria P2`,
"参数设置/电池电压充电P3级过压":   `Sovratensione Carica Batteria P3`,
"参数设置/电池电压充电过压截止":   `Soglia Sovratensione Carica Batteria`,
"参数设置/电池电压放电P1级欠压":   `Sottotensione Scarica Batteria P1`,
"参数设置/电池电压放电P2级欠压":   `Sottotensione Scarica Batteria P2`,
"参数设置/电池电压放电P3级欠压":   `Sottotensione Scarica Batteria P3`,
"参数设置/电池电压放电欠压截止":   `Soglia Sottotensione Scarica Batteria`,
"参数设置/电池温度充电P1级过温":   `Sovratemperatura Carica Batteria P1`,
"参数设置/电池温度充电P2级过温":   `Sovratemperatura Carica Batteria P2`,
"参数设置/电池温度充电P3级过温":   `Sovratemperatura Carica Batteria P3`,
"参数设置/电池温度充电过温截止":   `Soglia Sovratemperatura Carica Batteria`,
"参数设置/电池温度充电P1级欠温":   `Sottotemperatura Carica Batteria P1`,
"参数设置/电池温度充电P2级欠温":   `Sottotemperatura Carica Batteria P2`,
"参数设置/电池温度充电P3级欠温":   `Sottotemperatura Carica Batteria P3`,
"参数设置/电池温度充电欠温截止":   `Soglia Sottotemperatura Carica Batteria`,
"参数设置/电池温度放电P1级过温":   `Sovratemperatura Scarica Batteria P1`,
"参数设置/电池温度放电P2级过温":   `Sovratemperatura Scarica Batteria P2`,
"参数设置/电池温度放电P3级过温":   `Sovratemperatura Scarica Batteria P3`,
"参数设置/电池温度放电过温截止":   `Soglia Sovratemperatura Scarica Batteria`,
"参数设置/电池温度放电P1级欠温":   `Sottotemperatura Scarica Batteria P1`,
"参数设置/电池温度放电P2级欠温":   `Sottotemperatura Scarica Batteria P2`,
"参数设置/电池温度放电P3级欠温":   `Sottotemperatura Scarica Batteria P3`,
"参数设置/电池温度放电欠温截止":   `Soglia Sottotemperatura Scarica Batteria`,
"参数设置/电池总压1级过压":   `Sovratensione Totale Batteria P1`,
"参数设置/电池总压2级过压":   `Sovratensione Totale Batteria P2`,
"参数设置/电池总压3级过压":   `Sovratensione Totale Batteria P3`,
"参数设置/电池总压过压截止":   `Soglia Sovratensione Totale Batteria`,
"参数设置/电池总压1级欠压":   `Sottotensione Totale Batteria P1`,
"参数设置/电池总压2级欠压":   `Sottotensione Totale Batteria P2`,
"参数设置/电池总压3级欠压":   `Sottotensione Totale Batteria P3`,
"参数设置/电池总压欠压截止":   `Soglia Sottotensione Totale Batteria`,
"参数设置/电池电流充电P1级过流":   `Sovracorrente Carica Cella P1`,
"参数设置/电池电流充电P2级过流":   `Sovracorrente Carica Cella P2`,
"参数设置/电池电流充电P3级过流":   `Sovracorrente Carica Cella P3`,
"参数设置/电池电流充电过流截止":   `Soglia Sovracorrente Carica Cella`,
"参数设置/电池电流放电P1级过流":   `Sovracorrente Scarica Cella P1`,
"参数设置/电池电流放电P2级过流":   `Scarica Cella Sovracorrente P2`,
"参数设置/电池电流放电P3级过流":   `Scarica Cella Sovracorrente P3`,
"参数设置/电池电流放电过流截止":   `Interruzione Scarica Cella Sovracorrente`,
"参数设置/电池电压充电P1级极差":   `Differenza Tensione Carica Batteria P1`,
"参数设置/电池电压充电P2级极差":   `Differenza Tensione Carica Batteria P2`,
"参数设置/电池电压充电P3级极差":   `Differenza Tensione Carica Batteria P3`,
"参数设置/电池电压充电极差截止":   `Interruzione Differenza Tensione Carica Batteria`,
"参数设置/电池电压放电P1级极差":   `Differenza Tensione Scarica Batteria P1`,
"参数设置/电池电压放电P2级极差":   `Differenza Tensione Scarica Batteria P2`,
"参数设置/电池电压放电P3级极差":   `Differenza Tensione Scarica Batteria P3`,
"参数设置/电池电压放电极差截止":   `Interruzione Differenza Tensione Scarica Batteria`,
"参数设置/电池温度充电P1级极差":   `Differenza Temperatura Carica Batteria P1`,
"参数设置/电池温度充电P2级极差":   `Differenza Temperatura Carica Batteria P2`,
"参数设置/电池温度充电P3级极差":   `Differenza Temperatura Carica Batteria P3`,
"参数设置/电池温度充电极差截止":   `Interruzione Differenza Temperatura Carica Batteria`,
"参数设置/电池温度放电P1级极差":   `Differenza Temperatura Scarica Batteria P1`,
"参数设置/电池温度放电P2级极差":   `Differenza Temperatura Scarica Batteria P2`,
"参数设置/电池温度放电P3级极差":   `Differenza Temperatura Scarica Batteria P3`,
"参数设置/电池温度放电极差截止":   `Interruzione Differenza Temperatura Scarica Batteria`,
"参数设置/被动均衡模式":   `Modalità Equalizzazione Passiva`,
"参数设置/电压过欠压解锁开关":   `Interruttore Sblocco Sovra/Sottotensione`,
"参数设置/电气火灾解锁开关":   `Interruttore Sblocco Incendio Elettrico`,
"参数设置/手动均衡电压":   `Tensione Equalizzazione Manuale`,
"参数设置/自动模式":   `Modalità Automatica`,
"参数设置/手动模式":   `Modalità Manuale`,
"参数设置/无效":   `Inefficace`,
"参数设置/解锁":   `Sblocca`,
"参数设置/开启电压平均值均衡":   `Avvia Algoritmo Equalizzazione Tensione Media`,
"参数设置/开启电量均衡算法":   `Avvia Algoritmo Equalizzazione Energia`,
"参数设置/关闭均衡算法":   `Chiudi Algoritmo Equalizzazione`,
"参数设置/确定":   `Conferma`,
"参数设置/取消":   `Annulla`,
"参数设置/新增策略":   `Aggiungi Strategia`,
"参数设置/编辑策略":   `Modifica Strategia`,
"参数设置/编辑":   `Modifica`,
"参数设置/删除":   `Elimina`,
"参数设置/策略删除成功":   `Strategia Eliminata con Successo`,
"参数设置/最后一条策略的结束时间已经为23:59，不能再新增策略":   `L'ora di fine dell'ultima strategia è 23:59, non è possibile aggiungere una nuova strategia`,
"参数设置/设置成功":   `Impostazione Riuscita`,
"参数设置/设置失败":   `Impostazione Fallita`,
"参数设置/正在设置，请稍等...":   `Impostazione, attendere...`,
"参数设置/单个设备设置后，同一个组内的其他设备会自动同步设置":   `Dopo l'impostazione di un singolo dispositivo, gli altri dispositivi nello stesso gruppo sincronizzeranno automaticamente l'impostazione`,
"参数设置/读取成功":   `Lettura riuscita`,
"参数设置/协议帧格式有误":   `Errore formato frame protocollo`,
"参数设置/的dev_id不存在":   `Il dev_id non esiste`,
"参数设置/确定下发?":   `Confermare l'invio?`,
"参数设置/系统提示":   `Promemoria di sistema`,
"参数设置/设置箱变容量配比":   `Imposta rapporto capacità trasformatore`,
"参数设置/eBlock启停":   `Avvio-arresto eBlock`,
"参数设置/操作成功":   `Operazione riuscita`,
"参数设置/能量链":   `eLink`,
"参数设置/正在读取，请稍等...":   `Lettura in corso, attendere...`,
"参数设置/读取失败":   `Lettura fallita`,
"参数设置/是否更新缓存":   `Aggiornare la cache?`,
"参数设置/请输入功率":   `Inserire la potenza`,
"参数设置/请选择开始时间":   `Selezionare l'ora di inizio`,
"参数设置/请选择结束时间":   `Selezionare l'ora di fine`,  
'参数设置/BMU控制参数': 'Parametri di controllo BMU',
'参数设置/eBlock启用': 'eBlock Attivato',
'参数设置/eBlock停用': 'eBlock Disattivato',
'参数设置/实时控制': 'Controllo in tempo reale',
'参数设置/请设置参数值': 'Inserire il valore del parametro',

"空调运行参数设定/历史记录":   `Cronologia`,
"空调运行参数设定/空调参数":   `Parametri climatizzatore`,
"空调运行参数设定/设置结果":   `Risultato impostazione`,
"空调运行参数设定/未同步":   `Non sincronizzato`,
"空调运行参数设定/同步":   `Sincronizzato`,
"空调运行参数设定/上报时间":   `Data rapporto`,
"空调运行参数设定/查看上报数据":   `Visualizza dati rapporto`,
"空调运行参数设定/当前数据":   `Dati attuali`,
"空调运行参数设定/设置":   `Imposta`,
"空调运行参数设定/无上报数据":   `Nessun dato rapporto`,
"空调运行参数设定/删除":   `Elimina`,
"空调运行参数设定/新增":   `Nuovo`,
"空调运行参数设定/取消":   `Annulla`,
"空调运行参数设定/确定":   `Conferma`,
"空调运行参数设定/空调参数设置历史":   `Cronologia impostazioni parametri climatizzatore`,
"空调运行参数设定/eBlock空调参数":   `Parametri climatizzatore eBlock`,
"空调运行参数设定/eLink空调参数":   `Parametri climatizzatore eLink`,
"空调运行参数设定/开始时间":   `Ora inizio`,
"空调运行参数设定/结束时间":   `Ora fine`,
"空调运行参数设定/起始工作功率":   `Potenza inizio`,
"空调运行参数设定/结束工作功率":   `Potenza fine`,
"空调运行参数设定/制冷开始温度":   `Temperatura avvio raffreddamento`,
"空调运行参数设定/制冷结束温度":   `Temperatura fine raffreddamento`,
"空调运行参数设定/制热开始温度":   `Temperatura Iniziale Riscaldamento`,
"空调运行参数设定/制热结束温度":   `Temperatura Finale Riscaldamento`,
"空调运行参数设定/操作时间":   `Tempo di Funzionamento`,
"空调运行参数设定/操作者":   `Operatore`,
"空调运行参数设定/关闭":   `Chiudi`,
"空调运行参数设定/上报数据":   `Dati del Report`,
"空调运行参数设定/eBlock空调":   `Condizionatore eBlock`,
"空调运行参数设定/eLink空调":   `Condizionatore eLink`,
"空调运行参数设定/删除最后一行":   `Elimina Ultima Riga`,
"空调运行参数设定/新增一行":   `Aggiungi Nuova Riga`,
"空调运行参数设定/空调参数设置":   `Impostazione Parametri Condizionatore`,
"空调运行参数设定/时间区间未覆盖0-24h":   `Intervallo Temporale Non Copre 0-24h`,
"空调运行参数设定/结束时间已经是23:59, 请修改结束时间后再添加":   `L'ora finale è 23:59, modificare l'ora finale e poi aggiungere`,
"空调运行参数设定/最后一条不允许删除":   `L'ultima riga non può essere eliminata`,
"故障录波/故障录波":   `Registro Guasti`,
"故障录波/全部":   `Totale`,
"故障录波/搜索":   `Cerca`,
"故障录波/输入文件名搜索":   `Inserisci Nome File per Cercare`,
"故障录波/重置":   `Ripristina`,
"故障录波/文件名":   `Nome File`,
"故障录波/文件大小":   `Dimensione File`,
"故障录波/上传时间":   `Ora di Caricamento`,
"故障录波/操作":   `Operazione`,
"故障录波/暂无数据":   `Nessun Dato`,
"故障录波/名称":   `Nome`,
"故障录波/下载":   `Scarica`,
"功率跟踪/时间":   `Ora`,
"功率跟踪/至":   `A`,
"功率跟踪/能量链":   `eLink`,
"功率跟踪/能量块":   `eBlock`,
"功率跟踪/全部":   `Totale`,
"功率跟踪/查询":   `Cerca`,
"功率跟踪/重置":   `Ripristina`,
"功率跟踪/变压器容量":   `Capacità Trasformatore`,
"功率跟踪/2号":   `2#`,
"功率跟踪/储能单元SOC-功率跟踪分析曲线":   `Curva di Analisi Tracciamento Potenza - SOC Unità di Accumulo`,
"功率跟踪/功率":   `Potenza`,
"功率跟踪/策略":   `Strategia`,
"功率跟踪/最大需量":   `Domanda Massima`,
"功率跟踪/数据间隔":   `Intervallo Dati`,
"功率跟踪/分钟":   `Minuto`,
"功率跟踪/小时":   `Ora`,
"功率跟踪/天":   `Giorno`,
"功率跟踪/月":   `Mese`,
"功率跟踪/选择时间":   `Seleziona Data`,
"功率跟踪/选择设备":   `Seleziona Attrezzatura`,
"功率跟踪/选择类型":   `Seleziona Tipo`,
"功率跟踪/SOC-功率曲线":   `Curva SOC-Potenza`,
"功率跟踪/电能来源曲线":   `Curva Fonte di Energia`,
"功率跟踪/充放电数据":   `Dati Carica-Scarica`,
"功率跟踪/负载曲线":   `Curva di Carico`,
"功率跟踪/电池功率":   `Potenza Batteria`,
"功率跟踪/PV功率":   `Potenza Fotovoltaico`,
"功率跟踪/电网":   `Rete`,
"功率跟踪/光伏":   `Fotovoltaico`,
"功率跟踪/重要负载":   `Carico Importante`,
"功率跟踪/非重要负载":   `Carico Non Importante`,
"负荷跟踪/负荷跟踪":   `Monitoraggio Carico`,
"负荷跟踪/时间":   `Data`,
"负荷跟踪/刷新":   `Aggiorna`,
"负荷跟踪/导出":   `Scarica`,
"负荷跟踪/功率":   `Potenza`,
"负荷跟踪/全选":   `Seleziona Tutto`,
"负荷跟踪/收起":   `Espandi`,
"负荷跟踪/展开":   `Riduci`,
"负荷跟踪/实体电表":   `Contatore Fisico`,
"负荷跟踪/虚拟电表":   `Contatore Virtuale`,
"负荷跟踪/暂无":   `Nessun Dato`,
"负荷跟踪/填加虚拟电表":   `Nuovo Contatore Virtuale`,
"负荷跟踪/虚拟电表名称":   `Nome Contatore Virtuale`,
"负荷跟踪/请输入虚拟电表名称":   `Inserisci Nome Contatore Virtuale`,
"负荷跟踪/虚拟电表取值":   `Valore Contatore Virtuale`,
"负荷跟踪/请选择电表":   `Seleziona Contatore`,
"负荷跟踪/加":   `Aggiungi`,
"负荷跟踪/减":   `Sottrai`,
"负荷跟踪/取消":   `Annulla`,
"负荷跟踪/确定":   `Conferma`,
"负荷跟踪/时间范围超过31天，请重新选择":   `L'intervallo temporale supera 31 giorni, seleziona di nuovo`,
"负荷跟踪/母线":   `Bus`,
"负荷跟踪/负载":   `Carico`,
"负荷跟踪/光伏":   `PV`,
"负荷跟踪/储能系统":   `Sistema di Accumulo di Energia`,
"负荷跟踪/充电桩":   `Stazione di Ricarica`,
"负荷跟踪/变压器":   `Trasformatore`,
"负荷跟踪/总需量":   `Domanda Totale`,
"负荷跟踪/删除提示":  (s) => `Sei sicuro di voler eliminare ${s}?`,
"负荷跟踪/删除成功":   `Eliminazione Riuscita`,
"负荷跟踪/添加成功":   `Aggiunta Riuscita`,
"负荷跟踪/更新成功":   `Aggiornamento Riuscito`,
"负荷跟踪/运行需量曲线":   `Curva di Domanda in Esecuzione`,
"负荷跟踪/并网点功率":   `Potenza del Contatore in Rete`,
"负荷跟踪/关口表功率":   `Potenza del Contatore PCC`,
"负荷跟踪/负载功率":   `Potenza del Carico`,
"负荷跟踪/需量":   `Domanda`,
"负荷跟踪/全部":   `Tutto`,
"负荷跟踪/查询":   `Cerca`,
"负荷跟踪/重置":   `Ripristina`,
"充放电记录/时间":   `Ora`,
"充放电记录/至":   `A`,
"充放电记录/能量链":   `eLink`,
"充放电记录/查询":   `Cerca`,
"充放电记录/导出":   `Scarica`,
"充放电记录/重置":   `Ripristina`,
"充放电记录/充放电记录":   `Registro Carica-Scarica`,
"充放电记录/设备名称":   `Nome Attrezzatura`,
"充放电记录/充放电类型":   `Tipo Carica-Scarica`,
"充放电记录/平均功率":   `Potenza Media`,
"充放电记录/累计电能":   `Energia Accumulata`,
"充放电记录/起始时间":   `Ora di Inizio`,
"充放电记录/结束时间":   `Ora di Fine`,
"充放电记录/起始soc":   `SOC Iniziale`,
"充放电记录/结束soc":   `SOC Finale`,
"充放电记录/起始电表读数":   `Lettura Iniziale del Contatore`,
"充放电记录/结束电表读数":   `Lettura Finale del Contatore`,
"充放电记录/充电":   `Carica`,
"充放电记录/放电":   `Scarica`,
"充放电记录/充放电时长":   `Durata Carica-Scarica`,
"充放电记录/能量块":   `eBlock`,
"充放电记录/开始日期":   `Data di Inizio`,
"充放电记录/结束日期":   `Data di Fine`,
"充放电记录/请选择能量链":   `Seleziona eLink`,
"充放电记录/请选择能量块":   `Seleziona eBlock`,
"充放电记录/加载中...":   `Caricamento...`,
"充放电记录/正在导出...":   `Download in corso...`,
"充放电记录/导出成功":   `Download completato`,
"充放电记录/请选择时间":   `Seleziona l'orario`,
"充放电记录/请选择设备":   `Seleziona l'apparecchiatura`,
"充放电记录/请选择类型":   `Seleziona il tipo`,
"充放电记录/全部":   `Tutti`,
"满充容量统计/请选择月份":   `Seleziona il mese`,
"满充容量统计/查询":   `Cerca`,
"满充容量统计/重置":   `Ripristina`,
"满充容量统计/满充容量统计":   `Statistiche capacità di carica completa`,
"满充容量统计/日期":   `Data`,
"需量分析/时间":   `Data`,
"需量分析/查询":   `Cerca`,
"需量分析/重置":   `Ripristina`,
"需量分析/需量跟踪曲线":   `Curva di tracciamento della domanda`,
"需量分析/需量":   `Domanda`,
"需量分析/实际需量":   `Domanda effettiva`,
"需量分析/负荷需量":   `Domanda di carico`,
"需量分析/储能需量":   `Domanda di accumulo energetico`,
"需量分析/暂无数据":   `Nessun dato`,
"需量分析/加载中":   `Caricamento`,
"需量分析/最大值":   `Massimo`,
"电压数据分析/电芯电压变化趋势":   `Tendenza variazione tensione cella`,
"电压数据分析/单体电芯健康度量化分析":   `Analisi quantitativa stato di salute cella`,
"电压数据分析/电芯单日电压变化":   `Variazione tensione cella giornaliera`,
"电压数据分析/时间":   `Data`,
"电压数据分析/查询":   `Cerca`,
"电压数据分析/重置":   `Ripristina`,
"电压数据分析/标准差":   `Deviazione standard`,
"电压数据分析/标准差单日值":   `Deviazione standard giornaliera`,
"电压数据分析/电压":   `Tensione`,
"电压数据分析/电压累计差":   `Differenza accumulata tensione`,
"电压数据分析/电芯位置":   `Indice cella`,
"电压数据分析/请选择Pack":   `Seleziona il pacco`,
"电压数据分析/请选择能量块":   `Seleziona eBlock`,
"电压数据分析/请选择能量链":   `Seleziona eLink`,
"电压数据分析/开始日期":   `Data inizio`,
"电压数据分析/结束日期":   `Data fine`,
"电压数据分析/请选择时间":   `Seleziona l'orario`,
"电压数据分析/请选择设备":   `Seleziona l'attrezzatura`,
"电压数据分析/至":   `A`,
"电压数据分析/能量块":   `eBlock`,
"电压数据分析/能量链":   `eLink`,
"电压数据分析/最大值":   `Massimo`,
"电压数据分析/电芯电压":   `Tensione cella`,
"电压数据分析/电芯编号":   `Indice cella`,
"电压数据分析/请选择电芯":   `Seleziona cella`,
"电压一致性/电压一致性":   `Coerenza tensione`,
"电压一致性/压差":   `Differenza tensione`,
"电压一致性/压差对比":   `Confronto differenza tensione`,
"电压一致性/电芯电压对比":   `Confronto tensione cella`,
"电压一致性/方阵三相电压对比":   `Confronto tensione trifase matrice`,
"电压一致性/时间":   `Data`,
"电压一致性/至":   `A`,
"电压一致性/能量链":   `eLink`,
"电压一致性/能量块":   `eBlock`,
"电压一致性/请选择能量链":   `Seleziona eLink`,
"电压一致性/请选择能量块":   `Seleziona eBlock`,
"电压一致性/开始日期":   `Data inizio`,
"电压一致性/结束日期":   `Data fine`,
"电压一致性/全部":   `Tutto`,
"电压一致性/查询":   `Cerca`,
"电压一致性/重置":   `Ripristina`,
"电压一致性/电压":   `Tensione`,
"电压一致性/最高电压":   `Tensione massima`,
"电压一致性/最低电压":   `Tensione minima`,
"电压一致性/电芯电压标准差":   `Deviazione standard tensione cella`,
"电压一致性/最大压差":   `Differenza tensione massima`,
"电压一致性/正常电压范围":   `Intervallo tensione normale`,
"电压一致性/最大值":   `Valore massimo`,
"电压一致性/最大值电芯":   `Indice cella valore massimo`,
"电压一致性/AB线电压":   `Tensione linea AB`,
"电压一致性/BC线电压":   `Tensione linea BC`,
"电压一致性/CA线电压":   `Tensione linea CA`,
"电压一致性/暂无数据":   `Nessun dato`,
"电压一致性/最小值电芯":   `Indice cella valore minimo`,
"电压一致性/最小值":   `Valore minimo`,
"热管理分析/热管理分析":   `Analisi gestione termica`,
"热管理分析/Pack 电芯温度变化趋势":   `Tendenza della Variazione della Temperatura della Batteria`,
"热管理分析/PCS 温度变化趋势":   `Tendenza della Variazione della Temperatura del PCS`,
"热管理分析/电芯温度变化趋势":   `Tendenza della Variazione della Temperatura della Cella`,
"热管理分析/母排温度正负极历史曲线":   `Curva Storica della Temperatura del Bus Positivo e Negativo`,
"热管理分析/时间":   `Data`,
"热管理分析/至":   `A`,
"热管理分析/能量链":   `eLink`,
"热管理分析/能量块":   `eBlock`,
"热管理分析/请选择能量链":   `Seleziona eLink`,
"热管理分析/请选择能量块":   `Seleziona eBlock`,
"热管理分析/开始日期":   `Data Inizio`,
"热管理分析/结束日期":   `Data Fine`,
"热管理分析/全部":   `Tutto`,
"热管理分析/查询":   `Cerca`,
"热管理分析/重置":   `Ripristina`,
"热管理分析/电芯最高温度":   `Temperatura Massima della Cella`,
"热管理分析/电芯最低温度":   `Temperatura Minima della Cella`,
"热管理分析/柜体温度":   `Temperatura dell'Armadio`,
"热管理分析/电芯温度标准差":   `Deviazione Standard della Temperatura della Cella`,
"热管理分析/电芯温度25℃标准差":   `Deviazione Standard della Temperatura della Cella (media=25℃)`,
"热管理分析/PCS直流侧功率":   `Potenza in Corrente Continua del PCS`,
"热管理分析/柜体湿度":   `Umidità dell'Armadio`,
"热管理分析/空调状态":   `Stato del Condizionatore`,
"热管理分析/制冷":   `Raffreddamento`,
"热管理分析/制热":   `Riscaldamento`,
"热管理分析/加热":   `Riscaldamento`,
"热管理分析/除湿":   `Deumidificazione`,
"热管理分析/自循环":   `Autociclo`,
"热管理分析/温度":   `Temperatura`,
"热管理分析/温度标准差":   `Deviazione Standard della Temperatura`,
"热管理分析/功率":   `Potenza`,
"热管理分析/湿度":   `Umidità`,
"热管理分析/曲线选择":   `Seleziona Tipo di Curva`,
"热管理分析/最高":   `Temperatura Massima`,
"热管理分析/最低":   `Temperatura Minima`,
"热管理分析/PCS机箱温度":   `Temperatura del Telaio del PCS`,
"热管理分析/A相IGBT温度":   `Temperatura IGBT Fase A`,
"热管理分析/B相IGBT温度":   `Temperatura IGBT Fase B`,
"热管理分析/C相IGBT温度":   `Temperatura IGBT Fase C`,
"热管理分析/最大值":   `Temperatura Massima della Cella`,
"热管理分析/最大值电芯":   `Indice Massimo Temperatura Cella`,
"热管理分析/最小值":   `Temperatura Minima Cella`,
"热管理分析/最小值电芯":   `Indice Minimo Temperatura Cella`,
"热管理分析/正极":   `Positivo`,
"热管理分析/负极":   `Negativo`,
"热管理分析/正极温度":   `Temperatura Positiva`,
"热管理分析/负极温度":   `Temperatura Negativa`,
"热管理分析/A相IGBT温度1":   `Temperatura IGBT Fase A 1`,
"热管理分析/B相IGBT温度1":   `Temperatura IGBT Fase B 1`,
"热管理分析/C相IGBT温度1":   `Temperatura IGBT Fase C 1`,
"热管理分析/A相IGBT温度2":   `Temperatura IGBT Fase A 2`,
"热管理分析/B相IGBT温度2":   `Temperatura IGBT Fase B 2`,
"热管理分析/C相IGBT温度2":   `Temperatura IGBT Fase C 2`,
"热管理分析/日期范围过大，请选择范围为一天之内的日期":   `Intervallo di Date Troppo Ampio, Selezionare un Intervallo di un Giorno`,
"热管理分析/暂无数据":   `Nessun Dato`,
"储能分析/充放电效率统计":   `Statistiche Efficienza Carica-Scarica`,
"储能分析/系统效率":   `Efficienza del Sistema`,
"储能分析/能量链":   `eLink`,
"储能分析/能量块":   `eBlock`,
"储能分析/查询":   `Cerca`,
"储能分析/重置":   `Ripristina`,
"储能分析/总充电效率":   `Efficienza Totale di Carica`,
"储能分析/总放电效率":   `Efficienza Totale di Scarica`,
"储能分析/总充放效率":   `Efficienza Totale Carica-Scarica`,
"储能分析/选择时间":   `Seleziona Ora`,
"储能分析/充电效率":   `Efficienza di Carica`,
"储能分析/放电效率":   `Efficienza di Scarica`,
"储能分析/效率":   `Efficienza`,
"储能分析/暂无数据":   `Nessun Dato`,
"储能分析/加载中":   `Caricamento`,
"储能分析/充放电日期":   `Data Carica-Scarica`,
"储能分析/电量":   `Elettricità`,
"储能分析/充电量":   `Carica`,
"储能分析/放电量":   `Scarica`,
"储能分析/时间":   `Data`,
"电能质量/三相平衡曲线":   `Curva di Equalizzazione delle Tre Fasi`,
"电能质量/方阵":   `Matrice`,
"电能质量/查询":   `Cerca`,
"电能质量/重置":   `Ripristina`,
"电能质量/关口三相不平衡度":   `Curva di Disequalizzazione delle Tre Fasi PCC`,
"电能质量/负载三相不平衡度":   `Curva di Squilibrio del Carico Trifase`,
"电能质量/不平衡度":   `Grado di Squilibrio`,
"电能质量/三相不平衡度":   `Grado di Squilibrio Trifase`,
"电能质量/并网点有功功率":   `Potenza Attiva GCP`,
"电能质量/关口点有功功率":   `Potenza Attiva PCC`,
"电能质量/负载有功功率":   `Potenza Attiva del Carico`,
"电能质量/系统无功-电压曲线":   `Curva Tensione-Potenza Reattiva del Sistema`,
"电能质量/关口电表AB线电压":   `Tensione di Linea AB al Contatore PCC`,
"电能质量/关口电表BC线电压":   `Tensione di Linea BC al Contatore PCC`,
"电能质量/关口电表CA线电压":   `Tensione di Linea CA al Contatore PCC`,
"电能质量/并网电表A相无功功率":   `Potenza Reattiva Fase A al Contatore GCP`,
"电能质量/并网电表B相无功功率":   `Potenza Reattiva Fase B al Contatore GCP`,
"电能质量/并网电表C相无功功率":   `Potenza Reattiva Fase C al Contatore GCP`,
"电能质量/请选择储能方阵":   `Selezionare la Matrice di Accumulo`,
"电能质量/请选择电站单元":   `Selezionare l'Unità di Stazione`,
"电能质量/A相":   `Fase A`,
"电能质量/B相":   `Fase B`,
"电能质量/C相":   `Fase C`,
"电能质量/月":   `Mese`,
"电能质量/日":   `Giorno`,
"电能质量/电压":   `Tensione`,
"电能质量/无功功率":   `Potenza Reattiva`,
"电能质量/功率":   `Potenza`,
"电能质量/相":   `Fase`,
"电价趋势/时间":   `Data`,
"电价趋势/查询":   `Cerca`,
"电价趋势/重置":   `Ripristina`,
"电价趋势/电价":   `Tariffa`,
"电价趋势/分时电价":   `Prezzo Orario`,
"电价趋势/现货交易电价":   `Prezzo di Transazione Spot`,
"电表数据分析/查询":   `Cerca`,
"电表数据分析/重置":   `Ripristina`,
"电表数据分析/电表数据分析":   `Analisi Dati Contatore`,
"电表数据分析/有功功率":   `Potenza Attiva`,
"电表数据分析/无功功率":   `Potenza Reattiva`,
"电表数据分析/功率因数":   `Fattore di Potenza`,
"电表数据分析/功率":   `Potenza`,
"充电电量汇总/请选择月份":   `Selezionare il Mese`,
"充电电量汇总/查询":   `Cerca`,
"充电电量汇总/重置":   `Ripristina`,
"充电电量汇总/充电电量汇总":   `Riepilogo Energia di Ricarica`,
"充电电量汇总/日期":   `Data`,
"充电电量汇总/充电时间":   `Tempo di Ricarica`,
"充电电量汇总/充电量":   `Energia di Ricarica`,
"充电电量汇总/末端SOC":   `SOC Finale`,
"设备管理/添加电站单元":   `Nuova Unità Stazione`,
"设备管理/编辑电站单元":   `Modifica Unità Stazione`,
"设备管理/电站单元":   `Unità Stazione`,
"设备管理/变压器容量":   `Capacità Trasformatore`,
"设备管理/请输入电站单元名称":   `Inserisci il Nome dell'Unità Stazione`,
"设备管理/请输入变压器容量":   `Inserisci la Capacità del Trasformatore`,
"设备管理/取消":   `Annulla`,
"设备管理/确定":   `Conferma`,
"设备管理/搜索":   `Cerca`,
"设备管理/重置":   `Ripristina`,
"设备管理/新增":   `Nuovo`,
"设备管理/批量删除":   `Elimina in Blocco`,
"设备管理/电表名称":   `Nome Contatore`,
"设备管理/电表类型":   `Tipo Contatore`,
"设备管理/操作":   `Operazione`,
"设备管理/暂无数据":   `Nessun Dato`,
"设备管理/能量链名称":   `Nome eLink`,
"设备管理/产品型号":   `Modello Prodotto`,
"设备管理/能量块名称":   `Nome eBlock`,
"设备管理/额定功率":   `Potenza Nominale`,
"设备管理/容量":   `Capacità`,
"设备管理/删除后将丢失电站单元和设备的关系，你确定删除吗?":   `L'eliminazione interromperà la relazione tra l'unità stazione e l'attrezzatura, sei sicuro di voler eliminare?`,
"设备管理/提示":   `Suggerimento`,
"设备管理/删除成功":   `Eliminazione Riuscita`,
"设备管理/操作成功":   `Operazione Riuscita`,
"设备管理/删除":   `Elimina`,
"设备管理/编辑":   `Modifica`,
"设备管理/新增/编辑电表":   `Nuovo/Modifica Contatore`,
"设备管理/请输入uuid":   `Inserisci UUID`,
"设备管理/请输入电表名称":   `Inserisci Nome Contatore`,
"设备管理/请输入电表类型":   `Inserisci Tipo Contatore`,
"设备管理/请先选择要删除的项目":   `Seleziona l'Elemento da Eliminare`,
"设备管理/确定要删除这些电表吗？":   `Sei Sicuro di Voler Eliminare Questi Contatori?`,
"设备管理/删除选中的电表后，这些电表的信息将不可恢复":   `L'eliminazione dei Contatori Selezionati Renderà le Loro Informazioni Irrecuperabili`,
"设备管理/新增成功":   `Nuovo Riuscito`,
"设备管理/更新成功":   `Aggiornamento Riuscito`,
"设备管理/电表类型不正确":   `Tipo di Contatore Non Corretto`,
"设备管理/删除该电表后，该电表的信息将不可恢复":   `Eliminare il Contatore Renderà le Sue Informazioni Irrecuperabili`,
"设备管理/确定要删除该电表吗？":   `Sei Sicuro di Voler Eliminare Questo Contatore?`,
"设备管理/关口电表":   `Contatore PCC`,
"设备管理/计量电表":   `Contatore`,
"设备管理/并网点电表":   `Contatore GCP`,
"设备管理/备注":   `Nota`,
"设备管理/参数名称不能为空":   `Il Nome del Parametro Non Può Essere Vuoto`,
"设备管理/参数键名不能为空":   `Il Nome della Chiave del Parametro Non Può Essere Vuoto`,
"设备管理/参数键值不能为空":   `Il Valore della Chiave del Parametro Non Può Essere Vuoto`,
"设备管理/删除该能量链后，该能量链信息将不可恢复":   `Eliminare l'eLink Renderà le Sue Informazioni Irrecuperabili`,
"设备管理/确定要删除该能量链吗？":   `Sei Sicuro di Voler Eliminare Questo eLink?`,
"设备管理/删除选中的能量链后，这些能量链信息将不可恢复":   `Eliminare gli eLink Selezionati Renderà le Loro Informazioni Irrecuperabili`,
"设备管理/确定要删除这些能量链吗？":   `Sei Sicuro di Voler Eliminare Questi eLink?`,
"设备管理/新增/编辑能量链":   `Nuovo/Modifica eLink`,
"设备管理/关联电表":   `Contatore Associato`,
"设备管理/请输入能量链名称":   `Inserisci il Nome dell'eLink`,
"设备管理/修改成功":   `Modifica Riuscita`,
"设备管理/删除该能量块后，该能量块信息将不可恢复":   `Eliminare l'eBlock Renderà le Sue Informazioni Irrecuperabili`,
"设备管理/确定要删除该能量块吗？":   `Sei Sicuro di Voler Eliminare Questo eBlock?`,
"设备管理/删除选中的能量块后，这些能量块信息将不可恢复":   `Eliminare gli eBlock Selezionati Renderà le Loro Informazioni Irrecuperabili`,
"设备管理/确定要删除这些能量块吗？":   `Sei Sicuro di Voler Eliminare Questi eBlock?`,
"设备管理/新增/编辑能量块":   `Nuovo/Modifica eBlock`,
"设备管理/装机功率":   `Potenza Nominale`,
"设备管理/请输入能量块名称":   `Inserisci il Nome dell'eBlock`,
"设备管理/请输入能量块型号":   `Inserisci il Modello dell'eBlock`,
"设备管理/请输入能量块容量":   `Inserisci la Capacità dell'eBlock`,
"设备管理/请输入能量块额定功率":   `Inserisci la Potenza Nominale dell'eBlock`,
"设备管理/请输入能量块额定容量":   `Inserisci la Capacità Nominale dell'eBlock`,
"设备管理/请输入能量块额定电压":   `Inserisci la Tensione Nominale dell'eBlock`,

'设备管理/设备名称': 'Nome dell\'Attrezzatura',
'设备管理/设备型号': 'Modello dell\'Attrezzatura',
'设备管理/光伏名称': 'Nome del Fotovoltaico',
'设备管理/厂家名称': 'Nome del Fabbricante',
'设备管理/产品型号': 'Modello del Prodotto',
'设备管理/关联设备ID': 'ID dell\'Attrezzatura Associata',
'设备管理/设备SN': 'SN dell\'Attrezzatura',
'设备管理/备注': 'Nota',
'设备管理/确定要删除该光伏吗？': 'Sei Sicuro di Voler Eliminare Questo Fotovoltaico?',
'设备管理/确定要删除这些光伏吗？': 'Sei Sicuro di Voler Eliminare Questi Fotovoltaici?',
'设备管理/删除选中的光伏后，这些光伏信息将不可恢复': 'Eliminare i Fotovoltaici Selezionati Renderà le Loro Informazioni Irrecuperabili',
'设备管理/添加成功!': 'Aggiunta Riuscita!',
'设备管理/更新成功!': 'Aggiornamento Riuscito!',
'设备管理/删除成功!': 'Eliminazione Riuscita!',
'设备管理/请先选择要删除的项目': 'Seleziona l\'Elemento da Eliminare',
'设备管理/新增/编辑光伏': 'Nuovo/Modifica Fotovoltaico',
'设备管理/请输入光伏名称': 'Inserisci il Nome del Fotovoltaico',
'设备管理/请输入厂家名称': 'Inserisci il Nome del Fabbricante',
'设备管理/请输入产品型号': 'Inserisci il Modello del Prodotto',
'设备管理/请输入关联设备ID': 'Inserisci l\'ID dell\'Attrezzatura Associata',
'设备管理/请输入设备SN': 'Inserisci il SN dell\'Attrezzatura',
'设备管理/请输入备注': 'Inserisci la Nota',
'设备管理/请输入UUID': 'Inserisci il UUID',
'设备管理/删除该光伏后，该光伏信息将不可恢复': 'Eliminare il Fotovoltaico Renderà le Sue Informazioni Irrecuperabili',

"设备型号/型号名称":   `Nome del Modello`,
"设备型号/设备类型":   `Modello dell'Attrezzatura`,
"设备型号/请输入型号名称":   `Inserisci il Nome del Modello`,
"设备型号/搜索":   `Cerca`,
"设备型号/重置":   `Ripristina`,
"设备型号/隐藏搜索":   `Nascondi Ricerca`,
"设备型号/刷新":   `Aggiorna`,
"设备型号/型号编号":   `Codice del Modello`,
"设备型号/PACK数量":   `Numero PACK`,
"设备型号/电芯总数":   `Numero di Cella`,
"设备型号/型号版本":   `Versione del Modello`,
"设备型号/额定功率":   `Potenza Nominale`,
"设备型号/设计容量":   `Capacità`,
"设备型号/操作":   `Operazione`,
"设备型号/请输入型号编号":   `Inserisci il Codice del Modello`,
"设备型号/请输入PACK数量":   `Inserisci il Numero del PACK`,
"设备型号/请输入电芯总数":   `Inserisci il Numero di Cella`,
"设备型号/请输入型号版本":   `Inserisci la Versione del Modello`,
"设备型号/请输入额定功率":   `Inserisci la Potenza Nominale`,
"设备型号/请输入设计容量":   `Inserisci la Capacità`,
"设备型号/请输入额定电压":   `Inserisci la Tensione Nominale`,
"设备型号/添加设备型号基本信息":   `Aggiungi Informazioni Base del Modello`,
"设备型号/修改设备型号基本信息":   `Modifica Informazioni Base del Modello`,
"设备型号/修改成功":   `Modifica Riuscita`,
"设备型号/新增成功":   `Nuovo Riuscito`,
"设备型号/删除成功":   `Eliminazione Riuscita`,
"设备型号/警告":   `Avviso`,
"设备型号/是否确认删除型号":   `Sei Sicuro di Voler Eliminare il Modello?`,
"设备型号/PACK数量必须是整数":   `Il Numero del PACK Deve Essere un Intero`,
"设备型号/电芯数量必须是整数":   `Il Numero di Cella Deve Essere un Intero`,
"设备型号/删除提示":  (names) => `Sei sicuro di voler eliminare il modello [${names}]?`,
"设备型号/确定":   `Conferma`,
"设备型号/取消":   `Annulla`,
"设备型号/新增":   `Nuovo`,
"设备型号/修改":   `Modifica`,
"设备型号/删除":   `Elimina`,
"设备型号/能量块":   `eBlock`,
"设备型号/能量链":   `eLink`,
"设备型号/电表":   `Contatore`,
'设备型号/设备品牌': 'Nome del Fabbricante',
'设备型号/光伏': 'Fotovoltaico',
'设备型号/充电桩': 'Caricabatterie',

"电站管理/筛选":   `Filtro`,
"电站管理/电站名称":   `Nome della Stazione`,
"电站管理/输入电站名称进行搜索":   `Inserisci il Nome della Stazione per Cercare`,
"电站管理/电站ID":   `ID della Stazione`,
"电站管理/请输入电站ID":   `Inserisci l'ID della Stazione`,
"电站管理/全部":   `Totale`,
"电站管理/投资方":   `Investitore`,
"电站管理/业主方":   `Proprietario`,
"电站管理/渠道方":   `Parte del Canale`,
"电站管理/请输入投资方单位名称":   `Inserisci il Nome dell'Unità Investitrice`,
"电站管理/请输入业主方单位名称":   `Inserisci il Nome dell'Unità Proprietaria`,
"电站管理/请输入渠道方单位名称（选填）":   `Inserisci la Parte del Canale (Opzionale)`,
"电站管理/电站状态":   `Stato`,
"电站管理/未投运":   `NC`,
"电站管理/已投运":   `In esecuzione`,
"电站管理/暂停运营":   `Sospeso`,
"电站管理/项目编码":   `Codice progetto`,
"电站管理/请输入项目编码":   `Inserisci codice progetto`,
"电站管理/搜索":   `Cerca`,
"电站管理/重置":   `Ripristina`,
"电站管理/新增电站":   `Nuova stazione`,
"电站管理/批量删除":   `Eliminazione multipla`,
"电站管理/导出电站效率":   `Scarica efficienza stazione`,
"电站管理/导出电站":   `Scarica lista stazioni`,
"电站管理/所属城市":   `Città`,
"电站管理/电表模式":   `Modalità contatore`,
"电站管理/实体":   `Entità`,
"电站管理/虚拟":   `Virtuale`,
"电站管理/策略控制":   `Controllo strategia`,
"电站管理/投运日期":   `Data operazione`,
"电站管理/额定功率/装机容量":   `Potenza nominale/Capacità installata`,
"电站管理/eLink数量":   `Numero eLink`,
"电站管理/eBlock数量":   `Numero eBlock`,
"电站管理/eBlock型号":   `Modello eBlock`,
"电站管理/创建日期":   `Data creazione`,
"电站管理/操作":   `Operazione`,
"电站管理/基本参数":   `Parametri`,
"电站管理/电站设备":   `Attrezzatura`,
"电站管理/电站拓扑":   `Topologia`,
"电站管理/维护记录":   `Registro manutenzione`,
"电站管理/删除":   `Elimina`,
"电站管理/项目简称":   `Abbreviazione nome progetto`,
"电站管理/省份":   `Provincia`,
"电站管理/电站详细地址":   `Indirizzo dettagliato stazione`,
"电站管理/安装企业":   `Compagnia installazione`,
"电站管理/框架合同":   `Contratto quadro`,
"电站管理/选填":   `Opzionale`,
"电站管理/运营模式":   `Modalità operazione`,
"电站管理/用电类别":   `Tipo elettricità`,
"电站管理/自运营模式":   `Auto-gestito`,
"电站管理/合同能源管理":   `Contratto gestione energia`,
"电站管理/大工业用电":   `Industria generale`,
"电站管理/一般工业用电":   `Industria su larga scala`,
"电站管理/电压等级":   `Livello di tensione`,
"电站管理/计费模式":   `Modalità di ricarica`,
"电站管理/未知":   `Sconosciuto`,
"电站管理/容量计费":   `Capacità`,
"电站管理/需量计费":   `Domanda`,
"电站管理/请输入关键字搜索地址":   `Inserisci parola chiave per cercare l'indirizzo`,
"电站管理/电站位置":   `Indirizzo della stazione`,
"电站管理/在地图中选择电站位置，可自动填充电站地址及经纬度信息":   `Scegli la posizione della stazione sulla mappa, poi completa automaticamente l'indirizzo, latitudine e longitudine`,
"电站管理/下一步":   `Avanti`,
"电站管理/投资方负责人":   `Nome del responsabile investitore`,
"电站管理/投资方负责人联系电话":   `Numero di telefono del responsabile investitore`,
"电站管理/请输入投资方负责人":   `Inserisci il nome del responsabile investitore`,
"电站管理/请输入投资方负责人联系电话":   `Inserisci il numero di telefono del responsabile investitore`,
"电站管理/业主方负责人":   `Nome del responsabile proprietario`,
"电站管理/业主方联系电话":   `Numero di telefono del responsabile proprietario`,
"电站管理/请输入业主方负责人":   `Inserisci il nome del responsabile proprietario`,
"电站管理/请输入业主方联系电话":   `Inserisci il numero di telefono del responsabile proprietario`,
"电站管理/电站显示优先级":   `Priorità nella visualizzazione della stazione`,
"电站管理/电价模式":   `Modalità tariffaria`,
"电站管理/尖峰平谷模式":   `Modello di prezzo picco-pianura-valle`,
"电站管理/时段电价模式":   `Modalità di prezzo per fasce orarie`,
"电站管理/电站图片":   `Foto della stazione`,
"电站管理/上传":   `Carica`,
"电站管理/只能上传jpg/png文件，且不超过500kb":   `Solo jpg/png disponibili, dimensione inferiore a 500kb`,
"电站管理/页面切换时间":   `Tempo di cambio pagina`,
"电站管理/光伏接入":   `Include fotovoltaico`,
"电站管理/第三方API接入情况":   `Accesso API di terze parti`,
"电站管理/编辑设备信息":   `Modifica informazioni attrezzatura`,
"电站管理/返回":   `Indietro`,
"电站管理/完成":   `Fine`,
"电站管理/注意：这里只是记录一下有没有第三方接入，以及第三方接入信息，和电站实际运行没有任何关联":   `Nota: Qui solo per registrare informazioni di accesso di terze parti, nulla a che fare con il funzionamento della stazione`,
"电站管理/开启时策略由系统控制，关闭时由客户控制":   `Inizia la strategia di controllo dal sistema, ferma la strategia di controllo dal cliente`,
"电站管理/电站列表中电站的显示顺序，数字越大，优先级越高，显示越靠前":   `Ordine di visualizzazione nella lista delle stazioni, più alto è il numero, maggiore è la priorità e la visualizzazione`,
'电站管理/开启时，数据可视化页面、站级监控页面显示光伏相关数据': `Inizia a visualizzare i dati fotovoltaici nella pagina "Visualizzazione dati" e "Monitoraggio stazione"`,
"电站管理/数据可视化页面自动切换时间，0时不自动切换，最大可设置120s":   `Tempo di cambio automatico della pagina di visualizzazione dati. 0 per disattivare il cambio automatico, valore massimo: 120s`,
"电站管理/装机功率":   `Potenza installata`,
"电站管理/装机容量":   `Capacità installata`,
"电站管理/方阵":   `Matrice`,
"电站管理/变压器容量":   `Capacità del trasformatore`,
"电站管理/关口电表名称":   `Nome del contatore PCC`,
"电站管理/关口电表UUID":   `UUID del contatore PCC`,
"电站管理/能量链UUID":   `UUID eLink`,
"电站管理/设备ID":   `ID apparecchiatura`,
"电站管理/能量链型号":   `Modello eLink`,
"电站管理/并网点电表名称":   `Nome del contatore GCP`,
"电站管理/并网点电表UUID":   `UUID del contatore GCP`,
"电站管理/序号":   `Indice`,
"电站管理/导出配置":   `Scarica configurazione`,
"电站管理/编辑":   `Modifica`,
"电站管理/填加eBlock":   `Nuovo eBlock`,
"电站管理/填加eLink":   `Nuovo eLink`,
"电站管理/填加方阵":   `Nuova matrice`,
"电站管理/填加/编辑方阵":   `Aggiungi/Modifica matrice`,
"电站管理/方阵名称":   `Nome matrice`,
"电站管理/安装位置":   `Indirizzo installazione`,
"电站管理/请输入安装位置文字描述":   `Inserisci descrizione indirizzo installazione`,
"电站管理/电表型号":   `Modello contatore`,
"电站管理/请输入电表型号":   `Inserisci modello contatore`,
"电站管理/电表变比":   `Rapporto trasformazione contatore`,
"电站管理/请输入电表变比":   `Inserisci rapporto trasformazione contatore`,
"电站管理/取消":   `Annulla`,
"电站管理/确定":   `Conferma`,
"电站管理/能量链名称":   `Nome eLink`,
"电站管理/设备网络ID":   `ID rete apparecchiatura`,
"电站管理/请输入设备网络ID":   `Inserisci ID rete apparecchiatura`,
"电站管理/计量点传输距离（米）":   `Distanza trasmissione punto misura (unità: metri)`,
"电站管理/电表":   `Contatore`,
"电站管理/撤销":   `Annulla`,
"电站管理/重做":   `Ripristina`,
"电站管理/清空当前画布":   `Pulisci canvas corrente`,
"电站管理/导入":   `Importa`,
"电站管理/隐藏属性":   `Nascondi attributo`,
"电站管理/显示属性":   `Mostra attributo`,
"电站管理/保存":   `Salva`,
"电站管理/导出JSON":   `Scarica JSON`,
"电站管理/属性":   `Attributo`,
"电站管理/背景颜色":   `Colore sfondo`,
"电站管理/清空":   `Pulisci`,
"电站管理/全局文字颜色":   `Colore testo globale`,
"电站管理/显示网格":   `Griglia di Visualizzazione`,
"电站管理/应用背景样式":   `Applica Stile di Sfondo`,
"电站管理/快捷键提示":   `Tasto di Scorciatoia`,
"电站管理/复制":   `Copia`,
"电站管理/粘贴":   `Incolla`,
"电站管理/删除元素":   `Elimina Elemento`,
"电站管理/按住鼠标右键平移画布":   `Tieni Premuto il Tasto Destro del Mouse per Muovere la Tela`,
"电站管理/按住滑动滚轮进行缩放":   `Tieni Premuto e Scorri per Zoomare`,
"电站管理/基础元件":   `Elemento Generico`,
"电站管理/文本":   `Testo`,
"电站管理/矩形":   `Rettangolo`,
"电站管理/圆形":   `Cerchio`,
"电站管理/电气元件":   `Elemento Elettrico`,
"电站管理/负载":   `Carico`,
"电站管理/能量块":   `eBlock`,
"电站管理/能量链":   `eLink`,
"电站管理/母线":   `Bus`,
"电站管理/变压器":   `Trasformatore`,
"电站管理/充电桩":   `Colonna di Ricarica`,
"电站管理/光伏":   `Fotovoltaico`,
"电站管理/储能系统":   `Sistema di Accumulo di Energia`,
"电站管理/断路器":   `Interruttore`,
"电站管理/接触器":   `Contattore`,
"电站管理/新增":   `Nuovo`,
"电站管理/维护时间":   `Tempo di Manutenzione`,
"电站管理/维护人":   `Operatore di Manutenzione`,
"电站管理/维护动作":   `Azione di Manutenzione`,
"电站管理/维护内容":   `Contenuto della Manutenzione`,
"电站管理/创建时间":   `Data di Creazione`,
"电站管理/暂无数据":   `Nessun Dato`,
"电站管理/配网信息":   `Informazioni della Rete di Distribuzione`,
"电站管理/设备SN":   `Numero Seriale dell'Attrezzatura`,
"电站管理/ap名称":   `Nome AP`,
"电站管理/ap密码":   `Password AP`,
"电站管理/路由SSID":   `SSID del Router`,
"电站管理/路由密码":   `Password del Router`,
"电站管理/设备IP":   `IP dell'Attrezzatura`,
"电站管理/设备顺序":   `Ordine dell'Attrezzatura`,
"电站管理/方阵顺序":   `Ordine della Matrice`,
"电站管理/业务模式":   `Modalità Operativa`,
"电站管理/非自投":   `Investimento non autonomo`,
"电站管理/自投":   `Investimento autonomo`,
"电站管理/状态":   `Stato`,
"电站管理/功率":   `Potenza`,
"电站管理/电压":   `Tensione`,
"电站管理/电流":   `Corrente`,
"电站管理/功率因数":   `Fattore di potenza`,
"电站管理/SOC":   `SOC`,
"电站管理/请选择日期范围":   `Seleziona intervallo di date`,
"电站管理/按月":   `Mese`,
"电站管理/按周":   `Settimana`,
"电站管理/开始月份":   `Mese iniziale`,
"电站管理/结束月份":   `Mese finale`,
"电站管理/选择周":   `Seleziona settimana`,
"电站管理/第":   `Settimana`,
"电站管理/周":   `16.`,
"电站管理/项目名称":   `Nome del progetto`,
"电站管理/秒":   `Secondo`,
"电站管理/其他参数":   `Altri parametri`,
"电站管理/文件过大":   `File troppo grande`,
"电站管理/请输入或从地图选择电站地址":   `Inserisci o seleziona l'indirizzo della stazione dalla mappa`,
"电站管理/请输入或在右侧地图上点选地址":   `Inserisci o clicca sulla mappa per selezionare l'indirizzo`,
"电站管理/请选择投运日期":   `Seleziona la data di operazione`,
"电站管理/对接方":   `Partner`,
"电站管理/对接协议":   `Protocollo del partner`,
"电站管理/硬件配置":   `Configurazione hardware`,
"电站管理/请输入对接方":   `Inserisci il partner`,
"电站管理/请选择对接协议":   `Seleziona il protocollo del partner`,
"电站管理/请输入硬件配置":   `Inserisci la configurazione hardware`,
"电站管理/电站其他参数":   `Altri parametri della stazione`,
"电站管理/电站编码不能有中划线":   `Il codice della stazione non può contenere trattini`,
"电站管理/请输入电站编码":   `Inserisci il codice della stazione`,
"电站管理/请选择电压等级":   `Seleziona il livello di tensione`,
"电站管理/请输入或从地图选择":   `Inserisci o seleziona dalla mappa`,
"电站管理/请在地图上选择经度":   `Seleziona la longitudine sulla mappa`,
"电站管理/请在地图上选择维度":   `Seleziona la latitudine sulla mappa`,
"电站管理/请输入额定功率":   `Inserisci la potenza nominale`,
"电站管理/只能输入数字":   `Solo numeri consentiti`,
"电站管理/请输入设计容量":   `Inserisci la capacità installata`,
"电站管理/请输入电站名称":   `Inserisci il nome della stazione`,
"电站管理/比如: 陕西省":   `Ad esempio: Provincia di Shaanxi`,
"电站管理/电站编码可以是电站名称首字母拼写，如SHUOBEIDE":   `Il codice della stazione può essere la prima lettera del nome della stazione, ad esempio: SHUOBEIDE`,
"电站管理/台":   `Unità`,
"电站管理/确定要导出所有电站吗?":   `Sei sicuro di voler scaricare tutte le stazioni?`,
"电站管理/确定要删除该电站吗？":   `Sei sicuro di voler eliminare questa stazione?`,
"电站管理/删除选中的电站后，这些电站信息将不可恢复":   `Dopo l'eliminazione delle stazioni selezionate, le informazioni non saranno recuperabili`,
"电站管理/确定要删除这些电站吗？":   `Sei sicuro di voler eliminare queste stazioni?`,
"电站管理/已删除":   `Eliminato`,
"电站管理/目前不支持在web端创建eBlock-100C方阵，请在APP中创建":   `La creazione dell'attrezzatura eBlock-100C sul web non è attualmente supportata, utilizza l'app`,
"电站管理/数量":   `Numero`,
"电站管理/确定要删除吗":   `Sei sicuro di voler eliminare?`,
"电站管理/变压器名称":   `Nome del trasformatore`,
"电站管理/新增变压器":   `Nuovo trasformatore`,
"电站管理/编辑变压器":   `Modifica trasformatore`,
"电站管理/请输入变压器名称":   `Inserisci il nome del trasformatore`,
"电站管理/请输入变压器容量":   `Inserisci la capacità del trasformatore`,
"电站管理/请输入变压器UUID":   `Inserisci l'UUID del trasformatore`,
"电站管理/添加":   `Aggiungi`,
"电站管理/型号":   `Modello`,
"电站管理/添加/编辑":   `Aggiungi/Modifica`,
"电站管理/请输入计量点传输距离":   `Inserisci la distanza di trasmissione del punto di misura`,
"电站管理/能量块数量":   `Numero eBlock`,
"电站管理/计量电表":   `Misuratore`,
"电站管理/计量电表名称":   `Nome del misuratore`,
"电站管理/请输入计量电表名称":   `Inserisci il nome del misuratore`,
"电站管理/请输入计量电表uuid":   `Inserisci l'UUID del misuratore`,
"电站管理/请输入计量电表设备ID":   `Inserisci l'ID dispositivo del misuratore`,
"电站管理/请输入电表SN码":   `Inserisci il numero di serie del misuratore`,
"电站管理/计量电表UUID":   `UUID del misuratore`,
"电站管理/计量电表设备ID":   `ID dispositivo del misuratore`,
"电站管理/电表SN码":   `Numero di serie del misuratore`,
"电站管理/添加计量电表":   `Aggiungi misuratore`,
"电站管理/请上传类似如下的照片":   `Carica una foto simile alla seguente`,
"电站管理/排序":   `Ordina`,
"电站管理/设备序列号":   `Numero di serie dell'attrezzatura`,
"电站管理/电表类型":   `Tipo di misuratore`,
"电站管理/请选择电表类型":   `Seleziona il tipo di misuratore`,
"电站管理/电表名称":   `Nome del misuratore`,
"电站管理/请输入电表名称":   `Inserisci il nome del misuratore`,
"电站管理/请输入UUID":   `Inserisci UUID`,
"电站管理/请输入设备序列号":   `Inserisci il numero di serie dell'attrezzatura`,
"电站管理/电表名称不能为空！":   `Il nome del contatore non può essere vuoto`,
"电站管理/UUID不能为空！":   `L'UUID non può essere vuoto`,
"电站管理/设备ID不能为空！":   `L'ID dell'attrezzatura non può essere vuoto`,
"电站管理/安装位置不能为空！":   `La posizione di installazione non può essere vuota`,
"电站管理/电表型号不能为空！":   `Il modello del contatore non può essere vuoto`,
"电站管理/电表变比不能为空！":   `Il rapporto di trasformazione del contatore non può essere vuoto`,
"电站管理/电表正面照片不能为空！":   `La foto frontale del contatore non può essere vuota`,
"电站管理/电表正面照片":   `Foto frontale del contatore`,
"电站管理/查看图片":   `Visualizza immagine`,
"电站管理/负载电表":   `Contatore di carico`,
"电站管理/关口电表":   `Contatore PCC`,
"电站管理/光伏电表":   `Contatore fotovoltaico`,
"电站管理/并网点电表":   `Contatore GCP`,
"电站管理/外部电表":   `Contatore esterno`,
"电站管理/新增外部电表":   `Nuovo contatore esterno`,
"电站管理/您输入的uuid":   `UUID inserito`,
"电站管理/已使用":   `Già utilizzato`,
"电站管理/您输入的devId":   `devId inserito`,
"电站管理/名称":   `Nome`,
"电站管理/容量":   `Capacità`,
"电站管理/请先添加eBlock":   `Aggiungi prima un eBlock`,
"电站管理/已保存设备信息":   `Le informazioni del dispositivo sono state salvate`,
"电站管理/上传头像图片大小不能超过 2MB!":   `La dimensione dell'immagine dell'avatar non può superare 2MB`,
"电站管理/提示":   `Avviso`,
"电站管理/请先输入或选择地址后再上传图片":   `Inserisci o seleziona prima un indirizzo`,
"电站管理/文件类型不支持":   `Tipo di file non supportato`,
"电站管理/已保存电站基本信息":   `Le informazioni di base della stazione sono state salvate`,
"电站管理/保存失败":   `Salvataggio fallito`,
"电站管理/自定义控制权限":   `Permessi di controllo personalizzati`,
"电站管理/设置电站的特定控制权限":   `Imposta i permessi di controllo specifici della stazione`,
"电站管理/防逆流":   `Anti-reflusso`,
"电站管理/箱变容量配比":   `Rapporto di capacità del trasformatore`,
"电站管理/无功工作模式":   `Modalità di lavoro della potenza reattiva`,
"电站管理/联系手机号 *":   `Telefono di contatto *`,
"电站管理/联系手机号":   `Telefono di contatto`,
"电站管理/请输入联系手机号":   `Inserisci il telefono di contatto`,
"电站管理/返回电站列表":   `Torna alla lista delle centrali elettriche`,
'电站管理/自动需量': `Richiesta automatica`,
'电站管理/开启时系统自动控制需量': `Controllo automatico delle esigenze del sistema all'accensione`,
"维护记录/维护记录":   `Registro di manutenzione`,
"维护记录/确定要删除本条维护记录吗?":   `Sei sicuro di voler eliminare questo registro di manutenzione?`,
"维护记录/返回":   `Indietro`,
"维护记录/新增运维记录":   `Nuovo Record di Manutenzione`,
"维护记录/维护时间":   `Ora di Manutenzione`,
"维护记录/维护人":   `Addetto alla Manutenzione`,
"维护记录/维护动作":   `Azione di Manutenzione`,
"维护记录/维护内容":   `Contenuto della Manutenzione`,
"维护记录/请输入维护人":   `Inserisci l'Addetto alla Manutenzione`,
"维护记录/请输入维护动作":   `Inserisci l'Azione di Manutenzione`,
"维护记录/请输入维护内容":   `Inserisci il Contenuto della Manutenzione`,
"维护记录/请输入维护时间":   `Inserisci l'Ora di Manutenzione`,
"维护记录/序号":   `Ordine`,
"维护记录/创建时间":   `Data di Creazione`,
"API白名单设置/请输入IP地址":   `Inserisci l'Indirizzo IP`,
"API白名单设置/组织":   `Organizzazione`,
"API白名单设置/请输入组织名称":   `Inserisci il Nome dell'Organizzazione`,
"API白名单设置/状态":   `Stato`,
"API白名单设置/正常":   `Normale`,
"API白名单设置/停用":   `Fermo`,
"API白名单设置/请选择":   `Seleziona`,
"API白名单设置/组织名称":   `Nome dell'Organizzazione`,
"API白名单设置/协议":   `Protocollo`,
"API白名单设置/用户名":   `Nome Utente`,
"API白名单设置/创建人":   `Creatore`,
"API白名单设置/更新时间":   `Data di Aggiornamento`,
"API白名单设置/备注信息":   `Nota`,
"API白名单设置/新增/编辑白名单":   `Aggiungi/Modifica Lista Bianca`,
"API白名单设置/IP地址不能为空":   `L'Indirizzo IP non può essere vuoto`,
"API白名单设置/请输入正确的IP地址":   `Inserisci un Indirizzo IP corretto`,
"API白名单设置/用户名不能为空":   `Il Nome Utente non può essere vuoto`,
"API白名单设置/组织名称不能为空":   `Il Nome dell'Organizzazione non può essere vuoto`,
"API白名单设置/正在保存中":   `Salvataggio in corso...`,
"API白名单设置/删除成功":   `Eliminazione riuscita`,
"API白名单设置/添加成功":   `Aggiunta riuscita`,
"API白名单设置/修改成功":   `Aggiornamento riuscito`,
"API白名单设置/确定要删除吗?":   `Sei sicuro di voler eliminare?`,
"API白名单设置/请输入用户名":   `Inserisci il Nome Utente`,
"eLink查询/电站名称":   `Nome della Stazione`,
"eLink查询/搜索":   `Cerca`,
"eLink查询/重置":   `Reimposta`,
"eLink查询/能量链名称":   `Nome eLink`,
"eLink查询/产品型号":   `Modello di Prodotto`,
"设备升级/新增标签":   `Nuova Etichetta`,
"设备升级/标签":   `Etichetta`,
"设备升级/关联电站":   `Stazione Associata`,
"设备升级/备注":   `Nota`,
"设备升级/创建者":   `Creatore`,
"设备升级/创建日期":   `Data di Creazione`,
"设备升级/操作":   `Operazione`,
"设备升级/编辑":   `Modifica`,
"设备升级/删除":   `Elimina`,
"设备升级/编辑标签":   `Modifica Etichetta`,
"设备升级/标签名称":   `Nome Etichetta`,
"设备升级/全选":   `Seleziona Tutto`,
"设备升级/搜索电站":   `Cerca Stazione`,
"设备升级/取消":   `Annulla`,
"设备升级/确定":   `Conferma`,
"设备升级/请输入标签名称":   `Inserisci il Nome dell'Etichetta`,
"设备升级/请至少选择一个电站":   `Seleziona Almeno Una Stazione`,
"设备升级/标签管理":   `Gestione Etichette`,
"设备升级/固件升级":   `Aggiornamento Firmware`,
"设备升级/设备升级":   `Aggiornamento Attrezzatura`,
"设备升级/版本信息":   `Informazioni Versione`,
"设备升级/新增升级包":   `Nuovo Pacchetto di Aggiornamento`,
"设备升级/文件名称":   `Nome File`,
"设备升级/文件类型":   `Tipo File`,
"设备升级/文件大小":   `Dimensione File`,
"设备升级/上传时间":   `Ora di Caricamento`,
"设备升级/下载":   `Scarica`,
"设备升级/上传升级包":   `Carica Pacchetto di Aggiornamento`,
"设备升级/选择标签":   `Seleziona Etichetta`,
"设备升级/请选择":   `Seleziona`,
"设备升级/请选择文件类型":   `Seleziona Tipo File`,
"设备升级/文件上传":   `Carica File`,
"设备升级/拖拽到次或点击上传":   `Trascina Qui o Premi Carica`,
"设备升级/请选择文件，最大不超过50Mb":   `Seleziona File, Dimensione Inferiore a 500Mb`,
"设备升级/升级":   `Aggiorna`,
"设备升级/升级历史":   `Cronologia Aggiornamenti`,
"设备升级/状态":   `Stato`,
"设备升级/全部":   `Totale`,
"设备升级/电站":   `Stazione`,
"设备升级/升级类型":   `Aggiorna Dispositivo`,
"设备升级/开始升级时间":   `Ora Inizio Aggiornamento`,
"设备升级/进度":   `Progresso`,
"设备升级/用时":   `Durata`,
"设备升级/升级结果":   `Risultato Aggiornamento`,
"设备升级/升级成功":   `Aggiornamento Riuscito`,
"设备升级/升级版本和运行版本相同":   `Versione Corrente e di Aggiornamento Uguali`,
"设备升级/升级失败":   `Aggiornamento Fallito`,
"设备升级/升级失败设备序号":   `Indice Dispositivo Aggiornamento Fallito`,
"设备升级/选择电站":   `Seleziona Stazione`,
"设备升级/表格视图":   `Vista Tabella`,
"设备升级/树形视图":   `Vista Albero`,
"设备升级/eLink版本信息":   `Informazioni Versione eLink`,
"设备升级/序列号":   `Numero Seriale`,
"设备升级/创建时间":   `Data Creazione`,
"设备升级/确认删除":   `Conferma Eliminazione`,
"设备升级/添加":   `Aggiungi`,
"设备升级/创建成功":   `Creazione Riuscita`,
"设备升级/编辑成功":   `Modifica Riuscita`,
"设备升级/拖拽到此或":   `Trascina Qui o`,
"设备升级/点击上传":   `Clicca per Caricare`,
"设备升级/请选择文件":   `Seleziona File`,
"设备升级/最大不超过":   `Dimensione Massima: 50Mb`,
"设备升级/请先选择标签":   `Seleziona Etichetta`,
"设备升级/请先上传文件":   `Carica File`,
"设备升级/请先选择文件类型":   `Seleziona Tipo File`,
"设备升级/上传成功":   `Caricamento Riuscito`,
"设备升级/文件太大，请选择小于50Mb的文件":   `File Troppo Grande, Seleziona File Inferiore a 50Mb`,
"设备升级/文件格式不正确":   `Formato File Non Corretto`,
"设备升级/确认要删除吗":   `Sei Sicuro di Voler Eliminare`,
"设备升级/成功":   `Successo`,
"设备升级/文件名":   `Nome File`,
"设备升级/私钥文件":   `File Chiave Privata`,
"设备升级/无响应时可手动结束":   `Se Nessuna Risposta, Puoi Terminare Manualmente`,
"设备升级/请输入结束原因":   `Inserisci Motivo Terminazione`,
"设备升级/选择升级包":   `Seleziona Pacchetto Aggiornamento`,
"设备升级/请选择电站":   `Seleziona Stazione`,
"设备升级/选择eLink":   `Seleziona eLink`,
"设备升级/请选择eLink":   `Seleziona eLink`,
"设备升级/开始升级":   `Avvia Aggiornamento`,
"设备升级/结束":   `Fine`,
"设备升级/文件":   `File`,
"设备升级/升级命令已下发":   `Comando di aggiornamento inviato`,
"设备升级/请选择私钥文件":   `Seleziona il file della chiave privata`,
"设备升级/提示":   `Prompt`,
"设备升级/选填":   `Opzionale`,
"设备升级/电站ID":   `ID Stazione`,
"设备升级/电站名称":   `Nome Stazione`,
"设备升级/eBlock版本信息":   `Informazioni versione eBlock`,
"设备升级/返回":   `Indietro`,
"设备升级/版本详情":   `Dettagli versione`,
"设备升级/记录时间":   `Ora registrazione`,
"设备升级/时间范围":   `Intervallo temporale`,
"设备升级/搜索":   `Cerca`,
"设备升级/重置":   `Ripristina`,
"设备升级/版本号":   `versione`,
"设备升级/更新时间":   `Ora aggiornamento`,
"设备升级/序号":   `Ordine`,
"设备升级/名称":   `Nome`,
"数据可视化/数据可视化":   `Visualizzazione`,
"数据可视化/电站拓扑":   `Topologia`,
"数据可视化/智慧储能电站管理平台":   `Sistema Intelligente di Gestione dell'Accumulo di Energia`,
"数据可视化/综合运维":   `Operazione`,
"数据可视化/视频监控":   `Monitoraggio video`,
"数据可视化/全国":   `Nazionale`,
"数据可视化/广东省":   `Provincia di Guangdong`,
"数据可视化/浙江省":   `Provincia di Zhejiang`,
"数据可视化/电站规模":   `Scala della stazione`,
"数据可视化/安全运行天数":   `Giorni di funzionamento sicuro`,
"数据可视化/天":   `Giorni`,
"数据可视化/累计装机容量":   `Capacità installata accumulata`,
"数据可视化/累计装机功率":   `Potenza installata accumulata`,
"数据可视化/电站个数":   `Numero di stazioni`,
"数据可视化/能量链数量":   `Numero di eLink`,
"数据可视化/能量块数量":   `Numero di eBlock`,
"数据可视化/储能分析":   `Analisi accumulo energia`,
"数据可视化/充电":   `Carica`,
"数据可视化/放电":   `Scarica`,
"数据可视化/累计总充电量(不含今日)":   `Energia di carica accumulata (escluso oggi)`,
"数据可视化/累计总放电量(不含今日)":   `Energia di scarica accumulata (escluso oggi)`,
"数据可视化/节能减排":   `Risparmio energetico e riduzione delle emissioni`,
"数据可视化/CO2减排量":   `Riduzione delle emissioni di CO2`,
"数据可视化/节约标准煤":   `Risparmio di carbone standard`,
"数据可视化/减少森林砍伐":   `Riduzione della deforestazione`,
"数据可视化/收益分析":   `Analisi dei guadagni`,
"数据可视化/所辖电站近12月收益(万元)":   `Guadagni di tutte le stazioni nell'ultimo anno (in decine di migliaia di yuan)`,
"数据可视化/所辖电站累计收益":   `Guadagni accumulati di tutte le stazioni`,
"数据可视化/电站系统效率TOP10":   `TOP10 efficienza del sistema delle stazioni`,
"数据可视化/排名":   `Classifica`,
"数据可视化/电站":   `Stazione`,
"数据可视化/累计充电量":   `Ricarica`,
"数据可视化/累计放电量":   `Scarica`,
"数据可视化/系统效率(%)":   `Efficienza (%)`,
"数据可视化/各省电站收益率":   `Irradiazione nelle province`,
"数据可视化/运行评价":   `Valutazione operativa`,
"数据可视化/优级":   `Eccellente`,
"数据可视化/良级":   `Medio`,
"数据可视化/中级":   `Buono`,
"数据可视化/合格":   `Qualificato`,
"数据可视化/不合格":   `Non qualificato`,
"数据可视化/统计信息":   `Informazioni statistiche`,
"数据可视化/当日放电量":   `Energia giornaliera di scarica`,
"数据可视化/当日充电量":   `Energia giornaliera di ricarica`,
"数据可视化/母线":   `Autobus`,
"数据可视化/方阵":   `Matrice`,
"数据可视化/关口电表":   `Contatore PCC`,
"数据可视化/功率":   `Potenza`,
"数据可视化/电压":   `Tensione`,
"数据可视化/电流":   `Corrente`,
"数据可视化/负载":   `Carico`,
"数据可视化/并网点电表":   `Contatore allacciato alla rete`,
"数据可视化/状态":   `Stato`,
"数据可视化/直流功率":   `Potenza in corrente continua`,
"数据可视化/直流电压":   `Tensione in corrente continua`,
"数据可视化/直流电流":   `Corrente continua`,
"数据可视化/电站运行信息":   `Informazioni operative della stazione`,
"数据可视化/电站评价结果":   `Valutazione della stazione`,
"数据可视化/装机容量":   `Capacità installata`,
"数据可视化/装机功率":   `Potenza installata`,
"数据可视化/实时功率":   `Potenza in tempo reale`,
"数据可视化/可用电量":   `Energia Disponibile`,
"数据可视化/月累计收益":   `Guadagno Accumulato Mensile`,
"数据可视化/电池簇分析":   `Analisi del Cluster di Batterie`,
"数据可视化/温度":   `Temperatura`,
"数据可视化/位置":   `Posizione`,
"数据可视化/最高单体电压":   `Tensione Massima della Cella`,
"数据可视化/最低单体电压":   `Tensione Minima della Cella`,
"数据可视化/最大压差":   `Differenza di Tensione Massima`,
"数据可视化/最高电压位置编号":   `Indice della Tensione Massima della Cella`,
"数据可视化/最低电压位置编号":   `Indice della Tensione Minima della Cella`,
"数据可视化/最高单体温度":   `Temperatura Massima della Cella`,
"数据可视化/最低单体温度":   `Temperatura Minima della Cella`,
"数据可视化/最大温差":   `Differenza di Temperatura Massima`,
"数据可视化/最高温度位置编号":   `Indice della Temperatura Massima della Cella`,
"数据可视化/最低温度位置编号":   `Indice della Temperatura Minima della Cella`,
"数据可视化/功率曲线":   `Curva di Potenza`,
"数据可视化/运行信息":   `Informazioni di Funzionamento`,
"数据可视化/实时告警":   `Allarme in Tempo Reale`,
"数据可视化/紧急":   `Emergenza`,
"数据可视化/重要":   `Primario`,
"数据可视化/一般":   `Generale`,
"数据可视化/设备ID":   `ID dell'Attrezzatura`,
"数据可视化/设备类型":   `Modello dell'Attrezzatura`,
"数据可视化/告警名称":   `Nome dell'Allarme`,
"数据可视化/告警等级":   `Livello dell'Allarme`,
"数据可视化/暂无告警数据":   `Nessun Dato di Allarme`,
"数据可视化/负荷跟踪":   `Monitoraggio del Carico`,
"数据可视化/并网点功率":   `Potenza PCC`,
"数据可视化/关口表功率":   `Potenza GCP`,
"数据可视化/负载功率":   `Potenza del Carico`,
"数据可视化/电站个数(个)":   `Numero di Stazioni`,
"数据可视化/能量链数量(个)":   `Numero di eLink`,
"数据可视化/能量块数量(个)":   `Numero di eBlock`,
"数据可视化/累计总充电量（不含今日）":   `Energia di Ricarica Accumulata (Escluso Oggi)`,
"数据可视化/累计总放电量（不含今日）":   `Energia di Scarica Accumulata (Escluso Oggi)`,
"数据可视化/充放电量":   `Energia`,
"数据可视化/月":   `Mese`,
"数据可视化/万元":   `Mila Euro`,
"数据可视化/收益率":   `IRR`,
"数据可视化/月累计收益(元)":   `Guadagno Accumulato Mensile (Yuan)`,
"数据可视化/SOC - 功率曲线":   `SOC - Curva di Potenza`,
"数据可视化/eBlock运行信息":   `Informazioni di Funzionamento eBlock`,
"登录/eMind智慧储能电站管理平台":   `eMind Sistema Intelligente di Gestione dell'Accumulo di Energia`,
"登录/用户名密码登录":   `Accedi con Numero di Conto e Password`,
"登录/手机号验证登录":   `Accedi con Numero di Telefono`,
"登录/账号":   `Numero di Conto`,
"登录/请输入您的账号":   `Inserisci il Tuo Numero di Conto`,
"登录/请输入您的密码":   `Inserisci la Tua Password`,
"登录/验证码":   `Codice di Verifica`,
"登录/请输入验证码":   `Inserisci il Tuo Codice di Verifica`,
"登录/记住密码":   `Ricorda Password`,
"登录/手机号":   `Numero di Telefono`,
"登录/请输入正确的手机号":   `Inserisci un Numero di Telefono Corretto`,
"登录/获取验证码":   `Ottieni Codice di Verifica`,
"登录/登录":   `Accedi`,
"登录/密码":   `Password`,
"登录/网站备案/许可证号":   `Registrazione Sito/Numero di Licenza`,
"登录/奇点能源":   `JD Energy`,
"登录/登录中":   `Accesso in Corso`,
"登录/验证码已发送，五分钟后失效":   `Il Codice di Verifica è stato inviato, Scade in 5 Minuti`,
"登录/重发":   `Reinvia`,
"登录/确定注销并退出系统吗":   `Sei Sicuro di Voler Uscire dal Sistema?`,

/* 设备模型 */
'设备型号/请输入设备型号': 'Inserisci il Modello dell\'Apparecchiatura',
'设备型号/请输入数据源': 'Inserisci l\'Origine dei Dati',
'设备型号/请输入数据表': 'Inserisci il Nome della Tabella',
'设备型号/请输入版本号': 'Inserisci la Versione',
'设备型号/修改点表': 'Modifica Tabella Punti',

'设备型号/设备型号': 'Modello dell\'Apparecchiatura',
'设备型号/数据源': 'Origine dei Dati',
'设备型号/数据表': 'Nome della Tabella',
'设备型号/版本号': 'Versione',
'设备型号/数据间隔': 'Intervallo dei Dati',
'设备型号/保存方式': 'Metodo di Salvataggio',
'设备型号/数据上传方式': 'Metodo di Upload dei Dati',
'设备型号/数据模板': 'Modello dei Dati',
'设备型号/操作成功': 'Operazione Riuscita',

'设备型号/编辑设备型号': 'Modifica Modello dell\'Apparecchiatura',
'设备型号/新增设备型号': 'Nuovo Modello dell\'Apparecchiatura',


'设备型号/数据地址位(10进制)': 'Indirizzo Dati (Decimale)',
'设备型号/子分类': 'Sottocategoria',
'设备型号/中文名': 'Nome Cinese',
'设备型号/英文key': 'Chiave Inglese',
'设备型号/单位': 'Unità',
'设备型号/数据类型': 'Tipo di Dati',
'设备型号/数据类别': 'Categoria di Dati',
'设备型号/默认值': 'Valore Predefinito',
'设备型号/最小值': 'Valore Minimo',
'设备型号/最大值': 'Valore Massimo',
'设备型号/比率': 'Rapporto',
'设备型号/偏移量': 'Offset',
'设备型号/排序': 'Ordine',
'设备型号/保存开关': 'Salvataggio',
'设备型号/是否展示': 'Mostrare',
'设备型号/字典': 'Dizionario',
'设备型号/备注': 'Nota',
'设备型号/遥测': 'Telemisura(YC)',
'设备型号/遥信': 'Telecontrollo(YX)',
'设备型号/保存': 'Salvare',
'设备型号/不保存': 'Non Salvare',
'设备型号/展示': 'Mostrare',
'设备型号/隐藏': 'Nascondi',
'设备型号/排序必须是整数': 'L\'Ordine Deve Essere un Intero',
'设备型号/请输入数据地址位(10进制)': 'Inserisci l\'Indirizzo Dati (Decimale)',
'设备型号/请输入子分类': 'Inserisci la Sottocategoria',
'设备型号/请输入中文名': 'Inserisci il Nome Cinese',
'设备型号/请输入英文key': 'Inserisci la Chiave Inglese',
'设备型号/请输入单位': 'Inserisci l\'Unità',
'设备型号/请输入数据类型': 'Inserisci il Tipo di Dati',
'设备型号/请输入数据类别': 'Inserisci la Categoria di Dati',
'设备型号/请输入默认值': 'Inserisci il Valore Predefinito',
'设备型号/请输入最小值': 'Inserisci il Valore Minimo',
'设备型号/请输入最大值': 'Inserisci il Valore Massimo',
'设备型号/请输入比率': 'Inserisci il Rapporto',
'设备型号/请输入偏移量': 'Inserisci l\'Offset',
'设备型号/编辑模型': 'Modifica Modello',
'设备型号/新增模型': 'Nuovo Modello',
'设备型号/值': 'Valore',
'设备型号/描述': 'Descrizione',
'设备型号/请输入值': 'Inserisci il Valore',
'设备型号/继续创建下一个': 'Continua a Creare il Prossimo',
'设备型号/勾选后不关闭弹框，基于现有数据继续创建下一个点表': 'Se Selezionato, Non Chiudere la Finestra, Continua a Creare il Prossimo Tabella Punti Basato sulle Informazioni Esistenti',
'设备型号/刷新缓存': 'Aggiorna Cache',
}
